{
  "baseline": [
    {
      "scenario_id": 1,
      "conflict_count": 63,
      "total_duration": 75.35,
      "activations": [
        {
          "id": "s0_a0",
          "scenario": 1,
          "activation_step": 1,
          "start_time": 0,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s0_a1",
          "scenario": 1,
          "activation_step": 2,
          "start_time": 0,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s0_a2",
          "scenario": 1,
          "activation_step": 3,
          "start_time": 0,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s0_a3",
          "scenario": 1,
          "activation_step": 4,
          "start_time": 0,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s0_a4",
          "scenario": 1,
          "activation_step": 5,
          "start_time": 2.59,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a12",
          "scenario": 1,
          "activation_step": 13,
          "start_time": 4.16,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s0_a11",
          "scenario": 1,
          "activation_step": 12,
          "start_time": 4.31,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s0_a10",
          "scenario": 1,
          "activation_step": 11,
          "start_time": 4.62,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s0_a9",
          "scenario": 1,
          "activation_step": 10,
          "start_time": 4.67,
          "duration": 0.94,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s0_a8",
          "scenario": 1,
          "activation_step": 9,
          "start_time": 5.14,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s0_a6",
          "scenario": 1,
          "activation_step": 7,
          "start_time": 5.28,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s0_a7",
          "scenario": 1,
          "activation_step": 8,
          "start_time": 5.34,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s0_a5",
          "scenario": 1,
          "activation_step": 6,
          "start_time": 5.57,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a13",
          "scenario": 1,
          "activation_step": 14,
          "start_time": 6.46,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a14",
          "scenario": 1,
          "activation_step": 15,
          "start_time": 8.51,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a16",
          "scenario": 1,
          "activation_step": 17,
          "start_time": 10.28,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s0_a15",
          "scenario": 1,
          "activation_step": 16,
          "start_time": 10.68,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a20",
          "scenario": 1,
          "activation_step": 21,
          "start_time": 11.9,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s0_a19",
          "scenario": 1,
          "activation_step": 20,
          "start_time": 12.18,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s0_a17",
          "scenario": 1,
          "activation_step": 18,
          "start_time": 12.38,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a18",
          "scenario": 1,
          "activation_step": 19,
          "start_time": 12.43,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s0_a22",
          "scenario": 1,
          "activation_step": 23,
          "start_time": 13.67,
          "duration": 0.92,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s0_a23",
          "scenario": 1,
          "activation_step": 24,
          "start_time": 13.7,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s0_a24",
          "scenario": 1,
          "activation_step": 25,
          "start_time": 13.76,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s0_a21",
          "scenario": 1,
          "activation_step": 22,
          "start_time": 14.01,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a28",
          "scenario": 1,
          "activation_step": 29,
          "start_time": 14.96,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s0_a27",
          "scenario": 1,
          "activation_step": 28,
          "start_time": 15.01,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s0_a29",
          "scenario": 1,
          "activation_step": 30,
          "start_time": 15.09,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s0_a26",
          "scenario": 1,
          "activation_step": 27,
          "start_time": 15.11,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s0_a25",
          "scenario": 1,
          "activation_step": 26,
          "start_time": 15.59,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a30",
          "scenario": 1,
          "activation_step": 31,
          "start_time": 17.28,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a31",
          "scenario": 1,
          "activation_step": 32,
          "start_time": 19.84,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a34",
          "scenario": 1,
          "activation_step": 35,
          "start_time": 22.24,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s0_a32",
          "scenario": 1,
          "activation_step": 33,
          "start_time": 22.52,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a33",
          "scenario": 1,
          "activation_step": 34,
          "start_time": 22.65,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s0_a36",
          "scenario": 1,
          "activation_step": 37,
          "start_time": 24.61,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s0_a35",
          "scenario": 1,
          "activation_step": 36,
          "start_time": 24.67,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a37",
          "scenario": 1,
          "activation_step": 38,
          "start_time": 27.57,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a41",
          "scenario": 1,
          "activation_step": 42,
          "start_time": 29.67,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s0_a40",
          "scenario": 1,
          "activation_step": 41,
          "start_time": 29.9,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s0_a39",
          "scenario": 1,
          "activation_step": 40,
          "start_time": 30.07,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s0_a38",
          "scenario": 1,
          "activation_step": 39,
          "start_time": 30.23,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a43",
          "scenario": 1,
          "activation_step": 44,
          "start_time": 31.04,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s0_a42",
          "scenario": 1,
          "activation_step": 43,
          "start_time": 31.48,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a44",
          "scenario": 1,
          "activation_step": 45,
          "start_time": 32.94,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a45",
          "scenario": 1,
          "activation_step": 46,
          "start_time": 34.5,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a46",
          "scenario": 1,
          "activation_step": 47,
          "start_time": 36.69,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a47",
          "scenario": 1,
          "activation_step": 48,
          "start_time": 36.78,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s0_a49",
          "scenario": 1,
          "activation_step": 50,
          "start_time": 38.51,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s0_a48",
          "scenario": 1,
          "activation_step": 49,
          "start_time": 38.63,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a51",
          "scenario": 1,
          "activation_step": 52,
          "start_time": 40.68,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s0_a52",
          "scenario": 1,
          "activation_step": 53,
          "start_time": 40.7,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s0_a50",
          "scenario": 1,
          "activation_step": 51,
          "start_time": 40.79,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a53",
          "scenario": 1,
          "activation_step": 54,
          "start_time": 43.23,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a54",
          "scenario": 1,
          "activation_step": 55,
          "start_time": 44.87,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a58",
          "scenario": 1,
          "activation_step": 59,
          "start_time": 45.74,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s0_a57",
          "scenario": 1,
          "activation_step": 58,
          "start_time": 46.01,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s0_a56",
          "scenario": 1,
          "activation_step": 57,
          "start_time": 46.47,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s0_a55",
          "scenario": 1,
          "activation_step": 56,
          "start_time": 46.8,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a59",
          "scenario": 1,
          "activation_step": 60,
          "start_time": 47.6,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a60",
          "scenario": 1,
          "activation_step": 61,
          "start_time": 49.36,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a61",
          "scenario": 1,
          "activation_step": 62,
          "start_time": 49.53,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s0_a62",
          "scenario": 1,
          "activation_step": 63,
          "start_time": 51.33,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a63",
          "scenario": 1,
          "activation_step": 64,
          "start_time": 53.07,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a64",
          "scenario": 1,
          "activation_step": 65,
          "start_time": 53.25,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s0_a71",
          "scenario": 1,
          "activation_step": 72,
          "start_time": 55.11,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s0_a68",
          "scenario": 1,
          "activation_step": 69,
          "start_time": 55.15,
          "duration": 0.94,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s0_a69",
          "scenario": 1,
          "activation_step": 70,
          "start_time": 55.27,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s0_a70",
          "scenario": 1,
          "activation_step": 71,
          "start_time": 55.28,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s0_a67",
          "scenario": 1,
          "activation_step": 68,
          "start_time": 55.48,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s0_a65",
          "scenario": 1,
          "activation_step": 66,
          "start_time": 55.75,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a66",
          "scenario": 1,
          "activation_step": 67,
          "start_time": 55.81,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s0_a77",
          "scenario": 1,
          "activation_step": 78,
          "start_time": 56.25,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s0_a78",
          "scenario": 1,
          "activation_step": 79,
          "start_time": 56.28,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s0_a76",
          "scenario": 1,
          "activation_step": 77,
          "start_time": 56.7,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s0_a72",
          "scenario": 1,
          "activation_step": 73,
          "start_time": 56.87,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a73",
          "scenario": 1,
          "activation_step": 74,
          "start_time": 56.87,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s0_a74",
          "scenario": 1,
          "activation_step": 75,
          "start_time": 56.95,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s0_a75",
          "scenario": 1,
          "activation_step": 76,
          "start_time": 57.09,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s0_a79",
          "scenario": 1,
          "activation_step": 80,
          "start_time": 58.23,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a86",
          "scenario": 1,
          "activation_step": 87,
          "start_time": 60.6,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s0_a82",
          "scenario": 1,
          "activation_step": 83,
          "start_time": 60.67,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s0_a84",
          "scenario": 1,
          "activation_step": 85,
          "start_time": 60.7,
          "duration": 1.2,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s0_a85",
          "scenario": 1,
          "activation_step": 86,
          "start_time": 60.72,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s0_a83",
          "scenario": 1,
          "activation_step": 84,
          "start_time": 60.81,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s0_a81",
          "scenario": 1,
          "activation_step": 82,
          "start_time": 60.87,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s0_a80",
          "scenario": 1,
          "activation_step": 81,
          "start_time": 61.19,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a87",
          "scenario": 1,
          "activation_step": 88,
          "start_time": 63.39,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a88",
          "scenario": 1,
          "activation_step": 89,
          "start_time": 63.43,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s0_a89",
          "scenario": 1,
          "activation_step": 90,
          "start_time": 65.82,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a90",
          "scenario": 1,
          "activation_step": 91,
          "start_time": 68.3,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a91",
          "scenario": 1,
          "activation_step": 92,
          "start_time": 70.71,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a96",
          "scenario": 1,
          "activation_step": 97,
          "start_time": 70.9,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s0_a95",
          "scenario": 1,
          "activation_step": 96,
          "start_time": 71.36,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s0_a94",
          "scenario": 1,
          "activation_step": 95,
          "start_time": 71.58,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s0_a93",
          "scenario": 1,
          "activation_step": 94,
          "start_time": 71.79,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s0_a92",
          "scenario": 1,
          "activation_step": 93,
          "start_time": 72.24,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s0_a98",
          "scenario": 1,
          "activation_step": 99,
          "start_time": 72.97,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s0_a99",
          "scenario": 1,
          "activation_step": 100,
          "start_time": 73.03,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s0_a97",
          "scenario": 1,
          "activation_step": 98,
          "start_time": 73.35,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        }
      ]
    },
    {
      "scenario_id": 2,
      "conflict_count": 63,
      "total_duration": 74.44,
      "activations": [
        {
          "id": "s1_a0",
          "scenario": 2,
          "activation_step": 1,
          "start_time": 0.13,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s1_a1",
          "scenario": 2,
          "activation_step": 2,
          "start_time": 0.17,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s1_a2",
          "scenario": 2,
          "activation_step": 3,
          "start_time": 2.84,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a4",
          "scenario": 2,
          "activation_step": 5,
          "start_time": 2.86,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s1_a5",
          "scenario": 2,
          "activation_step": 6,
          "start_time": 2.89,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s1_a3",
          "scenario": 2,
          "activation_step": 4,
          "start_time": 3.0,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s1_a8",
          "scenario": 2,
          "activation_step": 9,
          "start_time": 4.8,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s1_a9",
          "scenario": 2,
          "activation_step": 10,
          "start_time": 4.97,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s1_a6",
          "scenario": 2,
          "activation_step": 7,
          "start_time": 5.04,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a7",
          "scenario": 2,
          "activation_step": 8,
          "start_time": 5.04,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s1_a11",
          "scenario": 2,
          "activation_step": 12,
          "start_time": 6.4,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s1_a10",
          "scenario": 2,
          "activation_step": 11,
          "start_time": 6.76,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a13",
          "scenario": 2,
          "activation_step": 14,
          "start_time": 8.2,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s1_a12",
          "scenario": 2,
          "activation_step": 13,
          "start_time": 8.27,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a14",
          "scenario": 2,
          "activation_step": 15,
          "start_time": 10.06,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a18",
          "scenario": 2,
          "activation_step": 19,
          "start_time": 11.38,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s1_a19",
          "scenario": 2,
          "activation_step": 20,
          "start_time": 11.49,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s1_a17",
          "scenario": 2,
          "activation_step": 18,
          "start_time": 11.76,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s1_a15",
          "scenario": 2,
          "activation_step": 16,
          "start_time": 11.83,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a16",
          "scenario": 2,
          "activation_step": 17,
          "start_time": 11.9,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s1_a20",
          "scenario": 2,
          "activation_step": 21,
          "start_time": 14.32,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a24",
          "scenario": 2,
          "activation_step": 25,
          "start_time": 15.6,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s1_a23",
          "scenario": 2,
          "activation_step": 24,
          "start_time": 15.61,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s1_a25",
          "scenario": 2,
          "activation_step": 26,
          "start_time": 15.7,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s1_a22",
          "scenario": 2,
          "activation_step": 23,
          "start_time": 16.1,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s1_a21",
          "scenario": 2,
          "activation_step": 22,
          "start_time": 16.53,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a27",
          "scenario": 2,
          "activation_step": 28,
          "start_time": 18.25,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s1_a26",
          "scenario": 2,
          "activation_step": 27,
          "start_time": 18.3,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a29",
          "scenario": 2,
          "activation_step": 30,
          "start_time": 20.13,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s1_a28",
          "scenario": 2,
          "activation_step": 29,
          "start_time": 20.29,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a30",
          "scenario": 2,
          "activation_step": 31,
          "start_time": 22.54,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a34",
          "scenario": 2,
          "activation_step": 35,
          "start_time": 24.82,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s1_a33",
          "scenario": 2,
          "activation_step": 34,
          "start_time": 24.86,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s1_a31",
          "scenario": 2,
          "activation_step": 32,
          "start_time": 25.27,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a32",
          "scenario": 2,
          "activation_step": 33,
          "start_time": 25.35,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s1_a35",
          "scenario": 2,
          "activation_step": 36,
          "start_time": 27.37,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a36",
          "scenario": 2,
          "activation_step": 37,
          "start_time": 27.53,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s1_a39",
          "scenario": 2,
          "activation_step": 40,
          "start_time": 29.17,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s1_a38",
          "scenario": 2,
          "activation_step": 39,
          "start_time": 29.35,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s1_a37",
          "scenario": 2,
          "activation_step": 38,
          "start_time": 29.69,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a42",
          "scenario": 2,
          "activation_step": 43,
          "start_time": 30.49,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s1_a41",
          "scenario": 2,
          "activation_step": 42,
          "start_time": 30.75,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s1_a40",
          "scenario": 2,
          "activation_step": 41,
          "start_time": 31.06,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a43",
          "scenario": 2,
          "activation_step": 44,
          "start_time": 32.69,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a44",
          "scenario": 2,
          "activation_step": 45,
          "start_time": 32.69,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s1_a47",
          "scenario": 2,
          "activation_step": 48,
          "start_time": 35.29,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s1_a48",
          "scenario": 2,
          "activation_step": 49,
          "start_time": 35.4,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s1_a46",
          "scenario": 2,
          "activation_step": 47,
          "start_time": 35.56,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s1_a45",
          "scenario": 2,
          "activation_step": 46,
          "start_time": 35.63,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a51",
          "scenario": 2,
          "activation_step": 52,
          "start_time": 37.13,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s1_a50",
          "scenario": 2,
          "activation_step": 51,
          "start_time": 37.29,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s1_a49",
          "scenario": 2,
          "activation_step": 50,
          "start_time": 37.57,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a52",
          "scenario": 2,
          "activation_step": 53,
          "start_time": 38.71,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a53",
          "scenario": 2,
          "activation_step": 54,
          "start_time": 38.82,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s1_a54",
          "scenario": 2,
          "activation_step": 55,
          "start_time": 40.49,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a58",
          "scenario": 2,
          "activation_step": 59,
          "start_time": 42.69,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s1_a57",
          "scenario": 2,
          "activation_step": 58,
          "start_time": 43.15,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s1_a64",
          "scenario": 2,
          "activation_step": 65,
          "start_time": 43.3,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s1_a55",
          "scenario": 2,
          "activation_step": 56,
          "start_time": 43.38,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a56",
          "scenario": 2,
          "activation_step": 57,
          "start_time": 43.42,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s1_a63",
          "scenario": 2,
          "activation_step": 64,
          "start_time": 43.62,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s1_a62",
          "scenario": 2,
          "activation_step": 63,
          "start_time": 43.93,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s1_a61",
          "scenario": 2,
          "activation_step": 62,
          "start_time": 44.36,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s1_a60",
          "scenario": 2,
          "activation_step": 61,
          "start_time": 44.73,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s1_a59",
          "scenario": 2,
          "activation_step": 60,
          "start_time": 44.94,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a65",
          "scenario": 2,
          "activation_step": 66,
          "start_time": 45.01,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a67",
          "scenario": 2,
          "activation_step": 68,
          "start_time": 47.4,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s1_a66",
          "scenario": 2,
          "activation_step": 67,
          "start_time": 47.73,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a70",
          "scenario": 2,
          "activation_step": 71,
          "start_time": 48.72,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s1_a69",
          "scenario": 2,
          "activation_step": 70,
          "start_time": 49.01,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s1_a68",
          "scenario": 2,
          "activation_step": 69,
          "start_time": 49.32,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a71",
          "scenario": 2,
          "activation_step": 72,
          "start_time": 50.36,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a72",
          "scenario": 2,
          "activation_step": 73,
          "start_time": 52.06,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a73",
          "scenario": 2,
          "activation_step": 74,
          "start_time": 54.48,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a74",
          "scenario": 2,
          "activation_step": 75,
          "start_time": 57.09,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a75",
          "scenario": 2,
          "activation_step": 76,
          "start_time": 58.99,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a84",
          "scenario": 2,
          "activation_step": 85,
          "start_time": 59.98,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s1_a83",
          "scenario": 2,
          "activation_step": 84,
          "start_time": 60.45,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s1_a77",
          "scenario": 2,
          "activation_step": 78,
          "start_time": 60.81,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s1_a79",
          "scenario": 2,
          "activation_step": 80,
          "start_time": 60.85,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s1_a82",
          "scenario": 2,
          "activation_step": 83,
          "start_time": 60.93,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s1_a78",
          "scenario": 2,
          "activation_step": 79,
          "start_time": 60.95,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s1_a80",
          "scenario": 2,
          "activation_step": 81,
          "start_time": 61.01,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s1_a81",
          "scenario": 2,
          "activation_step": 82,
          "start_time": 61.04,
          "duration": 0.94,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s1_a76",
          "scenario": 2,
          "activation_step": 77,
          "start_time": 61.16,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a86",
          "scenario": 2,
          "activation_step": 87,
          "start_time": 61.33,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s1_a87",
          "scenario": 2,
          "activation_step": 88,
          "start_time": 61.47,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s1_a85",
          "scenario": 2,
          "activation_step": 86,
          "start_time": 61.49,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a88",
          "scenario": 2,
          "activation_step": 89,
          "start_time": 63.66,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a91",
          "scenario": 2,
          "activation_step": 92,
          "start_time": 65.84,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s1_a90",
          "scenario": 2,
          "activation_step": 91,
          "start_time": 66.09,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s1_a89",
          "scenario": 2,
          "activation_step": 90,
          "start_time": 66.5,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a94",
          "scenario": 2,
          "activation_step": 95,
          "start_time": 67.83,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s1_a92",
          "scenario": 2,
          "activation_step": 93,
          "start_time": 67.98,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a93",
          "scenario": 2,
          "activation_step": 94,
          "start_time": 68.06,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s1_a96",
          "scenario": 2,
          "activation_step": 97,
          "start_time": 70.0,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s1_a98",
          "scenario": 2,
          "activation_step": 99,
          "start_time": 70.03,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s1_a97",
          "scenario": 2,
          "activation_step": 98,
          "start_time": 70.07,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s1_a95",
          "scenario": 2,
          "activation_step": 96,
          "start_time": 70.37,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s1_a99",
          "scenario": 2,
          "activation_step": 100,
          "start_time": 72.44,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        }
      ]
    },
    {
      "scenario_id": 3,
      "conflict_count": 63,
      "total_duration": 74.54,
      "activations": [
        {
          "id": "s2_a9",
          "scenario": 3,
          "activation_step": 10,
          "start_time": 0.09,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s2_a1",
          "scenario": 3,
          "activation_step": 2,
          "start_time": 0.1,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s2_a0",
          "scenario": 3,
          "activation_step": 1,
          "start_time": 0.13,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s2_a8",
          "scenario": 3,
          "activation_step": 9,
          "start_time": 0.59,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s2_a7",
          "scenario": 3,
          "activation_step": 8,
          "start_time": 0.85,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s2_a6",
          "scenario": 3,
          "activation_step": 7,
          "start_time": 1.19,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s2_a5",
          "scenario": 3,
          "activation_step": 6,
          "start_time": 1.38,
          "duration": 0.92,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s2_a4",
          "scenario": 3,
          "activation_step": 5,
          "start_time": 1.59,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s2_a3",
          "scenario": 3,
          "activation_step": 4,
          "start_time": 1.96,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s2_a12",
          "scenario": 3,
          "activation_step": 13,
          "start_time": 2.09,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s2_a2",
          "scenario": 3,
          "activation_step": 3,
          "start_time": 2.16,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a11",
          "scenario": 3,
          "activation_step": 12,
          "start_time": 2.25,
          "duration": 0.98,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s2_a10",
          "scenario": 3,
          "activation_step": 11,
          "start_time": 2.43,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a14",
          "scenario": 3,
          "activation_step": 15,
          "start_time": 3.54,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s2_a13",
          "scenario": 3,
          "activation_step": 14,
          "start_time": 3.78,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a19",
          "scenario": 3,
          "activation_step": 20,
          "start_time": 5.19,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s2_a18",
          "scenario": 3,
          "activation_step": 19,
          "start_time": 5.63,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s2_a17",
          "scenario": 3,
          "activation_step": 18,
          "start_time": 5.85,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s2_a16",
          "scenario": 3,
          "activation_step": 17,
          "start_time": 6.19,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s2_a15",
          "scenario": 3,
          "activation_step": 16,
          "start_time": 6.22,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a23",
          "scenario": 3,
          "activation_step": 24,
          "start_time": 7.01,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s2_a22",
          "scenario": 3,
          "activation_step": 23,
          "start_time": 7.27,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s2_a21",
          "scenario": 3,
          "activation_step": 22,
          "start_time": 7.69,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s2_a20",
          "scenario": 3,
          "activation_step": 21,
          "start_time": 7.78,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a24",
          "scenario": 3,
          "activation_step": 25,
          "start_time": 8.98,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a25",
          "scenario": 3,
          "activation_step": 26,
          "start_time": 10.52,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a27",
          "scenario": 3,
          "activation_step": 28,
          "start_time": 12.64,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s2_a26",
          "scenario": 3,
          "activation_step": 27,
          "start_time": 12.65,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a31",
          "scenario": 3,
          "activation_step": 32,
          "start_time": 14.5,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s2_a29",
          "scenario": 3,
          "activation_step": 30,
          "start_time": 14.8,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s2_a28",
          "scenario": 3,
          "activation_step": 29,
          "start_time": 14.84,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a30",
          "scenario": 3,
          "activation_step": 31,
          "start_time": 14.94,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s2_a35",
          "scenario": 3,
          "activation_step": 36,
          "start_time": 16.58,
          "duration": 0.94,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s2_a34",
          "scenario": 3,
          "activation_step": 35,
          "start_time": 17.0,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s2_a32",
          "scenario": 3,
          "activation_step": 33,
          "start_time": 17.31,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a33",
          "scenario": 3,
          "activation_step": 34,
          "start_time": 17.4,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s2_a37",
          "scenario": 3,
          "activation_step": 38,
          "start_time": 18.27,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s2_a36",
          "scenario": 3,
          "activation_step": 37,
          "start_time": 18.3,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a38",
          "scenario": 3,
          "activation_step": 39,
          "start_time": 18.35,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s2_a42",
          "scenario": 3,
          "activation_step": 43,
          "start_time": 19.07,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s2_a43",
          "scenario": 3,
          "activation_step": 44,
          "start_time": 19.23,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s2_a41",
          "scenario": 3,
          "activation_step": 42,
          "start_time": 19.5,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s2_a40",
          "scenario": 3,
          "activation_step": 41,
          "start_time": 19.51,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s2_a39",
          "scenario": 3,
          "activation_step": 40,
          "start_time": 19.99,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a47",
          "scenario": 3,
          "activation_step": 48,
          "start_time": 20.82,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s2_a46",
          "scenario": 3,
          "activation_step": 47,
          "start_time": 20.91,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s2_a48",
          "scenario": 3,
          "activation_step": 49,
          "start_time": 20.95,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s2_a45",
          "scenario": 3,
          "activation_step": 46,
          "start_time": 21.0,
          "duration": 0.94,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s2_a50",
          "scenario": 3,
          "activation_step": 51,
          "start_time": 21.07,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s2_a49",
          "scenario": 3,
          "activation_step": 50,
          "start_time": 21.08,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s2_a44",
          "scenario": 3,
          "activation_step": 45,
          "start_time": 21.23,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a51",
          "scenario": 3,
          "activation_step": 52,
          "start_time": 22.73,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a52",
          "scenario": 3,
          "activation_step": 53,
          "start_time": 22.89,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s2_a54",
          "scenario": 3,
          "activation_step": 55,
          "start_time": 24.65,
          "duration": 0.94,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s2_a53",
          "scenario": 3,
          "activation_step": 54,
          "start_time": 24.66,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a56",
          "scenario": 3,
          "activation_step": 57,
          "start_time": 26.91,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s2_a55",
          "scenario": 3,
          "activation_step": 56,
          "start_time": 27.31,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a57",
          "scenario": 3,
          "activation_step": 58,
          "start_time": 28.81,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a58",
          "scenario": 3,
          "activation_step": 59,
          "start_time": 30.87,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a62",
          "scenario": 3,
          "activation_step": 63,
          "start_time": 31.76,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s2_a63",
          "scenario": 3,
          "activation_step": 64,
          "start_time": 31.83,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s2_a61",
          "scenario": 3,
          "activation_step": 62,
          "start_time": 32.22,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s2_a59",
          "scenario": 3,
          "activation_step": 60,
          "start_time": 32.45,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a60",
          "scenario": 3,
          "activation_step": 61,
          "start_time": 32.46,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s2_a65",
          "scenario": 3,
          "activation_step": 66,
          "start_time": 34.18,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s2_a64",
          "scenario": 3,
          "activation_step": 65,
          "start_time": 34.55,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a66",
          "scenario": 3,
          "activation_step": 67,
          "start_time": 37.11,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a67",
          "scenario": 3,
          "activation_step": 68,
          "start_time": 37.31,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s2_a68",
          "scenario": 3,
          "activation_step": 69,
          "start_time": 39.54,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a69",
          "scenario": 3,
          "activation_step": 70,
          "start_time": 41.36,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a70",
          "scenario": 3,
          "activation_step": 71,
          "start_time": 44.09,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a72",
          "scenario": 3,
          "activation_step": 73,
          "start_time": 46.1,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s2_a71",
          "scenario": 3,
          "activation_step": 72,
          "start_time": 46.13,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a73",
          "scenario": 3,
          "activation_step": 74,
          "start_time": 47.78,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a74",
          "scenario": 3,
          "activation_step": 75,
          "start_time": 49.5,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a77",
          "scenario": 3,
          "activation_step": 78,
          "start_time": 51.54,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s2_a76",
          "scenario": 3,
          "activation_step": 77,
          "start_time": 51.86,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s2_a75",
          "scenario": 3,
          "activation_step": 76,
          "start_time": 52.14,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a78",
          "scenario": 3,
          "activation_step": 79,
          "start_time": 53.66,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a79",
          "scenario": 3,
          "activation_step": 80,
          "start_time": 56.39,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a80",
          "scenario": 3,
          "activation_step": 81,
          "start_time": 59.12,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a83",
          "scenario": 3,
          "activation_step": 84,
          "start_time": 61.37,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s2_a81",
          "scenario": 3,
          "activation_step": 82,
          "start_time": 61.48,
          "duration": 0.8,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a82",
          "scenario": 3,
          "activation_step": 83,
          "start_time": 61.51,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s2_a85",
          "scenario": 3,
          "activation_step": 86,
          "start_time": 64.01,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s2_a84",
          "scenario": 3,
          "activation_step": 85,
          "start_time": 64.12,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a86",
          "scenario": 3,
          "activation_step": 87,
          "start_time": 66.69,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a90",
          "scenario": 3,
          "activation_step": 91,
          "start_time": 66.77,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s2_a87",
          "scenario": 3,
          "activation_step": 88,
          "start_time": 66.81,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s2_a92",
          "scenario": 3,
          "activation_step": 93,
          "start_time": 66.82,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s2_a91",
          "scenario": 3,
          "activation_step": 92,
          "start_time": 66.94,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s2_a88",
          "scenario": 3,
          "activation_step": 89,
          "start_time": 66.96,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s2_a89",
          "scenario": 3,
          "activation_step": 90,
          "start_time": 66.98,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s2_a95",
          "scenario": 3,
          "activation_step": 96,
          "start_time": 68.31,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s2_a94",
          "scenario": 3,
          "activation_step": 95,
          "start_time": 68.52,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s2_a93",
          "scenario": 3,
          "activation_step": 94,
          "start_time": 68.88,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a98",
          "scenario": 3,
          "activation_step": 99,
          "start_time": 69.66,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s2_a96",
          "scenario": 3,
          "activation_step": 97,
          "start_time": 70.08,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s2_a97",
          "scenario": 3,
          "activation_step": 98,
          "start_time": 70.13,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s2_a99",
          "scenario": 3,
          "activation_step": 100,
          "start_time": 72.54,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        }
      ]
    },
    {
      "scenario_id": 4,
      "conflict_count": 66,
      "total_duration": 64.05,
      "activations": [
        {
          "id": "s3_a0",
          "scenario": 4,
          "activation_step": 1,
          "start_time": 0,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s3_a2",
          "scenario": 4,
          "activation_step": 3,
          "start_time": 1.74,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a1",
          "scenario": 4,
          "activation_step": 2,
          "start_time": 2.17,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a3",
          "scenario": 4,
          "activation_step": 4,
          "start_time": 3.78,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a4",
          "scenario": 4,
          "activation_step": 5,
          "start_time": 3.96,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s3_a8",
          "scenario": 4,
          "activation_step": 9,
          "start_time": 5.17,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a7",
          "scenario": 4,
          "activation_step": 8,
          "start_time": 5.54,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a6",
          "scenario": 4,
          "activation_step": 7,
          "start_time": 5.9,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s3_a5",
          "scenario": 4,
          "activation_step": 6,
          "start_time": 5.97,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a14",
          "scenario": 4,
          "activation_step": 15,
          "start_time": 7.23,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a10",
          "scenario": 4,
          "activation_step": 11,
          "start_time": 7.51,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s3_a13",
          "scenario": 4,
          "activation_step": 14,
          "start_time": 7.55,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s3_a11",
          "scenario": 4,
          "activation_step": 12,
          "start_time": 7.59,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a12",
          "scenario": 4,
          "activation_step": 13,
          "start_time": 7.65,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s3_a9",
          "scenario": 4,
          "activation_step": 10,
          "start_time": 7.96,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a16",
          "scenario": 4,
          "activation_step": 17,
          "start_time": 8.66,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a15",
          "scenario": 4,
          "activation_step": 16,
          "start_time": 8.9,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a17",
          "scenario": 4,
          "activation_step": 18,
          "start_time": 11.08,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a18",
          "scenario": 4,
          "activation_step": 19,
          "start_time": 13.83,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a19",
          "scenario": 4,
          "activation_step": 20,
          "start_time": 15.46,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a20",
          "scenario": 4,
          "activation_step": 21,
          "start_time": 15.49,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s3_a21",
          "scenario": 4,
          "activation_step": 22,
          "start_time": 15.69,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s3_a25",
          "scenario": 4,
          "activation_step": 26,
          "start_time": 16.62,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a24",
          "scenario": 4,
          "activation_step": 25,
          "start_time": 16.7,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s3_a23",
          "scenario": 4,
          "activation_step": 24,
          "start_time": 16.98,
          "duration": 0.98,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s3_a22",
          "scenario": 4,
          "activation_step": 23,
          "start_time": 17.45,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a26",
          "scenario": 4,
          "activation_step": 27,
          "start_time": 18.42,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a28",
          "scenario": 4,
          "activation_step": 29,
          "start_time": 20.08,
          "duration": 0.92,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s3_a27",
          "scenario": 4,
          "activation_step": 28,
          "start_time": 20.14,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a29",
          "scenario": 4,
          "activation_step": 30,
          "start_time": 22.41,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a30",
          "scenario": 4,
          "activation_step": 31,
          "start_time": 24.6,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a33",
          "scenario": 4,
          "activation_step": 34,
          "start_time": 26.56,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a32",
          "scenario": 4,
          "activation_step": 33,
          "start_time": 26.63,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a34",
          "scenario": 4,
          "activation_step": 35,
          "start_time": 26.73,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s3_a31",
          "scenario": 4,
          "activation_step": 32,
          "start_time": 26.81,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a36",
          "scenario": 4,
          "activation_step": 37,
          "start_time": 29.02,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s3_a35",
          "scenario": 4,
          "activation_step": 36,
          "start_time": 29.14,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a41",
          "scenario": 4,
          "activation_step": 42,
          "start_time": 30.69,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s3_a42",
          "scenario": 4,
          "activation_step": 43,
          "start_time": 30.86,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s3_a38",
          "scenario": 4,
          "activation_step": 39,
          "start_time": 30.99,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s3_a40",
          "scenario": 4,
          "activation_step": 41,
          "start_time": 31.14,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s3_a39",
          "scenario": 4,
          "activation_step": 40,
          "start_time": 31.15,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s3_a37",
          "scenario": 4,
          "activation_step": 38,
          "start_time": 31.27,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a44",
          "scenario": 4,
          "activation_step": 45,
          "start_time": 33.69,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s3_a43",
          "scenario": 4,
          "activation_step": 44,
          "start_time": 33.81,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a45",
          "scenario": 4,
          "activation_step": 46,
          "start_time": 35.75,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a46",
          "scenario": 4,
          "activation_step": 47,
          "start_time": 37.84,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a48",
          "scenario": 4,
          "activation_step": 49,
          "start_time": 40.2,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a47",
          "scenario": 4,
          "activation_step": 48,
          "start_time": 40.45,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a49",
          "scenario": 4,
          "activation_step": 50,
          "start_time": 42.13,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a51",
          "scenario": 4,
          "activation_step": 52,
          "start_time": 44.05,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s3_a50",
          "scenario": 4,
          "activation_step": 51,
          "start_time": 44.5,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a52",
          "scenario": 4,
          "activation_step": 53,
          "start_time": 45.91,
          "duration": 0.8,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a59",
          "scenario": 4,
          "activation_step": 60,
          "start_time": 46.8,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s3_a60",
          "scenario": 4,
          "activation_step": 61,
          "start_time": 46.86,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s3_a58",
          "scenario": 4,
          "activation_step": 59,
          "start_time": 47.02,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s3_a61",
          "scenario": 4,
          "activation_step": 62,
          "start_time": 47.02,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s3_a63",
          "scenario": 4,
          "activation_step": 64,
          "start_time": 47.05,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a62",
          "scenario": 4,
          "activation_step": 63,
          "start_time": 47.09,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s3_a72",
          "scenario": 4,
          "activation_step": 73,
          "start_time": 47.12,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s3_a57",
          "scenario": 4,
          "activation_step": 58,
          "start_time": 47.22,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s3_a71",
          "scenario": 4,
          "activation_step": 72,
          "start_time": 47.35,
          "duration": 1.2,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a69",
          "scenario": 4,
          "activation_step": 70,
          "start_time": 47.42,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s3_a70",
          "scenario": 4,
          "activation_step": 71,
          "start_time": 47.52,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a56",
          "scenario": 4,
          "activation_step": 57,
          "start_time": 47.57,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s3_a67",
          "scenario": 4,
          "activation_step": 68,
          "start_time": 47.62,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s3_a68",
          "scenario": 4,
          "activation_step": 69,
          "start_time": 47.67,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s3_a53",
          "scenario": 4,
          "activation_step": 54,
          "start_time": 47.87,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a54",
          "scenario": 4,
          "activation_step": 55,
          "start_time": 47.92,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s3_a66",
          "scenario": 4,
          "activation_step": 67,
          "start_time": 47.93,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s3_a55",
          "scenario": 4,
          "activation_step": 56,
          "start_time": 47.96,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a65",
          "scenario": 4,
          "activation_step": 66,
          "start_time": 48.24,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s3_a64",
          "scenario": 4,
          "activation_step": 65,
          "start_time": 48.61,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a73",
          "scenario": 4,
          "activation_step": 74,
          "start_time": 48.9,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a78",
          "scenario": 4,
          "activation_step": 79,
          "start_time": 50.89,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s3_a76",
          "scenario": 4,
          "activation_step": 77,
          "start_time": 50.99,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a77",
          "scenario": 4,
          "activation_step": 78,
          "start_time": 51.01,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s3_a74",
          "scenario": 4,
          "activation_step": 75,
          "start_time": 51.16,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a75",
          "scenario": 4,
          "activation_step": 76,
          "start_time": 51.18,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s3_a79",
          "scenario": 4,
          "activation_step": 80,
          "start_time": 53.26,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a82",
          "scenario": 4,
          "activation_step": 83,
          "start_time": 54.91,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s3_a80",
          "scenario": 4,
          "activation_step": 81,
          "start_time": 55.0,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a81",
          "scenario": 4,
          "activation_step": 82,
          "start_time": 55.15,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s3_a84",
          "scenario": 4,
          "activation_step": 85,
          "start_time": 56.05,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a83",
          "scenario": 4,
          "activation_step": 84,
          "start_time": 56.44,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a85",
          "scenario": 4,
          "activation_step": 86,
          "start_time": 57.64,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a95",
          "scenario": 4,
          "activation_step": 96,
          "start_time": 57.67,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a94",
          "scenario": 4,
          "activation_step": 95,
          "start_time": 57.87,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s3_a93",
          "scenario": 4,
          "activation_step": 94,
          "start_time": 58.18,
          "duration": 0.98,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a90",
          "scenario": 4,
          "activation_step": 91,
          "start_time": 58.24,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s3_a91",
          "scenario": 4,
          "activation_step": 92,
          "start_time": 58.3,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s3_a92",
          "scenario": 4,
          "activation_step": 93,
          "start_time": 58.33,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s3_a89",
          "scenario": 4,
          "activation_step": 90,
          "start_time": 58.61,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s3_a88",
          "scenario": 4,
          "activation_step": 89,
          "start_time": 58.87,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s3_a87",
          "scenario": 4,
          "activation_step": 88,
          "start_time": 59.27,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s3_a97",
          "scenario": 4,
          "activation_step": 98,
          "start_time": 59.43,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s3_a86",
          "scenario": 4,
          "activation_step": 87,
          "start_time": 59.55,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a96",
          "scenario": 4,
          "activation_step": 97,
          "start_time": 59.81,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a98",
          "scenario": 4,
          "activation_step": 99,
          "start_time": 61.89,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s3_a99",
          "scenario": 4,
          "activation_step": 100,
          "start_time": 62.05,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        }
      ]
    },
    {
      "scenario_id": 5,
      "conflict_count": 63,
      "total_duration": 75.99,
      "activations": [
        {
          "id": "s4_a0",
          "scenario": 5,
          "activation_step": 1,
          "start_time": 0,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s4_a1",
          "scenario": 5,
          "activation_step": 2,
          "start_time": 0,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s4_a2",
          "scenario": 5,
          "activation_step": 3,
          "start_time": 2.07,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a3",
          "scenario": 5,
          "activation_step": 4,
          "start_time": 4.35,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a4",
          "scenario": 5,
          "activation_step": 5,
          "start_time": 7.26,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a5",
          "scenario": 5,
          "activation_step": 6,
          "start_time": 9.78,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a10",
          "scenario": 5,
          "activation_step": 11,
          "start_time": 11.91,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s4_a8",
          "scenario": 5,
          "activation_step": 9,
          "start_time": 12.31,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s4_a9",
          "scenario": 5,
          "activation_step": 10,
          "start_time": 12.33,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s4_a6",
          "scenario": 5,
          "activation_step": 7,
          "start_time": 12.37,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a7",
          "scenario": 5,
          "activation_step": 8,
          "start_time": 12.48,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s4_a11",
          "scenario": 5,
          "activation_step": 12,
          "start_time": 14.43,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a12",
          "scenario": 5,
          "activation_step": 13,
          "start_time": 16.89,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a16",
          "scenario": 5,
          "activation_step": 17,
          "start_time": 18.76,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s4_a14",
          "scenario": 5,
          "activation_step": 15,
          "start_time": 19.08,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s4_a15",
          "scenario": 5,
          "activation_step": 16,
          "start_time": 19.13,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s4_a13",
          "scenario": 5,
          "activation_step": 14,
          "start_time": 19.35,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a17",
          "scenario": 5,
          "activation_step": 18,
          "start_time": 21.37,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a18",
          "scenario": 5,
          "activation_step": 19,
          "start_time": 23.46,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a19",
          "scenario": 5,
          "activation_step": 20,
          "start_time": 26.05,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a21",
          "scenario": 5,
          "activation_step": 22,
          "start_time": 27.43,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s4_a22",
          "scenario": 5,
          "activation_step": 23,
          "start_time": 27.49,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s4_a20",
          "scenario": 5,
          "activation_step": 21,
          "start_time": 27.6,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a25",
          "scenario": 5,
          "activation_step": 26,
          "start_time": 28.61,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s4_a26",
          "scenario": 5,
          "activation_step": 27,
          "start_time": 28.7,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s4_a24",
          "scenario": 5,
          "activation_step": 25,
          "start_time": 29.04,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s4_a23",
          "scenario": 5,
          "activation_step": 24,
          "start_time": 29.5,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a27",
          "scenario": 5,
          "activation_step": 28,
          "start_time": 31.25,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a29",
          "scenario": 5,
          "activation_step": 30,
          "start_time": 33.37,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s4_a28",
          "scenario": 5,
          "activation_step": 29,
          "start_time": 33.83,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a34",
          "scenario": 5,
          "activation_step": 35,
          "start_time": 34.91,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s4_a33",
          "scenario": 5,
          "activation_step": 34,
          "start_time": 35.32,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s4_a31",
          "scenario": 5,
          "activation_step": 32,
          "start_time": 35.76,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s4_a32",
          "scenario": 5,
          "activation_step": 33,
          "start_time": 35.76,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s4_a30",
          "scenario": 5,
          "activation_step": 31,
          "start_time": 35.97,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a39",
          "scenario": 5,
          "activation_step": 40,
          "start_time": 36.5,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s4_a38",
          "scenario": 5,
          "activation_step": 39,
          "start_time": 36.63,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s4_a40",
          "scenario": 5,
          "activation_step": 41,
          "start_time": 36.66,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s4_a36",
          "scenario": 5,
          "activation_step": 37,
          "start_time": 36.68,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s4_a37",
          "scenario": 5,
          "activation_step": 38,
          "start_time": 36.88,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s4_a35",
          "scenario": 5,
          "activation_step": 36,
          "start_time": 36.95,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a41",
          "scenario": 5,
          "activation_step": 42,
          "start_time": 39.45,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a42",
          "scenario": 5,
          "activation_step": 43,
          "start_time": 41.82,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a43",
          "scenario": 5,
          "activation_step": 44,
          "start_time": 43.51,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a46",
          "scenario": 5,
          "activation_step": 47,
          "start_time": 45.38,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s4_a45",
          "scenario": 5,
          "activation_step": 46,
          "start_time": 45.77,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s4_a58",
          "scenario": 5,
          "activation_step": 59,
          "start_time": 45.85,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s4_a44",
          "scenario": 5,
          "activation_step": 45,
          "start_time": 45.93,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a57",
          "scenario": 5,
          "activation_step": 58,
          "start_time": 46.01,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s4_a56",
          "scenario": 5,
          "activation_step": 57,
          "start_time": 46.25,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s4_a54",
          "scenario": 5,
          "activation_step": 55,
          "start_time": 46.39,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s4_a55",
          "scenario": 5,
          "activation_step": 56,
          "start_time": 46.56,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s4_a53",
          "scenario": 5,
          "activation_step": 54,
          "start_time": 46.86,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s4_a52",
          "scenario": 5,
          "activation_step": 53,
          "start_time": 47.11,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s4_a50",
          "scenario": 5,
          "activation_step": 51,
          "start_time": 47.13,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s4_a51",
          "scenario": 5,
          "activation_step": 52,
          "start_time": 47.19,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s4_a49",
          "scenario": 5,
          "activation_step": 50,
          "start_time": 47.46,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s4_a48",
          "scenario": 5,
          "activation_step": 49,
          "start_time": 47.79,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s4_a59",
          "scenario": 5,
          "activation_step": 60,
          "start_time": 47.79,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a47",
          "scenario": 5,
          "activation_step": 48,
          "start_time": 47.91,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a60",
          "scenario": 5,
          "activation_step": 61,
          "start_time": 49.64,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a61",
          "scenario": 5,
          "activation_step": 62,
          "start_time": 51.7,
          "duration": 0.8,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a63",
          "scenario": 5,
          "activation_step": 64,
          "start_time": 53.86,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s4_a62",
          "scenario": 5,
          "activation_step": 63,
          "start_time": 53.96,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a64",
          "scenario": 5,
          "activation_step": 65,
          "start_time": 53.96,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s4_a65",
          "scenario": 5,
          "activation_step": 66,
          "start_time": 53.96,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s4_a66",
          "scenario": 5,
          "activation_step": 67,
          "start_time": 54.1,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s4_a68",
          "scenario": 5,
          "activation_step": 69,
          "start_time": 55.85,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s4_a67",
          "scenario": 5,
          "activation_step": 68,
          "start_time": 56.0,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a70",
          "scenario": 5,
          "activation_step": 71,
          "start_time": 57.46,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s4_a69",
          "scenario": 5,
          "activation_step": 70,
          "start_time": 57.85,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a72",
          "scenario": 5,
          "activation_step": 73,
          "start_time": 59.54,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s4_a73",
          "scenario": 5,
          "activation_step": 74,
          "start_time": 59.57,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s4_a71",
          "scenario": 5,
          "activation_step": 72,
          "start_time": 59.74,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a77",
          "scenario": 5,
          "activation_step": 78,
          "start_time": 60.73,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s4_a76",
          "scenario": 5,
          "activation_step": 77,
          "start_time": 60.92,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s4_a75",
          "scenario": 5,
          "activation_step": 76,
          "start_time": 61.26,
          "duration": 1.2,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s4_a74",
          "scenario": 5,
          "activation_step": 75,
          "start_time": 61.74,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a80",
          "scenario": 5,
          "activation_step": 81,
          "start_time": 62.94,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s4_a78",
          "scenario": 5,
          "activation_step": 79,
          "start_time": 63.13,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a79",
          "scenario": 5,
          "activation_step": 80,
          "start_time": 63.15,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s4_a81",
          "scenario": 5,
          "activation_step": 82,
          "start_time": 64.66,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a87",
          "scenario": 5,
          "activation_step": 88,
          "start_time": 66.01,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s4_a86",
          "scenario": 5,
          "activation_step": 87,
          "start_time": 66.48,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s4_a84",
          "scenario": 5,
          "activation_step": 85,
          "start_time": 66.78,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s4_a85",
          "scenario": 5,
          "activation_step": 86,
          "start_time": 66.86,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s4_a82",
          "scenario": 5,
          "activation_step": 83,
          "start_time": 67.02,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a93",
          "scenario": 5,
          "activation_step": 94,
          "start_time": 67.04,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s4_a83",
          "scenario": 5,
          "activation_step": 84,
          "start_time": 67.13,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s4_a92",
          "scenario": 5,
          "activation_step": 93,
          "start_time": 67.45,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s4_a91",
          "scenario": 5,
          "activation_step": 92,
          "start_time": 67.73,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s4_a90",
          "scenario": 5,
          "activation_step": 91,
          "start_time": 67.93,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s4_a89",
          "scenario": 5,
          "activation_step": 90,
          "start_time": 67.99,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s4_a88",
          "scenario": 5,
          "activation_step": 89,
          "start_time": 68.4,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a94",
          "scenario": 5,
          "activation_step": 95,
          "start_time": 69.65,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a95",
          "scenario": 5,
          "activation_step": 96,
          "start_time": 72.02,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a96",
          "scenario": 5,
          "activation_step": 97,
          "start_time": 72.16,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s4_a97",
          "scenario": 5,
          "activation_step": 98,
          "start_time": 73.75,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s4_a98",
          "scenario": 5,
          "activation_step": 99,
          "start_time": 73.95,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s4_a99",
          "scenario": 5,
          "activation_step": 100,
          "start_time": 73.99,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        }
      ]
    },
    {
      "scenario_id": 6,
      "conflict_count": 63,
      "total_duration": 74.21,
      "activations": [
        {
          "id": "s5_a4",
          "scenario": 6,
          "activation_step": 5,
          "start_time": 1.5,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s5_a3",
          "scenario": 6,
          "activation_step": 4,
          "start_time": 1.85,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s5_a0",
          "scenario": 6,
          "activation_step": 1,
          "start_time": 2.0,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a1",
          "scenario": 6,
          "activation_step": 2,
          "start_time": 2.01,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s5_a2",
          "scenario": 6,
          "activation_step": 3,
          "start_time": 2.18,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s5_a5",
          "scenario": 6,
          "activation_step": 6,
          "start_time": 4.17,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a9",
          "scenario": 6,
          "activation_step": 10,
          "start_time": 5.8,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s5_a8",
          "scenario": 6,
          "activation_step": 9,
          "start_time": 6.08,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s5_a7",
          "scenario": 6,
          "activation_step": 8,
          "start_time": 6.34,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s5_a6",
          "scenario": 6,
          "activation_step": 7,
          "start_time": 6.83,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a12",
          "scenario": 6,
          "activation_step": 13,
          "start_time": 7.18,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s5_a11",
          "scenario": 6,
          "activation_step": 12,
          "start_time": 7.66,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s5_a10",
          "scenario": 6,
          "activation_step": 11,
          "start_time": 7.78,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a13",
          "scenario": 6,
          "activation_step": 14,
          "start_time": 10.02,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a22",
          "scenario": 6,
          "activation_step": 23,
          "start_time": 10.86,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s5_a21",
          "scenario": 6,
          "activation_step": 22,
          "start_time": 10.96,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s5_a19",
          "scenario": 6,
          "activation_step": 20,
          "start_time": 11.08,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s5_a20",
          "scenario": 6,
          "activation_step": 21,
          "start_time": 11.09,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s5_a16",
          "scenario": 6,
          "activation_step": 17,
          "start_time": 11.2,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s5_a15",
          "scenario": 6,
          "activation_step": 16,
          "start_time": 11.23,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s5_a17",
          "scenario": 6,
          "activation_step": 18,
          "start_time": 11.36,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s5_a18",
          "scenario": 6,
          "activation_step": 19,
          "start_time": 11.4,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s5_a14",
          "scenario": 6,
          "activation_step": 15,
          "start_time": 11.68,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a23",
          "scenario": 6,
          "activation_step": 24,
          "start_time": 12.81,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a27",
          "scenario": 6,
          "activation_step": 28,
          "start_time": 14.82,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s5_a26",
          "scenario": 6,
          "activation_step": 27,
          "start_time": 15.14,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s5_a24",
          "scenario": 6,
          "activation_step": 25,
          "start_time": 15.32,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a25",
          "scenario": 6,
          "activation_step": 26,
          "start_time": 15.32,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s5_a29",
          "scenario": 6,
          "activation_step": 30,
          "start_time": 17.05,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s5_a28",
          "scenario": 6,
          "activation_step": 29,
          "start_time": 17.31,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a33",
          "scenario": 6,
          "activation_step": 34,
          "start_time": 19.01,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s5_a32",
          "scenario": 6,
          "activation_step": 33,
          "start_time": 19.18,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s5_a31",
          "scenario": 6,
          "activation_step": 32,
          "start_time": 19.44,
          "duration": 0.98,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s5_a30",
          "scenario": 6,
          "activation_step": 31,
          "start_time": 19.83,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a36",
          "scenario": 6,
          "activation_step": 37,
          "start_time": 20.04,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s5_a35",
          "scenario": 6,
          "activation_step": 36,
          "start_time": 20.29,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s5_a34",
          "scenario": 6,
          "activation_step": 35,
          "start_time": 20.57,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a37",
          "scenario": 6,
          "activation_step": 38,
          "start_time": 22.86,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a38",
          "scenario": 6,
          "activation_step": 39,
          "start_time": 23.04,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s5_a41",
          "scenario": 6,
          "activation_step": 42,
          "start_time": 24.51,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s5_a40",
          "scenario": 6,
          "activation_step": 41,
          "start_time": 24.75,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s5_a39",
          "scenario": 6,
          "activation_step": 40,
          "start_time": 25.17,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a42",
          "scenario": 6,
          "activation_step": 43,
          "start_time": 27.41,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a43",
          "scenario": 6,
          "activation_step": 44,
          "start_time": 29.33,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a44",
          "scenario": 6,
          "activation_step": 45,
          "start_time": 30.95,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a49",
          "scenario": 6,
          "activation_step": 50,
          "start_time": 32.95,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s5_a48",
          "scenario": 6,
          "activation_step": 49,
          "start_time": 33.18,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s5_a47",
          "scenario": 6,
          "activation_step": 48,
          "start_time": 33.33,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s5_a45",
          "scenario": 6,
          "activation_step": 46,
          "start_time": 33.62,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a46",
          "scenario": 6,
          "activation_step": 47,
          "start_time": 33.78,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s5_a50",
          "scenario": 6,
          "activation_step": 51,
          "start_time": 34.47,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a53",
          "scenario": 6,
          "activation_step": 54,
          "start_time": 35.38,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s5_a52",
          "scenario": 6,
          "activation_step": 53,
          "start_time": 35.65,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s5_a51",
          "scenario": 6,
          "activation_step": 52,
          "start_time": 36.0,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a54",
          "scenario": 6,
          "activation_step": 55,
          "start_time": 38.0,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a55",
          "scenario": 6,
          "activation_step": 56,
          "start_time": 38.15,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s5_a56",
          "scenario": 6,
          "activation_step": 57,
          "start_time": 38.19,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s5_a57",
          "scenario": 6,
          "activation_step": 58,
          "start_time": 40.05,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a58",
          "scenario": 6,
          "activation_step": 59,
          "start_time": 42.6,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a60",
          "scenario": 6,
          "activation_step": 61,
          "start_time": 44.0,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s5_a59",
          "scenario": 6,
          "activation_step": 60,
          "start_time": 44.39,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a61",
          "scenario": 6,
          "activation_step": 62,
          "start_time": 46.42,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a62",
          "scenario": 6,
          "activation_step": 63,
          "start_time": 49.0,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a64",
          "scenario": 6,
          "activation_step": 65,
          "start_time": 50.53,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s5_a65",
          "scenario": 6,
          "activation_step": 66,
          "start_time": 50.66,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s5_a63",
          "scenario": 6,
          "activation_step": 64,
          "start_time": 50.73,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a66",
          "scenario": 6,
          "activation_step": 67,
          "start_time": 52.26,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a67",
          "scenario": 6,
          "activation_step": 68,
          "start_time": 54.37,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a73",
          "scenario": 6,
          "activation_step": 74,
          "start_time": 55.44,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s5_a70",
          "scenario": 6,
          "activation_step": 71,
          "start_time": 55.82,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s5_a71",
          "scenario": 6,
          "activation_step": 72,
          "start_time": 55.84,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s5_a72",
          "scenario": 6,
          "activation_step": 73,
          "start_time": 55.9,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s5_a69",
          "scenario": 6,
          "activation_step": 70,
          "start_time": 56.09,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s5_a68",
          "scenario": 6,
          "activation_step": 69,
          "start_time": 56.18,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a77",
          "scenario": 6,
          "activation_step": 78,
          "start_time": 57.17,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s5_a78",
          "scenario": 6,
          "activation_step": 79,
          "start_time": 57.28,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s5_a76",
          "scenario": 6,
          "activation_step": 77,
          "start_time": 57.35,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s5_a75",
          "scenario": 6,
          "activation_step": 76,
          "start_time": 57.81,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s5_a74",
          "scenario": 6,
          "activation_step": 75,
          "start_time": 58.0,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a79",
          "scenario": 6,
          "activation_step": 80,
          "start_time": 60.16,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a80",
          "scenario": 6,
          "activation_step": 81,
          "start_time": 62.83,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a81",
          "scenario": 6,
          "activation_step": 82,
          "start_time": 65.62,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a82",
          "scenario": 6,
          "activation_step": 83,
          "start_time": 65.72,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s5_a87",
          "scenario": 6,
          "activation_step": 88,
          "start_time": 67.7,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s5_a86",
          "scenario": 6,
          "activation_step": 87,
          "start_time": 67.85,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s5_a85",
          "scenario": 6,
          "activation_step": 86,
          "start_time": 67.96,
          "duration": 1.2,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s5_a83",
          "scenario": 6,
          "activation_step": 84,
          "start_time": 68.0,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a84",
          "scenario": 6,
          "activation_step": 85,
          "start_time": 68.03,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s5_a91",
          "scenario": 6,
          "activation_step": 92,
          "start_time": 68.83,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s5_a90",
          "scenario": 6,
          "activation_step": 91,
          "start_time": 68.99,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s5_a89",
          "scenario": 6,
          "activation_step": 90,
          "start_time": 69.27,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s5_a88",
          "scenario": 6,
          "activation_step": 89,
          "start_time": 69.31,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a96",
          "scenario": 6,
          "activation_step": 97,
          "start_time": 70.1,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s5_a97",
          "scenario": 6,
          "activation_step": 98,
          "start_time": 70.21,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s5_a95",
          "scenario": 6,
          "activation_step": 96,
          "start_time": 70.26,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s5_a94",
          "scenario": 6,
          "activation_step": 95,
          "start_time": 70.68,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s5_a93",
          "scenario": 6,
          "activation_step": 94,
          "start_time": 70.74,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s5_a92",
          "scenario": 6,
          "activation_step": 93,
          "start_time": 70.75,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a98",
          "scenario": 6,
          "activation_step": 99,
          "start_time": 72.05,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s5_a99",
          "scenario": 6,
          "activation_step": 100,
          "start_time": 72.21,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        }
      ]
    },
    {
      "scenario_id": 7,
      "conflict_count": 63,
      "total_duration": 76.27,
      "activations": [
        {
          "id": "s6_a7",
          "scenario": 7,
          "activation_step": 8,
          "start_time": 1.62,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s6_a5",
          "scenario": 7,
          "activation_step": 6,
          "start_time": 1.84,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s6_a6",
          "scenario": 7,
          "activation_step": 7,
          "start_time": 2.02,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s6_a4",
          "scenario": 7,
          "activation_step": 5,
          "start_time": 2.13,
          "duration": 0.94,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s6_a2",
          "scenario": 7,
          "activation_step": 3,
          "start_time": 2.22,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s6_a3",
          "scenario": 7,
          "activation_step": 4,
          "start_time": 2.28,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s6_a1",
          "scenario": 7,
          "activation_step": 2,
          "start_time": 2.56,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s6_a0",
          "scenario": 7,
          "activation_step": 1,
          "start_time": 2.99,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a9",
          "scenario": 7,
          "activation_step": 10,
          "start_time": 3.04,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s6_a8",
          "scenario": 7,
          "activation_step": 9,
          "start_time": 3.46,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a11",
          "scenario": 7,
          "activation_step": 12,
          "start_time": 5.62,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s6_a10",
          "scenario": 7,
          "activation_step": 11,
          "start_time": 5.94,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a13",
          "scenario": 7,
          "activation_step": 14,
          "start_time": 7.57,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s6_a14",
          "scenario": 7,
          "activation_step": 15,
          "start_time": 7.63,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s6_a12",
          "scenario": 7,
          "activation_step": 13,
          "start_time": 7.72,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a18",
          "scenario": 7,
          "activation_step": 19,
          "start_time": 9.25,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s6_a17",
          "scenario": 7,
          "activation_step": 18,
          "start_time": 9.67,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s6_a15",
          "scenario": 7,
          "activation_step": 16,
          "start_time": 9.72,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a16",
          "scenario": 7,
          "activation_step": 17,
          "start_time": 9.9,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s6_a19",
          "scenario": 7,
          "activation_step": 20,
          "start_time": 11.87,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a23",
          "scenario": 7,
          "activation_step": 24,
          "start_time": 12.85,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s6_a22",
          "scenario": 7,
          "activation_step": 23,
          "start_time": 12.91,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s6_a21",
          "scenario": 7,
          "activation_step": 22,
          "start_time": 13.32,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s6_a20",
          "scenario": 7,
          "activation_step": 21,
          "start_time": 13.74,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a26",
          "scenario": 7,
          "activation_step": 27,
          "start_time": 15.24,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s6_a25",
          "scenario": 7,
          "activation_step": 26,
          "start_time": 15.29,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s6_a24",
          "scenario": 7,
          "activation_step": 25,
          "start_time": 15.66,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a29",
          "scenario": 7,
          "activation_step": 30,
          "start_time": 18.02,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s6_a27",
          "scenario": 7,
          "activation_step": 28,
          "start_time": 18.06,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a28",
          "scenario": 7,
          "activation_step": 29,
          "start_time": 18.16,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s6_a37",
          "scenario": 7,
          "activation_step": 38,
          "start_time": 19.01,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s6_a36",
          "scenario": 7,
          "activation_step": 37,
          "start_time": 19.23,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s6_a34",
          "scenario": 7,
          "activation_step": 35,
          "start_time": 19.52,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s6_a35",
          "scenario": 7,
          "activation_step": 36,
          "start_time": 19.61,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s6_a33",
          "scenario": 7,
          "activation_step": 34,
          "start_time": 19.87,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s6_a31",
          "scenario": 7,
          "activation_step": 32,
          "start_time": 19.94,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s6_a32",
          "scenario": 7,
          "activation_step": 33,
          "start_time": 19.99,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s6_a30",
          "scenario": 7,
          "activation_step": 31,
          "start_time": 20.04,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a38",
          "scenario": 7,
          "activation_step": 39,
          "start_time": 20.51,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a40",
          "scenario": 7,
          "activation_step": 41,
          "start_time": 22.23,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s6_a41",
          "scenario": 7,
          "activation_step": 42,
          "start_time": 22.28,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s6_a42",
          "scenario": 7,
          "activation_step": 43,
          "start_time": 22.38,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s6_a39",
          "scenario": 7,
          "activation_step": 40,
          "start_time": 22.72,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a44",
          "scenario": 7,
          "activation_step": 45,
          "start_time": 23.92,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s6_a43",
          "scenario": 7,
          "activation_step": 44,
          "start_time": 24.33,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a46",
          "scenario": 7,
          "activation_step": 47,
          "start_time": 25.86,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s6_a45",
          "scenario": 7,
          "activation_step": 46,
          "start_time": 25.92,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a47",
          "scenario": 7,
          "activation_step": 48,
          "start_time": 28.19,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a48",
          "scenario": 7,
          "activation_step": 49,
          "start_time": 30.69,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a53",
          "scenario": 7,
          "activation_step": 54,
          "start_time": 33.05,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s6_a52",
          "scenario": 7,
          "activation_step": 53,
          "start_time": 33.4,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s6_a51",
          "scenario": 7,
          "activation_step": 52,
          "start_time": 33.43,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s6_a49",
          "scenario": 7,
          "activation_step": 50,
          "start_time": 33.6,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a50",
          "scenario": 7,
          "activation_step": 51,
          "start_time": 33.63,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s6_a54",
          "scenario": 7,
          "activation_step": 55,
          "start_time": 35.73,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a57",
          "scenario": 7,
          "activation_step": 58,
          "start_time": 37.3,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s6_a56",
          "scenario": 7,
          "activation_step": 57,
          "start_time": 37.7,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s6_a55",
          "scenario": 7,
          "activation_step": 56,
          "start_time": 37.81,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a60",
          "scenario": 7,
          "activation_step": 61,
          "start_time": 39.91,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s6_a58",
          "scenario": 7,
          "activation_step": 59,
          "start_time": 40.14,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a59",
          "scenario": 7,
          "activation_step": 60,
          "start_time": 40.3,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s6_a62",
          "scenario": 7,
          "activation_step": 63,
          "start_time": 41.47,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s6_a61",
          "scenario": 7,
          "activation_step": 62,
          "start_time": 41.73,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a63",
          "scenario": 7,
          "activation_step": 64,
          "start_time": 44.07,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a64",
          "scenario": 7,
          "activation_step": 65,
          "start_time": 44.17,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s6_a65",
          "scenario": 7,
          "activation_step": 66,
          "start_time": 44.18,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s6_a70",
          "scenario": 7,
          "activation_step": 71,
          "start_time": 44.65,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s6_a69",
          "scenario": 7,
          "activation_step": 70,
          "start_time": 44.79,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s6_a68",
          "scenario": 7,
          "activation_step": 69,
          "start_time": 45.12,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s6_a67",
          "scenario": 7,
          "activation_step": 68,
          "start_time": 45.57,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s6_a66",
          "scenario": 7,
          "activation_step": 67,
          "start_time": 45.95,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a73",
          "scenario": 7,
          "activation_step": 74,
          "start_time": 46.39,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s6_a72",
          "scenario": 7,
          "activation_step": 73,
          "start_time": 46.47,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s6_a71",
          "scenario": 7,
          "activation_step": 72,
          "start_time": 46.56,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a74",
          "scenario": 7,
          "activation_step": 75,
          "start_time": 46.58,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s6_a75",
          "scenario": 7,
          "activation_step": 76,
          "start_time": 48.77,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a76",
          "scenario": 7,
          "activation_step": 77,
          "start_time": 48.89,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s6_a77",
          "scenario": 7,
          "activation_step": 78,
          "start_time": 50.49,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a78",
          "scenario": 7,
          "activation_step": 79,
          "start_time": 52.31,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a79",
          "scenario": 7,
          "activation_step": 80,
          "start_time": 55.07,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a80",
          "scenario": 7,
          "activation_step": 81,
          "start_time": 57.8,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a82",
          "scenario": 7,
          "activation_step": 83,
          "start_time": 59.99,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s6_a83",
          "scenario": 7,
          "activation_step": 84,
          "start_time": 60.19,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s6_a81",
          "scenario": 7,
          "activation_step": 82,
          "start_time": 60.2,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a84",
          "scenario": 7,
          "activation_step": 85,
          "start_time": 62.02,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a86",
          "scenario": 7,
          "activation_step": 87,
          "start_time": 62.03,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s6_a85",
          "scenario": 7,
          "activation_step": 86,
          "start_time": 62.15,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s6_a88",
          "scenario": 7,
          "activation_step": 89,
          "start_time": 64.16,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s6_a87",
          "scenario": 7,
          "activation_step": 88,
          "start_time": 64.55,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a91",
          "scenario": 7,
          "activation_step": 92,
          "start_time": 65.78,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s6_a90",
          "scenario": 7,
          "activation_step": 91,
          "start_time": 65.89,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s6_a89",
          "scenario": 7,
          "activation_step": 90,
          "start_time": 66.2,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a94",
          "scenario": 7,
          "activation_step": 95,
          "start_time": 67.77,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s6_a92",
          "scenario": 7,
          "activation_step": 93,
          "start_time": 68.1,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a93",
          "scenario": 7,
          "activation_step": 94,
          "start_time": 68.11,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s6_a96",
          "scenario": 7,
          "activation_step": 97,
          "start_time": 69.92,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s6_a97",
          "scenario": 7,
          "activation_step": 98,
          "start_time": 70.11,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s6_a95",
          "scenario": 7,
          "activation_step": 96,
          "start_time": 70.15,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a98",
          "scenario": 7,
          "activation_step": 99,
          "start_time": 71.75,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s6_a99",
          "scenario": 7,
          "activation_step": 100,
          "start_time": 74.27,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        }
      ]
    },
    {
      "scenario_id": 8,
      "conflict_count": 66,
      "total_duration": 71.98,
      "activations": [
        {
          "id": "s7_a0",
          "scenario": 8,
          "activation_step": 1,
          "start_time": 0,
          "duration": 0.92,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s7_a1",
          "scenario": 8,
          "activation_step": 2,
          "start_time": 0,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s7_a2",
          "scenario": 8,
          "activation_step": 3,
          "start_time": 2.48,
          "duration": 0.8,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a3",
          "scenario": 8,
          "activation_step": 4,
          "start_time": 4.67,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a4",
          "scenario": 8,
          "activation_step": 5,
          "start_time": 7.51,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a5",
          "scenario": 8,
          "activation_step": 6,
          "start_time": 9.51,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a7",
          "scenario": 8,
          "activation_step": 8,
          "start_time": 9.54,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s7_a6",
          "scenario": 8,
          "activation_step": 7,
          "start_time": 9.59,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s7_a8",
          "scenario": 8,
          "activation_step": 9,
          "start_time": 9.69,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s7_a10",
          "scenario": 8,
          "activation_step": 11,
          "start_time": 10.93,
          "duration": 0.92,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s7_a9",
          "scenario": 8,
          "activation_step": 10,
          "start_time": 11.27,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a11",
          "scenario": 8,
          "activation_step": 12,
          "start_time": 13.17,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a15",
          "scenario": 8,
          "activation_step": 16,
          "start_time": 15.44,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s7_a16",
          "scenario": 8,
          "activation_step": 17,
          "start_time": 15.5,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s7_a12",
          "scenario": 8,
          "activation_step": 13,
          "start_time": 15.55,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a17",
          "scenario": 8,
          "activation_step": 18,
          "start_time": 15.56,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s7_a13",
          "scenario": 8,
          "activation_step": 14,
          "start_time": 15.67,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s7_a14",
          "scenario": 8,
          "activation_step": 15,
          "start_time": 15.75,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s7_a18",
          "scenario": 8,
          "activation_step": 19,
          "start_time": 18.54,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a19",
          "scenario": 8,
          "activation_step": 20,
          "start_time": 20.78,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a20",
          "scenario": 8,
          "activation_step": 21,
          "start_time": 20.89,
          "duration": 0.94,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s7_a22",
          "scenario": 8,
          "activation_step": 23,
          "start_time": 22.67,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s7_a21",
          "scenario": 8,
          "activation_step": 22,
          "start_time": 23.08,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a25",
          "scenario": 8,
          "activation_step": 26,
          "start_time": 23.98,
          "duration": 0.92,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s7_a26",
          "scenario": 8,
          "activation_step": 27,
          "start_time": 24.04,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s7_a23",
          "scenario": 8,
          "activation_step": 24,
          "start_time": 24.18,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a24",
          "scenario": 8,
          "activation_step": 25,
          "start_time": 24.29,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s7_a28",
          "scenario": 8,
          "activation_step": 29,
          "start_time": 26.7,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s7_a27",
          "scenario": 8,
          "activation_step": 28,
          "start_time": 26.84,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a29",
          "scenario": 8,
          "activation_step": 30,
          "start_time": 29.04,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a30",
          "scenario": 8,
          "activation_step": 31,
          "start_time": 29.14,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s7_a31",
          "scenario": 8,
          "activation_step": 32,
          "start_time": 30.95,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a32",
          "scenario": 8,
          "activation_step": 33,
          "start_time": 31.05,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s7_a33",
          "scenario": 8,
          "activation_step": 34,
          "start_time": 31.23,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s7_a35",
          "scenario": 8,
          "activation_step": 36,
          "start_time": 33.32,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s7_a34",
          "scenario": 8,
          "activation_step": 35,
          "start_time": 33.46,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a40",
          "scenario": 8,
          "activation_step": 41,
          "start_time": 34.66,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s7_a42",
          "scenario": 8,
          "activation_step": 43,
          "start_time": 34.71,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s7_a41",
          "scenario": 8,
          "activation_step": 42,
          "start_time": 34.75,
          "duration": 0.92,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s7_a39",
          "scenario": 8,
          "activation_step": 40,
          "start_time": 35.05,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s7_a38",
          "scenario": 8,
          "activation_step": 39,
          "start_time": 35.46,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s7_a37",
          "scenario": 8,
          "activation_step": 38,
          "start_time": 35.87,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s7_a36",
          "scenario": 8,
          "activation_step": 37,
          "start_time": 35.93,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a43",
          "scenario": 8,
          "activation_step": 44,
          "start_time": 36.32,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a50",
          "scenario": 8,
          "activation_step": 51,
          "start_time": 36.78,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s7_a49",
          "scenario": 8,
          "activation_step": 50,
          "start_time": 37.16,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s7_a48",
          "scenario": 8,
          "activation_step": 49,
          "start_time": 37.23,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s7_a46",
          "scenario": 8,
          "activation_step": 47,
          "start_time": 37.25,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s7_a47",
          "scenario": 8,
          "activation_step": 48,
          "start_time": 37.25,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s7_a45",
          "scenario": 8,
          "activation_step": 46,
          "start_time": 37.63,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s7_a44",
          "scenario": 8,
          "activation_step": 45,
          "start_time": 37.97,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a51",
          "scenario": 8,
          "activation_step": 52,
          "start_time": 38.96,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a54",
          "scenario": 8,
          "activation_step": 55,
          "start_time": 41.15,
          "duration": 0.98,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s7_a55",
          "scenario": 8,
          "activation_step": 56,
          "start_time": 41.23,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s7_a53",
          "scenario": 8,
          "activation_step": 54,
          "start_time": 41.5,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s7_a52",
          "scenario": 8,
          "activation_step": 53,
          "start_time": 41.91,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a57",
          "scenario": 8,
          "activation_step": 58,
          "start_time": 42.67,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s7_a56",
          "scenario": 8,
          "activation_step": 57,
          "start_time": 42.76,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a58",
          "scenario": 8,
          "activation_step": 59,
          "start_time": 44.54,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a59",
          "scenario": 8,
          "activation_step": 60,
          "start_time": 46.16,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a60",
          "scenario": 8,
          "activation_step": 61,
          "start_time": 47.72,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a61",
          "scenario": 8,
          "activation_step": 62,
          "start_time": 50.6,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a63",
          "scenario": 8,
          "activation_step": 64,
          "start_time": 52.73,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s7_a65",
          "scenario": 8,
          "activation_step": 66,
          "start_time": 52.8,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s7_a64",
          "scenario": 8,
          "activation_step": 65,
          "start_time": 52.87,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s7_a62",
          "scenario": 8,
          "activation_step": 63,
          "start_time": 53.05,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a66",
          "scenario": 8,
          "activation_step": 67,
          "start_time": 55.06,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a77",
          "scenario": 8,
          "activation_step": 78,
          "start_time": 55.99,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s7_a76",
          "scenario": 8,
          "activation_step": 77,
          "start_time": 56.27,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s7_a74",
          "scenario": 8,
          "activation_step": 75,
          "start_time": 56.54,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s7_a75",
          "scenario": 8,
          "activation_step": 76,
          "start_time": 56.61,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s7_a73",
          "scenario": 8,
          "activation_step": 74,
          "start_time": 56.65,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s7_a72",
          "scenario": 8,
          "activation_step": 73,
          "start_time": 57.08,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s7_a71",
          "scenario": 8,
          "activation_step": 72,
          "start_time": 57.31,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s7_a69",
          "scenario": 8,
          "activation_step": 70,
          "start_time": 57.46,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s7_a70",
          "scenario": 8,
          "activation_step": 71,
          "start_time": 57.52,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s7_a67",
          "scenario": 8,
          "activation_step": 68,
          "start_time": 57.57,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a68",
          "scenario": 8,
          "activation_step": 69,
          "start_time": 57.71,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s7_a81",
          "scenario": 8,
          "activation_step": 82,
          "start_time": 57.87,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s7_a80",
          "scenario": 8,
          "activation_step": 81,
          "start_time": 58.35,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s7_a79",
          "scenario": 8,
          "activation_step": 80,
          "start_time": 58.54,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s7_a78",
          "scenario": 8,
          "activation_step": 79,
          "start_time": 58.78,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a85",
          "scenario": 8,
          "activation_step": 86,
          "start_time": 60.32,
          "duration": 0.92,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s7_a84",
          "scenario": 8,
          "activation_step": 85,
          "start_time": 60.42,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s7_a83",
          "scenario": 8,
          "activation_step": 84,
          "start_time": 60.49,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s7_a82",
          "scenario": 8,
          "activation_step": 83,
          "start_time": 60.61,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a87",
          "scenario": 8,
          "activation_step": 88,
          "start_time": 62.82,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s7_a88",
          "scenario": 8,
          "activation_step": 89,
          "start_time": 62.92,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s7_a86",
          "scenario": 8,
          "activation_step": 87,
          "start_time": 63.1,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a89",
          "scenario": 8,
          "activation_step": 90,
          "start_time": 65.9,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a93",
          "scenario": 8,
          "activation_step": 94,
          "start_time": 65.9,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s7_a90",
          "scenario": 8,
          "activation_step": 91,
          "start_time": 65.97,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s7_a91",
          "scenario": 8,
          "activation_step": 92,
          "start_time": 66.03,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s7_a92",
          "scenario": 8,
          "activation_step": 93,
          "start_time": 66.1,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s7_a94",
          "scenario": 8,
          "activation_step": 95,
          "start_time": 68.18,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s7_a99",
          "scenario": 8,
          "activation_step": 100,
          "start_time": 69.02,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s7_a98",
          "scenario": 8,
          "activation_step": 99,
          "start_time": 69.04,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s7_a97",
          "scenario": 8,
          "activation_step": 98,
          "start_time": 69.15,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s7_a96",
          "scenario": 8,
          "activation_step": 97,
          "start_time": 69.59,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s7_a95",
          "scenario": 8,
          "activation_step": 96,
          "start_time": 69.98,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        }
      ]
    },
    {
      "scenario_id": 9,
      "conflict_count": 65,
      "total_duration": 73.28,
      "activations": [
        {
          "id": "s8_a0",
          "scenario": 9,
          "activation_step": 1,
          "start_time": 0.11,
          "duration": 0.98,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s8_a1",
          "scenario": 9,
          "activation_step": 2,
          "start_time": 0.21,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s8_a3",
          "scenario": 9,
          "activation_step": 4,
          "start_time": 2.77,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s8_a2",
          "scenario": 9,
          "activation_step": 3,
          "start_time": 2.89,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a4",
          "scenario": 9,
          "activation_step": 5,
          "start_time": 4.77,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a8",
          "scenario": 9,
          "activation_step": 9,
          "start_time": 6.42,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s8_a7",
          "scenario": 9,
          "activation_step": 8,
          "start_time": 6.55,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s8_a5",
          "scenario": 9,
          "activation_step": 6,
          "start_time": 6.72,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a6",
          "scenario": 9,
          "activation_step": 7,
          "start_time": 6.74,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s8_a11",
          "scenario": 9,
          "activation_step": 12,
          "start_time": 7.91,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s8_a12",
          "scenario": 9,
          "activation_step": 13,
          "start_time": 7.94,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s8_a10",
          "scenario": 9,
          "activation_step": 11,
          "start_time": 7.97,
          "duration": 1.2,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s8_a9",
          "scenario": 9,
          "activation_step": 10,
          "start_time": 8.34,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a15",
          "scenario": 9,
          "activation_step": 16,
          "start_time": 9.56,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s8_a14",
          "scenario": 9,
          "activation_step": 15,
          "start_time": 9.86,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s8_a13",
          "scenario": 9,
          "activation_step": 14,
          "start_time": 10.02,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a19",
          "scenario": 9,
          "activation_step": 20,
          "start_time": 10.55,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s8_a18",
          "scenario": 9,
          "activation_step": 19,
          "start_time": 10.86,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s8_a17",
          "scenario": 9,
          "activation_step": 18,
          "start_time": 10.92,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s8_a16",
          "scenario": 9,
          "activation_step": 17,
          "start_time": 11.25,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a20",
          "scenario": 9,
          "activation_step": 21,
          "start_time": 12.33,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a23",
          "scenario": 9,
          "activation_step": 24,
          "start_time": 14.21,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s8_a22",
          "scenario": 9,
          "activation_step": 23,
          "start_time": 14.55,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s8_a21",
          "scenario": 9,
          "activation_step": 22,
          "start_time": 14.68,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a24",
          "scenario": 9,
          "activation_step": 25,
          "start_time": 17.14,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a31",
          "scenario": 9,
          "activation_step": 32,
          "start_time": 19.07,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s8_a32",
          "scenario": 9,
          "activation_step": 33,
          "start_time": 19.07,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s8_a29",
          "scenario": 9,
          "activation_step": 30,
          "start_time": 19.2,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s8_a33",
          "scenario": 9,
          "activation_step": 34,
          "start_time": 19.24,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s8_a30",
          "scenario": 9,
          "activation_step": 31,
          "start_time": 19.28,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s8_a28",
          "scenario": 9,
          "activation_step": 29,
          "start_time": 19.36,
          "duration": 0.94,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s8_a34",
          "scenario": 9,
          "activation_step": 35,
          "start_time": 19.4,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s8_a27",
          "scenario": 9,
          "activation_step": 28,
          "start_time": 19.57,
          "duration": 1.2,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s8_a26",
          "scenario": 9,
          "activation_step": 27,
          "start_time": 19.66,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s8_a25",
          "scenario": 9,
          "activation_step": 26,
          "start_time": 19.94,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a37",
          "scenario": 9,
          "activation_step": 38,
          "start_time": 21.48,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s8_a36",
          "scenario": 9,
          "activation_step": 37,
          "start_time": 21.77,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s8_a35",
          "scenario": 9,
          "activation_step": 36,
          "start_time": 22.21,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a39",
          "scenario": 9,
          "activation_step": 40,
          "start_time": 24.11,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s8_a38",
          "scenario": 9,
          "activation_step": 39,
          "start_time": 24.22,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a42",
          "scenario": 9,
          "activation_step": 43,
          "start_time": 26.42,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s8_a41",
          "scenario": 9,
          "activation_step": 42,
          "start_time": 26.59,
          "duration": 0.94,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s8_a40",
          "scenario": 9,
          "activation_step": 41,
          "start_time": 26.62,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a44",
          "scenario": 9,
          "activation_step": 45,
          "start_time": 27.58,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s8_a45",
          "scenario": 9,
          "activation_step": 46,
          "start_time": 27.64,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s8_a46",
          "scenario": 9,
          "activation_step": 47,
          "start_time": 27.67,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s8_a47",
          "scenario": 9,
          "activation_step": 48,
          "start_time": 27.77,
          "duration": 0.94,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s8_a43",
          "scenario": 9,
          "activation_step": 44,
          "start_time": 28.06,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a49",
          "scenario": 9,
          "activation_step": 50,
          "start_time": 29.65,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s8_a48",
          "scenario": 9,
          "activation_step": 49,
          "start_time": 29.89,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a51",
          "scenario": 9,
          "activation_step": 52,
          "start_time": 31.95,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s8_a50",
          "scenario": 9,
          "activation_step": 51,
          "start_time": 32.25,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a52",
          "scenario": 9,
          "activation_step": 53,
          "start_time": 33.84,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a53",
          "scenario": 9,
          "activation_step": 54,
          "start_time": 36.03,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a54",
          "scenario": 9,
          "activation_step": 55,
          "start_time": 38.99,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a55",
          "scenario": 9,
          "activation_step": 56,
          "start_time": 40.85,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a56",
          "scenario": 9,
          "activation_step": 57,
          "start_time": 40.96,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s8_a59",
          "scenario": 9,
          "activation_step": 60,
          "start_time": 42.83,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s8_a60",
          "scenario": 9,
          "activation_step": 61,
          "start_time": 43.0,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s8_a58",
          "scenario": 9,
          "activation_step": 59,
          "start_time": 43.01,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s8_a57",
          "scenario": 9,
          "activation_step": 58,
          "start_time": 43.44,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a61",
          "scenario": 9,
          "activation_step": 62,
          "start_time": 44.74,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a62",
          "scenario": 9,
          "activation_step": 63,
          "start_time": 47.45,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a63",
          "scenario": 9,
          "activation_step": 64,
          "start_time": 47.52,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s8_a64",
          "scenario": 9,
          "activation_step": 65,
          "start_time": 47.53,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s8_a70",
          "scenario": 9,
          "activation_step": 71,
          "start_time": 48.91,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s8_a69",
          "scenario": 9,
          "activation_step": 70,
          "start_time": 49.14,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s8_a68",
          "scenario": 9,
          "activation_step": 69,
          "start_time": 49.21,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s8_a67",
          "scenario": 9,
          "activation_step": 68,
          "start_time": 49.46,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s8_a66",
          "scenario": 9,
          "activation_step": 67,
          "start_time": 49.57,
          "duration": 0.92,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s8_a65",
          "scenario": 9,
          "activation_step": 66,
          "start_time": 49.81,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a71",
          "scenario": 9,
          "activation_step": 72,
          "start_time": 50.89,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a72",
          "scenario": 9,
          "activation_step": 73,
          "start_time": 53.67,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a73",
          "scenario": 9,
          "activation_step": 74,
          "start_time": 55.61,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a81",
          "scenario": 9,
          "activation_step": 82,
          "start_time": 57.28,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s8_a80",
          "scenario": 9,
          "activation_step": 81,
          "start_time": 57.35,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s8_a79",
          "scenario": 9,
          "activation_step": 80,
          "start_time": 57.46,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s8_a77",
          "scenario": 9,
          "activation_step": 78,
          "start_time": 57.64,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s8_a78",
          "scenario": 9,
          "activation_step": 79,
          "start_time": 57.72,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s8_a76",
          "scenario": 9,
          "activation_step": 77,
          "start_time": 57.86,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s8_a75",
          "scenario": 9,
          "activation_step": 76,
          "start_time": 58.1,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s8_a74",
          "scenario": 9,
          "activation_step": 75,
          "start_time": 58.25,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a83",
          "scenario": 9,
          "activation_step": 84,
          "start_time": 59.63,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s8_a82",
          "scenario": 9,
          "activation_step": 83,
          "start_time": 59.94,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a84",
          "scenario": 9,
          "activation_step": 85,
          "start_time": 62.47,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a86",
          "scenario": 9,
          "activation_step": 87,
          "start_time": 64.37,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s8_a87",
          "scenario": 9,
          "activation_step": 88,
          "start_time": 64.37,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s8_a85",
          "scenario": 9,
          "activation_step": 86,
          "start_time": 64.69,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a89",
          "scenario": 9,
          "activation_step": 90,
          "start_time": 66.15,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s8_a90",
          "scenario": 9,
          "activation_step": 91,
          "start_time": 66.22,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s8_a92",
          "scenario": 9,
          "activation_step": 93,
          "start_time": 66.29,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s8_a91",
          "scenario": 9,
          "activation_step": 92,
          "start_time": 66.31,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s8_a88",
          "scenario": 9,
          "activation_step": 89,
          "start_time": 66.62,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a94",
          "scenario": 9,
          "activation_step": 95,
          "start_time": 68.38,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s8_a95",
          "scenario": 9,
          "activation_step": 96,
          "start_time": 68.4,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s8_a93",
          "scenario": 9,
          "activation_step": 94,
          "start_time": 68.5,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a98",
          "scenario": 9,
          "activation_step": 99,
          "start_time": 69.33,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s8_a97",
          "scenario": 9,
          "activation_step": 98,
          "start_time": 69.55,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s8_a96",
          "scenario": 9,
          "activation_step": 97,
          "start_time": 69.97,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s8_a99",
          "scenario": 9,
          "activation_step": 100,
          "start_time": 71.28,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        }
      ]
    },
    {
      "scenario_id": 10,
      "conflict_count": 64,
      "total_duration": 74.49,
      "activations": [
        {
          "id": "s9_a1",
          "scenario": 10,
          "activation_step": 2,
          "start_time": 0,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s9_a0",
          "scenario": 10,
          "activation_step": 1,
          "start_time": 0.09,
          "duration": 0.92,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s9_a2",
          "scenario": 10,
          "activation_step": 3,
          "start_time": 1.95,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a3",
          "scenario": 10,
          "activation_step": 4,
          "start_time": 3.62,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a5",
          "scenario": 10,
          "activation_step": 6,
          "start_time": 5.04,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s9_a4",
          "scenario": 10,
          "activation_step": 5,
          "start_time": 5.17,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a8",
          "scenario": 10,
          "activation_step": 9,
          "start_time": 6.38,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s9_a7",
          "scenario": 10,
          "activation_step": 8,
          "start_time": 6.46,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s9_a6",
          "scenario": 10,
          "activation_step": 7,
          "start_time": 6.63,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a9",
          "scenario": 10,
          "activation_step": 10,
          "start_time": 8.22,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a10",
          "scenario": 10,
          "activation_step": 11,
          "start_time": 8.33,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s9_a11",
          "scenario": 10,
          "activation_step": 12,
          "start_time": 8.37,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s9_a12",
          "scenario": 10,
          "activation_step": 13,
          "start_time": 10.04,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a13",
          "scenario": 10,
          "activation_step": 14,
          "start_time": 10.15,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s9_a14",
          "scenario": 10,
          "activation_step": 15,
          "start_time": 10.28,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s9_a15",
          "scenario": 10,
          "activation_step": 16,
          "start_time": 13.1,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a16",
          "scenario": 10,
          "activation_step": 17,
          "start_time": 14.97,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a22",
          "scenario": 10,
          "activation_step": 23,
          "start_time": 16.2,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s9_a21",
          "scenario": 10,
          "activation_step": 22,
          "start_time": 16.6,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s9_a19",
          "scenario": 10,
          "activation_step": 20,
          "start_time": 16.75,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s9_a20",
          "scenario": 10,
          "activation_step": 21,
          "start_time": 16.8,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s9_a18",
          "scenario": 10,
          "activation_step": 19,
          "start_time": 16.87,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s9_a17",
          "scenario": 10,
          "activation_step": 18,
          "start_time": 17.33,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a23",
          "scenario": 10,
          "activation_step": 24,
          "start_time": 18.93,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a24",
          "scenario": 10,
          "activation_step": 25,
          "start_time": 18.94,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s9_a25",
          "scenario": 10,
          "activation_step": 26,
          "start_time": 21.14,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a26",
          "scenario": 10,
          "activation_step": 27,
          "start_time": 23.2,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a28",
          "scenario": 10,
          "activation_step": 29,
          "start_time": 25.24,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s9_a27",
          "scenario": 10,
          "activation_step": 28,
          "start_time": 25.68,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a31",
          "scenario": 10,
          "activation_step": 32,
          "start_time": 26.52,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s9_a29",
          "scenario": 10,
          "activation_step": 30,
          "start_time": 26.98,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a30",
          "scenario": 10,
          "activation_step": 31,
          "start_time": 26.98,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s9_a34",
          "scenario": 10,
          "activation_step": 35,
          "start_time": 28.59,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s9_a32",
          "scenario": 10,
          "activation_step": 33,
          "start_time": 28.62,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a35",
          "scenario": 10,
          "activation_step": 36,
          "start_time": 28.62,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s9_a33",
          "scenario": 10,
          "activation_step": 34,
          "start_time": 28.67,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s9_a38",
          "scenario": 10,
          "activation_step": 39,
          "start_time": 30.17,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s9_a39",
          "scenario": 10,
          "activation_step": 40,
          "start_time": 30.36,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s9_a37",
          "scenario": 10,
          "activation_step": 38,
          "start_time": 30.61,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s9_a36",
          "scenario": 10,
          "activation_step": 37,
          "start_time": 31.01,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a40",
          "scenario": 10,
          "activation_step": 41,
          "start_time": 32.56,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a42",
          "scenario": 10,
          "activation_step": 43,
          "start_time": 34.84,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s9_a41",
          "scenario": 10,
          "activation_step": 42,
          "start_time": 34.91,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a45",
          "scenario": 10,
          "activation_step": 46,
          "start_time": 36.46,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s9_a43",
          "scenario": 10,
          "activation_step": 44,
          "start_time": 36.68,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a44",
          "scenario": 10,
          "activation_step": 45,
          "start_time": 36.85,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s9_a48",
          "scenario": 10,
          "activation_step": 49,
          "start_time": 39.02,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s9_a47",
          "scenario": 10,
          "activation_step": 48,
          "start_time": 39.05,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s9_a49",
          "scenario": 10,
          "activation_step": 50,
          "start_time": 39.15,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s9_a46",
          "scenario": 10,
          "activation_step": 47,
          "start_time": 39.37,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a50",
          "scenario": 10,
          "activation_step": 51,
          "start_time": 40.74,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a55",
          "scenario": 10,
          "activation_step": 56,
          "start_time": 42.41,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s9_a54",
          "scenario": 10,
          "activation_step": 55,
          "start_time": 42.7,
          "duration": 0.92,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s9_a53",
          "scenario": 10,
          "activation_step": 54,
          "start_time": 42.87,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s9_a52",
          "scenario": 10,
          "activation_step": 53,
          "start_time": 43.21,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s9_a51",
          "scenario": 10,
          "activation_step": 52,
          "start_time": 43.31,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a56",
          "scenario": 10,
          "activation_step": 57,
          "start_time": 44.17,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a57",
          "scenario": 10,
          "activation_step": 58,
          "start_time": 46.2,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a60",
          "scenario": 10,
          "activation_step": 61,
          "start_time": 48.44,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s9_a59",
          "scenario": 10,
          "activation_step": 60,
          "start_time": 48.71,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s9_a58",
          "scenario": 10,
          "activation_step": 59,
          "start_time": 48.93,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a61",
          "scenario": 10,
          "activation_step": 62,
          "start_time": 51.14,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a68",
          "scenario": 10,
          "activation_step": 69,
          "start_time": 53.15,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s9_a65",
          "scenario": 10,
          "activation_step": 66,
          "start_time": 53.17,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s9_a64",
          "scenario": 10,
          "activation_step": 65,
          "start_time": 53.21,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s9_a69",
          "scenario": 10,
          "activation_step": 70,
          "start_time": 53.24,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s9_a67",
          "scenario": 10,
          "activation_step": 68,
          "start_time": 53.26,
          "duration": 0.94,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s9_a66",
          "scenario": 10,
          "activation_step": 67,
          "start_time": 53.36,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s9_a63",
          "scenario": 10,
          "activation_step": 64,
          "start_time": 53.4,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s9_a62",
          "scenario": 10,
          "activation_step": 63,
          "start_time": 53.76,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a72",
          "scenario": 10,
          "activation_step": 73,
          "start_time": 56.07,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s9_a71",
          "scenario": 10,
          "activation_step": 72,
          "start_time": 56.15,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s9_a70",
          "scenario": 10,
          "activation_step": 71,
          "start_time": 56.21,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a74",
          "scenario": 10,
          "activation_step": 75,
          "start_time": 57.88,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s9_a73",
          "scenario": 10,
          "activation_step": 74,
          "start_time": 58.25,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a75",
          "scenario": 10,
          "activation_step": 76,
          "start_time": 60.13,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a76",
          "scenario": 10,
          "activation_step": 77,
          "start_time": 62.4,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a84",
          "scenario": 10,
          "activation_step": 85,
          "start_time": 62.81,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s9_a85",
          "scenario": 10,
          "activation_step": 86,
          "start_time": 62.82,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s9_a87",
          "scenario": 10,
          "activation_step": 88,
          "start_time": 62.93,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s9_a86",
          "scenario": 10,
          "activation_step": 87,
          "start_time": 62.94,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s9_a83",
          "scenario": 10,
          "activation_step": 84,
          "start_time": 63.22,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s9_a82",
          "scenario": 10,
          "activation_step": 83,
          "start_time": 63.54,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s9_a81",
          "scenario": 10,
          "activation_step": 82,
          "start_time": 63.77,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s9_a79",
          "scenario": 10,
          "activation_step": 80,
          "start_time": 64.07,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s9_a78",
          "scenario": 10,
          "activation_step": 79,
          "start_time": 64.13,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s9_a80",
          "scenario": 10,
          "activation_step": 81,
          "start_time": 64.23,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s9_a77",
          "scenario": 10,
          "activation_step": 78,
          "start_time": 64.39,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a88",
          "scenario": 10,
          "activation_step": 89,
          "start_time": 65.54,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a89",
          "scenario": 10,
          "activation_step": 90,
          "start_time": 65.71,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s9_a91",
          "scenario": 10,
          "activation_step": 92,
          "start_time": 67.76,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s9_a90",
          "scenario": 10,
          "activation_step": 91,
          "start_time": 67.87,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a94",
          "scenario": 10,
          "activation_step": 95,
          "start_time": 69.81,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s9_a93",
          "scenario": 10,
          "activation_step": 94,
          "start_time": 70.26,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s9_a92",
          "scenario": 10,
          "activation_step": 93,
          "start_time": 70.62,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a98",
          "scenario": 10,
          "activation_step": 99,
          "start_time": 71.98,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s9_a99",
          "scenario": 10,
          "activation_step": 100,
          "start_time": 72.06,
          "duration": 0.98,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s9_a95",
          "scenario": 10,
          "activation_step": 96,
          "start_time": 72.4,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s9_a97",
          "scenario": 10,
          "activation_step": 98,
          "start_time": 72.4,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s9_a96",
          "scenario": 10,
          "activation_step": 97,
          "start_time": 72.49,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        }
      ]
    },
    {
      "scenario_id": 11,
      "conflict_count": 65,
      "total_duration": 72.62,
      "activations": [
        {
          "id": "s10_a5",
          "scenario": 11,
          "activation_step": 6,
          "start_time": 2.43,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s10_a6",
          "scenario": 11,
          "activation_step": 7,
          "start_time": 2.55,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s10_a3",
          "scenario": 11,
          "activation_step": 4,
          "start_time": 2.68,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s10_a0",
          "scenario": 11,
          "activation_step": 1,
          "start_time": 2.84,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a4",
          "scenario": 11,
          "activation_step": 5,
          "start_time": 2.85,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s10_a1",
          "scenario": 11,
          "activation_step": 2,
          "start_time": 3.01,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s10_a2",
          "scenario": 11,
          "activation_step": 3,
          "start_time": 3.05,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s10_a10",
          "scenario": 11,
          "activation_step": 11,
          "start_time": 4.56,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s10_a9",
          "scenario": 11,
          "activation_step": 10,
          "start_time": 4.88,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s10_a8",
          "scenario": 11,
          "activation_step": 9,
          "start_time": 5.3,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s10_a7",
          "scenario": 11,
          "activation_step": 8,
          "start_time": 5.47,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a11",
          "scenario": 11,
          "activation_step": 12,
          "start_time": 7.04,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a12",
          "scenario": 11,
          "activation_step": 13,
          "start_time": 8.85,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a13",
          "scenario": 11,
          "activation_step": 14,
          "start_time": 9.04,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s10_a14",
          "scenario": 11,
          "activation_step": 15,
          "start_time": 11.59,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a16",
          "scenario": 11,
          "activation_step": 17,
          "start_time": 14.14,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s10_a15",
          "scenario": 11,
          "activation_step": 16,
          "start_time": 14.41,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a17",
          "scenario": 11,
          "activation_step": 18,
          "start_time": 16.58,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a18",
          "scenario": 11,
          "activation_step": 19,
          "start_time": 18.6,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a19",
          "scenario": 11,
          "activation_step": 20,
          "start_time": 20.55,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a22",
          "scenario": 11,
          "activation_step": 23,
          "start_time": 21.77,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s10_a23",
          "scenario": 11,
          "activation_step": 24,
          "start_time": 21.96,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s10_a21",
          "scenario": 11,
          "activation_step": 22,
          "start_time": 22.0,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s10_a20",
          "scenario": 11,
          "activation_step": 21,
          "start_time": 22.19,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a24",
          "scenario": 11,
          "activation_step": 25,
          "start_time": 23.74,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a25",
          "scenario": 11,
          "activation_step": 26,
          "start_time": 26.32,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a26",
          "scenario": 11,
          "activation_step": 27,
          "start_time": 28.26,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a30",
          "scenario": 11,
          "activation_step": 31,
          "start_time": 29.61,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s10_a28",
          "scenario": 11,
          "activation_step": 29,
          "start_time": 29.79,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s10_a29",
          "scenario": 11,
          "activation_step": 30,
          "start_time": 29.82,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s10_a27",
          "scenario": 11,
          "activation_step": 28,
          "start_time": 29.96,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a31",
          "scenario": 11,
          "activation_step": 32,
          "start_time": 31.9,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a32",
          "scenario": 11,
          "activation_step": 33,
          "start_time": 34.36,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a33",
          "scenario": 11,
          "activation_step": 34,
          "start_time": 34.52,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s10_a34",
          "scenario": 11,
          "activation_step": 35,
          "start_time": 37.4,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a36",
          "scenario": 11,
          "activation_step": 37,
          "start_time": 39.01,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s10_a48",
          "scenario": 11,
          "activation_step": 49,
          "start_time": 39.04,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s10_a37",
          "scenario": 11,
          "activation_step": 38,
          "start_time": 39.14,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s10_a35",
          "scenario": 11,
          "activation_step": 36,
          "start_time": 39.46,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a47",
          "scenario": 11,
          "activation_step": 48,
          "start_time": 39.49,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s10_a46",
          "scenario": 11,
          "activation_step": 47,
          "start_time": 39.8,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s10_a45",
          "scenario": 11,
          "activation_step": 46,
          "start_time": 39.88,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s10_a44",
          "scenario": 11,
          "activation_step": 45,
          "start_time": 40.15,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s10_a40",
          "scenario": 11,
          "activation_step": 41,
          "start_time": 40.41,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s10_a42",
          "scenario": 11,
          "activation_step": 43,
          "start_time": 40.52,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s10_a43",
          "scenario": 11,
          "activation_step": 44,
          "start_time": 40.56,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s10_a55",
          "scenario": 11,
          "activation_step": 56,
          "start_time": 40.58,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s10_a41",
          "scenario": 11,
          "activation_step": 42,
          "start_time": 40.61,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s10_a53",
          "scenario": 11,
          "activation_step": 54,
          "start_time": 40.76,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s10_a38",
          "scenario": 11,
          "activation_step": 39,
          "start_time": 40.8,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a39",
          "scenario": 11,
          "activation_step": 40,
          "start_time": 40.85,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s10_a51",
          "scenario": 11,
          "activation_step": 52,
          "start_time": 40.91,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s10_a54",
          "scenario": 11,
          "activation_step": 55,
          "start_time": 40.91,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s10_a52",
          "scenario": 11,
          "activation_step": 53,
          "start_time": 41.01,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s10_a50",
          "scenario": 11,
          "activation_step": 51,
          "start_time": 41.37,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s10_a49",
          "scenario": 11,
          "activation_step": 50,
          "start_time": 41.53,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a56",
          "scenario": 11,
          "activation_step": 57,
          "start_time": 42.65,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a57",
          "scenario": 11,
          "activation_step": 58,
          "start_time": 45.21,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a58",
          "scenario": 11,
          "activation_step": 59,
          "start_time": 47.01,
          "duration": 0.8,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a59",
          "scenario": 11,
          "activation_step": 60,
          "start_time": 47.09,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s10_a60",
          "scenario": 11,
          "activation_step": 61,
          "start_time": 47.15,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s10_a61",
          "scenario": 11,
          "activation_step": 62,
          "start_time": 49.14,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a62",
          "scenario": 11,
          "activation_step": 63,
          "start_time": 52.04,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a63",
          "scenario": 11,
          "activation_step": 64,
          "start_time": 52.08,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s10_a64",
          "scenario": 11,
          "activation_step": 65,
          "start_time": 53.86,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a65",
          "scenario": 11,
          "activation_step": 66,
          "start_time": 54.02,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s10_a68",
          "scenario": 11,
          "activation_step": 69,
          "start_time": 56.05,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s10_a67",
          "scenario": 11,
          "activation_step": 68,
          "start_time": 56.37,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s10_a66",
          "scenario": 11,
          "activation_step": 67,
          "start_time": 56.57,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a69",
          "scenario": 11,
          "activation_step": 70,
          "start_time": 59.01,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a74",
          "scenario": 11,
          "activation_step": 75,
          "start_time": 59.97,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s10_a73",
          "scenario": 11,
          "activation_step": 74,
          "start_time": 60.21,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s10_a72",
          "scenario": 11,
          "activation_step": 73,
          "start_time": 60.67,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s10_a71",
          "scenario": 11,
          "activation_step": 72,
          "start_time": 60.93,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s10_a70",
          "scenario": 11,
          "activation_step": 71,
          "start_time": 61.28,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a75",
          "scenario": 11,
          "activation_step": 76,
          "start_time": 62.03,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a78",
          "scenario": 11,
          "activation_step": 79,
          "start_time": 64.41,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s10_a77",
          "scenario": 11,
          "activation_step": 78,
          "start_time": 64.6,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s10_a76",
          "scenario": 11,
          "activation_step": 77,
          "start_time": 65.0,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a83",
          "scenario": 11,
          "activation_step": 84,
          "start_time": 65.33,
          "duration": 0.98,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s10_a82",
          "scenario": 11,
          "activation_step": 83,
          "start_time": 65.69,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s10_a81",
          "scenario": 11,
          "activation_step": 82,
          "start_time": 65.98,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s10_a80",
          "scenario": 11,
          "activation_step": 81,
          "start_time": 66.36,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s10_a79",
          "scenario": 11,
          "activation_step": 80,
          "start_time": 66.53,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a91",
          "scenario": 11,
          "activation_step": 92,
          "start_time": 66.69,
          "duration": 0.92,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s10_a88",
          "scenario": 11,
          "activation_step": 89,
          "start_time": 66.96,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s10_a89",
          "scenario": 11,
          "activation_step": 90,
          "start_time": 67.0,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s10_a90",
          "scenario": 11,
          "activation_step": 91,
          "start_time": 67.0,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s10_a84",
          "scenario": 11,
          "activation_step": 85,
          "start_time": 67.09,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a87",
          "scenario": 11,
          "activation_step": 88,
          "start_time": 67.13,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s10_a85",
          "scenario": 11,
          "activation_step": 86,
          "start_time": 67.15,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s10_a86",
          "scenario": 11,
          "activation_step": 87,
          "start_time": 67.19,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s10_a92",
          "scenario": 11,
          "activation_step": 93,
          "start_time": 68.47,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s10_a93",
          "scenario": 11,
          "activation_step": 94,
          "start_time": 68.61,
          "duration": 0.98,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s10_a95",
          "scenario": 11,
          "activation_step": 96,
          "start_time": 68.71,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s10_a94",
          "scenario": 11,
          "activation_step": 95,
          "start_time": 68.77,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s10_a99",
          "scenario": 11,
          "activation_step": 100,
          "start_time": 69.78,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s10_a98",
          "scenario": 11,
          "activation_step": 99,
          "start_time": 69.87,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s10_a97",
          "scenario": 11,
          "activation_step": 98,
          "start_time": 70.36,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s10_a96",
          "scenario": 11,
          "activation_step": 97,
          "start_time": 70.62,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        }
      ]
    },
    {
      "scenario_id": 12,
      "conflict_count": 65,
      "total_duration": 70.89,
      "activations": [
        {
          "id": "s11_a1",
          "scenario": 12,
          "activation_step": 2,
          "start_time": 2.81,
          "duration": 0.98,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s11_a0",
          "scenario": 12,
          "activation_step": 1,
          "start_time": 2.97,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a3",
          "scenario": 12,
          "activation_step": 4,
          "start_time": 4.5,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a2",
          "scenario": 12,
          "activation_step": 3,
          "start_time": 4.92,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a4",
          "scenario": 12,
          "activation_step": 5,
          "start_time": 6.63,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a5",
          "scenario": 12,
          "activation_step": 6,
          "start_time": 6.66,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s11_a6",
          "scenario": 12,
          "activation_step": 7,
          "start_time": 8.76,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a7",
          "scenario": 12,
          "activation_step": 8,
          "start_time": 10.61,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a8",
          "scenario": 12,
          "activation_step": 9,
          "start_time": 12.95,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a13",
          "scenario": 12,
          "activation_step": 14,
          "start_time": 14.47,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a12",
          "scenario": 12,
          "activation_step": 13,
          "start_time": 14.76,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a11",
          "scenario": 12,
          "activation_step": 12,
          "start_time": 14.95,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s11_a10",
          "scenario": 12,
          "activation_step": 11,
          "start_time": 15.09,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s11_a9",
          "scenario": 12,
          "activation_step": 10,
          "start_time": 15.17,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a17",
          "scenario": 12,
          "activation_step": 18,
          "start_time": 16.34,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a18",
          "scenario": 12,
          "activation_step": 19,
          "start_time": 16.35,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a16",
          "scenario": 12,
          "activation_step": 17,
          "start_time": 16.75,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s11_a15",
          "scenario": 12,
          "activation_step": 16,
          "start_time": 17.03,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s11_a14",
          "scenario": 12,
          "activation_step": 15,
          "start_time": 17.04,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a19",
          "scenario": 12,
          "activation_step": 20,
          "start_time": 18.33,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a20",
          "scenario": 12,
          "activation_step": 21,
          "start_time": 20.07,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a25",
          "scenario": 12,
          "activation_step": 26,
          "start_time": 21.94,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a26",
          "scenario": 12,
          "activation_step": 27,
          "start_time": 22.02,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s11_a24",
          "scenario": 12,
          "activation_step": 25,
          "start_time": 22.2,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s11_a23",
          "scenario": 12,
          "activation_step": 24,
          "start_time": 22.27,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s11_a22",
          "scenario": 12,
          "activation_step": 23,
          "start_time": 22.62,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s11_a21",
          "scenario": 12,
          "activation_step": 22,
          "start_time": 23.04,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a28",
          "scenario": 12,
          "activation_step": 29,
          "start_time": 24.19,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s11_a27",
          "scenario": 12,
          "activation_step": 28,
          "start_time": 24.3,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a36",
          "scenario": 12,
          "activation_step": 37,
          "start_time": 25.45,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a35",
          "scenario": 12,
          "activation_step": 36,
          "start_time": 25.5,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a34",
          "scenario": 12,
          "activation_step": 35,
          "start_time": 25.91,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s11_a33",
          "scenario": 12,
          "activation_step": 34,
          "start_time": 26.12,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s11_a32",
          "scenario": 12,
          "activation_step": 33,
          "start_time": 26.32,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s11_a31",
          "scenario": 12,
          "activation_step": 32,
          "start_time": 26.5,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s11_a30",
          "scenario": 12,
          "activation_step": 31,
          "start_time": 26.57,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a40",
          "scenario": 12,
          "activation_step": 41,
          "start_time": 26.76,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s11_a29",
          "scenario": 12,
          "activation_step": 30,
          "start_time": 26.84,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a39",
          "scenario": 12,
          "activation_step": 40,
          "start_time": 27.18,
          "duration": 0.92,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s11_a38",
          "scenario": 12,
          "activation_step": 39,
          "start_time": 27.24,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s11_a37",
          "scenario": 12,
          "activation_step": 38,
          "start_time": 27.43,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a41",
          "scenario": 12,
          "activation_step": 42,
          "start_time": 28.79,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a42",
          "scenario": 12,
          "activation_step": 43,
          "start_time": 31.44,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a46",
          "scenario": 12,
          "activation_step": 47,
          "start_time": 33.55,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s11_a48",
          "scenario": 12,
          "activation_step": 49,
          "start_time": 33.58,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s11_a50",
          "scenario": 12,
          "activation_step": 51,
          "start_time": 33.58,
          "duration": 0.98,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s11_a47",
          "scenario": 12,
          "activation_step": 48,
          "start_time": 33.59,
          "duration": 1.2,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a43",
          "scenario": 12,
          "activation_step": 44,
          "start_time": 33.73,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a49",
          "scenario": 12,
          "activation_step": 50,
          "start_time": 33.74,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s11_a44",
          "scenario": 12,
          "activation_step": 45,
          "start_time": 33.82,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s11_a45",
          "scenario": 12,
          "activation_step": 46,
          "start_time": 33.85,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a51",
          "scenario": 12,
          "activation_step": 52,
          "start_time": 36.11,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a52",
          "scenario": 12,
          "activation_step": 53,
          "start_time": 37.97,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a55",
          "scenario": 12,
          "activation_step": 56,
          "start_time": 39.05,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s11_a54",
          "scenario": 12,
          "activation_step": 55,
          "start_time": 39.26,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s11_a53",
          "scenario": 12,
          "activation_step": 54,
          "start_time": 39.56,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a57",
          "scenario": 12,
          "activation_step": 58,
          "start_time": 41.55,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s11_a58",
          "scenario": 12,
          "activation_step": 59,
          "start_time": 41.56,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s11_a56",
          "scenario": 12,
          "activation_step": 57,
          "start_time": 41.74,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a62",
          "scenario": 12,
          "activation_step": 63,
          "start_time": 43.84,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a60",
          "scenario": 12,
          "activation_step": 61,
          "start_time": 44.16,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a61",
          "scenario": 12,
          "activation_step": 62,
          "start_time": 44.28,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s11_a59",
          "scenario": 12,
          "activation_step": 60,
          "start_time": 44.37,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a64",
          "scenario": 12,
          "activation_step": 65,
          "start_time": 45.82,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a63",
          "scenario": 12,
          "activation_step": 64,
          "start_time": 45.95,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a66",
          "scenario": 12,
          "activation_step": 67,
          "start_time": 47.68,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s11_a65",
          "scenario": 12,
          "activation_step": 66,
          "start_time": 48.03,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a67",
          "scenario": 12,
          "activation_step": 68,
          "start_time": 50.05,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a71",
          "scenario": 12,
          "activation_step": 72,
          "start_time": 50.05,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s11_a69",
          "scenario": 12,
          "activation_step": 70,
          "start_time": 50.21,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s11_a68",
          "scenario": 12,
          "activation_step": 69,
          "start_time": 50.23,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a70",
          "scenario": 12,
          "activation_step": 71,
          "start_time": 50.23,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s11_a72",
          "scenario": 12,
          "activation_step": 73,
          "start_time": 52.5,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a73",
          "scenario": 12,
          "activation_step": 74,
          "start_time": 55.45,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a76",
          "scenario": 12,
          "activation_step": 77,
          "start_time": 56.74,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s11_a75",
          "scenario": 12,
          "activation_step": 76,
          "start_time": 56.8,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s11_a74",
          "scenario": 12,
          "activation_step": 75,
          "start_time": 57.25,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a83",
          "scenario": 12,
          "activation_step": 84,
          "start_time": 57.78,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s11_a79",
          "scenario": 12,
          "activation_step": 80,
          "start_time": 57.98,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s11_a80",
          "scenario": 12,
          "activation_step": 81,
          "start_time": 58.11,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s11_a78",
          "scenario": 12,
          "activation_step": 79,
          "start_time": 58.14,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s11_a82",
          "scenario": 12,
          "activation_step": 83,
          "start_time": 58.26,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s11_a81",
          "scenario": 12,
          "activation_step": 82,
          "start_time": 58.27,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a77",
          "scenario": 12,
          "activation_step": 78,
          "start_time": 58.44,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a86",
          "scenario": 12,
          "activation_step": 87,
          "start_time": 58.9,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s11_a85",
          "scenario": 12,
          "activation_step": 86,
          "start_time": 59.25,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s11_a84",
          "scenario": 12,
          "activation_step": 85,
          "start_time": 59.63,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a90",
          "scenario": 12,
          "activation_step": 91,
          "start_time": 60.19,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s11_a92",
          "scenario": 12,
          "activation_step": 93,
          "start_time": 60.23,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s11_a89",
          "scenario": 12,
          "activation_step": 90,
          "start_time": 60.29,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a91",
          "scenario": 12,
          "activation_step": 92,
          "start_time": 60.29,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s11_a93",
          "scenario": 12,
          "activation_step": 94,
          "start_time": 60.35,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s11_a88",
          "scenario": 12,
          "activation_step": 89,
          "start_time": 60.42,
          "duration": 0.92,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s11_a87",
          "scenario": 12,
          "activation_step": 88,
          "start_time": 60.86,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a95",
          "scenario": 12,
          "activation_step": 96,
          "start_time": 62.16,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s11_a94",
          "scenario": 12,
          "activation_step": 95,
          "start_time": 62.28,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a96",
          "scenario": 12,
          "activation_step": 97,
          "start_time": 64.79,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a97",
          "scenario": 12,
          "activation_step": 98,
          "start_time": 67.23,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s11_a99",
          "scenario": 12,
          "activation_step": 100,
          "start_time": 68.59,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s11_a98",
          "scenario": 12,
          "activation_step": 99,
          "start_time": 68.89,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        }
      ]
    },
    {
      "scenario_id": 13,
      "conflict_count": 66,
      "total_duration": 64.91,
      "activations": [
        {
          "id": "s12_a0",
          "scenario": 13,
          "activation_step": 1,
          "start_time": 0,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s12_a2",
          "scenario": 13,
          "activation_step": 3,
          "start_time": 1.95,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s12_a1",
          "scenario": 13,
          "activation_step": 2,
          "start_time": 2.31,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a9",
          "scenario": 13,
          "activation_step": 10,
          "start_time": 4.33,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s12_a7",
          "scenario": 13,
          "activation_step": 8,
          "start_time": 4.57,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s12_a6",
          "scenario": 13,
          "activation_step": 7,
          "start_time": 4.65,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s12_a5",
          "scenario": 13,
          "activation_step": 6,
          "start_time": 4.66,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s12_a8",
          "scenario": 13,
          "activation_step": 9,
          "start_time": 4.7,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s12_a3",
          "scenario": 13,
          "activation_step": 4,
          "start_time": 4.91,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a4",
          "scenario": 13,
          "activation_step": 5,
          "start_time": 5.03,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s12_a11",
          "scenario": 13,
          "activation_step": 12,
          "start_time": 5.99,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s12_a10",
          "scenario": 13,
          "activation_step": 11,
          "start_time": 6.01,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a16",
          "scenario": 13,
          "activation_step": 17,
          "start_time": 6.6,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s12_a15",
          "scenario": 13,
          "activation_step": 16,
          "start_time": 6.86,
          "duration": 0.94,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s12_a14",
          "scenario": 13,
          "activation_step": 15,
          "start_time": 7.32,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s12_a13",
          "scenario": 13,
          "activation_step": 14,
          "start_time": 7.76,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s12_a12",
          "scenario": 13,
          "activation_step": 13,
          "start_time": 7.79,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a18",
          "scenario": 13,
          "activation_step": 19,
          "start_time": 8.06,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s12_a19",
          "scenario": 13,
          "activation_step": 20,
          "start_time": 8.12,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s12_a20",
          "scenario": 13,
          "activation_step": 21,
          "start_time": 8.26,
          "duration": 0.94,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s12_a17",
          "scenario": 13,
          "activation_step": 18,
          "start_time": 8.41,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a21",
          "scenario": 13,
          "activation_step": 22,
          "start_time": 10.38,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a22",
          "scenario": 13,
          "activation_step": 23,
          "start_time": 12.66,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a23",
          "scenario": 13,
          "activation_step": 24,
          "start_time": 14.17,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a24",
          "scenario": 13,
          "activation_step": 25,
          "start_time": 15.8,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a25",
          "scenario": 13,
          "activation_step": 26,
          "start_time": 16.0,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s12_a29",
          "scenario": 13,
          "activation_step": 30,
          "start_time": 18.18,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s12_a28",
          "scenario": 13,
          "activation_step": 29,
          "start_time": 18.21,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s12_a26",
          "scenario": 13,
          "activation_step": 27,
          "start_time": 18.31,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a27",
          "scenario": 13,
          "activation_step": 28,
          "start_time": 18.4,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s12_a30",
          "scenario": 13,
          "activation_step": 31,
          "start_time": 21.02,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a31",
          "scenario": 13,
          "activation_step": 32,
          "start_time": 22.89,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a33",
          "scenario": 13,
          "activation_step": 34,
          "start_time": 24.64,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s12_a40",
          "scenario": 13,
          "activation_step": 41,
          "start_time": 24.82,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s12_a39",
          "scenario": 13,
          "activation_step": 40,
          "start_time": 24.9,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s12_a41",
          "scenario": 13,
          "activation_step": 42,
          "start_time": 24.9,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s12_a32",
          "scenario": 13,
          "activation_step": 33,
          "start_time": 25.13,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a37",
          "scenario": 13,
          "activation_step": 38,
          "start_time": 25.14,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s12_a38",
          "scenario": 13,
          "activation_step": 39,
          "start_time": 25.22,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s12_a36",
          "scenario": 13,
          "activation_step": 37,
          "start_time": 25.61,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s12_a35",
          "scenario": 13,
          "activation_step": 36,
          "start_time": 25.87,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s12_a44",
          "scenario": 13,
          "activation_step": 45,
          "start_time": 25.96,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s12_a47",
          "scenario": 13,
          "activation_step": 48,
          "start_time": 25.97,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s12_a45",
          "scenario": 13,
          "activation_step": 46,
          "start_time": 25.98,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s12_a46",
          "scenario": 13,
          "activation_step": 47,
          "start_time": 26.12,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s12_a48",
          "scenario": 13,
          "activation_step": 49,
          "start_time": 26.14,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s12_a34",
          "scenario": 13,
          "activation_step": 35,
          "start_time": 26.2,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a43",
          "scenario": 13,
          "activation_step": 44,
          "start_time": 26.27,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s12_a42",
          "scenario": 13,
          "activation_step": 43,
          "start_time": 26.72,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a51",
          "scenario": 13,
          "activation_step": 52,
          "start_time": 26.96,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s12_a52",
          "scenario": 13,
          "activation_step": 53,
          "start_time": 27.1,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s12_a50",
          "scenario": 13,
          "activation_step": 51,
          "start_time": 27.41,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s12_a49",
          "scenario": 13,
          "activation_step": 50,
          "start_time": 27.67,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a54",
          "scenario": 13,
          "activation_step": 55,
          "start_time": 28.76,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s12_a53",
          "scenario": 13,
          "activation_step": 54,
          "start_time": 28.97,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a55",
          "scenario": 13,
          "activation_step": 56,
          "start_time": 30.65,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a57",
          "scenario": 13,
          "activation_step": 58,
          "start_time": 32.16,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s12_a56",
          "scenario": 13,
          "activation_step": 57,
          "start_time": 32.39,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a58",
          "scenario": 13,
          "activation_step": 59,
          "start_time": 34.02,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a59",
          "scenario": 13,
          "activation_step": 60,
          "start_time": 35.73,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a64",
          "scenario": 13,
          "activation_step": 65,
          "start_time": 37.14,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s12_a63",
          "scenario": 13,
          "activation_step": 64,
          "start_time": 37.32,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s12_a62",
          "scenario": 13,
          "activation_step": 63,
          "start_time": 37.55,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s12_a60",
          "scenario": 13,
          "activation_step": 61,
          "start_time": 37.89,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a61",
          "scenario": 13,
          "activation_step": 62,
          "start_time": 38.01,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s12_a65",
          "scenario": 13,
          "activation_step": 66,
          "start_time": 39.29,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a67",
          "scenario": 13,
          "activation_step": 68,
          "start_time": 41.26,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s12_a66",
          "scenario": 13,
          "activation_step": 67,
          "start_time": 41.56,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a68",
          "scenario": 13,
          "activation_step": 69,
          "start_time": 44.03,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a71",
          "scenario": 13,
          "activation_step": 72,
          "start_time": 45.39,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s12_a70",
          "scenario": 13,
          "activation_step": 71,
          "start_time": 45.59,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s12_a69",
          "scenario": 13,
          "activation_step": 70,
          "start_time": 45.96,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a72",
          "scenario": 13,
          "activation_step": 73,
          "start_time": 47.9,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a73",
          "scenario": 13,
          "activation_step": 74,
          "start_time": 48.02,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s12_a76",
          "scenario": 13,
          "activation_step": 77,
          "start_time": 49.36,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s12_a75",
          "scenario": 13,
          "activation_step": 76,
          "start_time": 49.85,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s12_a74",
          "scenario": 13,
          "activation_step": 75,
          "start_time": 50.27,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a79",
          "scenario": 13,
          "activation_step": 80,
          "start_time": 52.2,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s12_a78",
          "scenario": 13,
          "activation_step": 79,
          "start_time": 52.21,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s12_a77",
          "scenario": 13,
          "activation_step": 78,
          "start_time": 52.27,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a80",
          "scenario": 13,
          "activation_step": 81,
          "start_time": 52.28,
          "duration": 1.2,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s12_a85",
          "scenario": 13,
          "activation_step": 86,
          "start_time": 53.83,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s12_a86",
          "scenario": 13,
          "activation_step": 87,
          "start_time": 53.85,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s12_a84",
          "scenario": 13,
          "activation_step": 85,
          "start_time": 53.93,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s12_a82",
          "scenario": 13,
          "activation_step": 83,
          "start_time": 54.06,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s12_a81",
          "scenario": 13,
          "activation_step": 82,
          "start_time": 54.17,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a83",
          "scenario": 13,
          "activation_step": 84,
          "start_time": 54.21,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s12_a92",
          "scenario": 13,
          "activation_step": 93,
          "start_time": 55.15,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s12_a91",
          "scenario": 13,
          "activation_step": 92,
          "start_time": 55.58,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s12_a89",
          "scenario": 13,
          "activation_step": 90,
          "start_time": 55.81,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s12_a90",
          "scenario": 13,
          "activation_step": 91,
          "start_time": 55.94,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s12_a88",
          "scenario": 13,
          "activation_step": 89,
          "start_time": 56.07,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s12_a87",
          "scenario": 13,
          "activation_step": 88,
          "start_time": 56.2,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a93",
          "scenario": 13,
          "activation_step": 94,
          "start_time": 57.46,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a94",
          "scenario": 13,
          "activation_step": 95,
          "start_time": 60.37,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s12_a98",
          "scenario": 13,
          "activation_step": 99,
          "start_time": 62.15,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s12_a99",
          "scenario": 13,
          "activation_step": 100,
          "start_time": 62.23,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s12_a97",
          "scenario": 13,
          "activation_step": 98,
          "start_time": 62.55,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s12_a96",
          "scenario": 13,
          "activation_step": 97,
          "start_time": 62.85,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s12_a95",
          "scenario": 13,
          "activation_step": 96,
          "start_time": 62.91,
          "duration": 0.8,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        }
      ]
    },
    {
      "scenario_id": 14,
      "conflict_count": 63,
      "total_duration": 73.09,
      "activations": [
        {
          "id": "s13_a0",
          "scenario": 14,
          "activation_step": 1,
          "start_time": 0,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a1",
          "scenario": 14,
          "activation_step": 2,
          "start_time": 2.27,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a2",
          "scenario": 14,
          "activation_step": 3,
          "start_time": 3.94,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a4",
          "scenario": 14,
          "activation_step": 5,
          "start_time": 6.02,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s13_a3",
          "scenario": 14,
          "activation_step": 4,
          "start_time": 6.13,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a10",
          "scenario": 14,
          "activation_step": 11,
          "start_time": 7.07,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a9",
          "scenario": 14,
          "activation_step": 10,
          "start_time": 7.19,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s13_a8",
          "scenario": 14,
          "activation_step": 9,
          "start_time": 7.48,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s13_a7",
          "scenario": 14,
          "activation_step": 8,
          "start_time": 7.54,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s13_a6",
          "scenario": 14,
          "activation_step": 7,
          "start_time": 7.75,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a5",
          "scenario": 14,
          "activation_step": 6,
          "start_time": 8.07,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a12",
          "scenario": 14,
          "activation_step": 13,
          "start_time": 9.31,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s13_a11",
          "scenario": 14,
          "activation_step": 12,
          "start_time": 9.47,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a15",
          "scenario": 14,
          "activation_step": 16,
          "start_time": 10.85,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a14",
          "scenario": 14,
          "activation_step": 15,
          "start_time": 11.27,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s13_a13",
          "scenario": 14,
          "activation_step": 14,
          "start_time": 11.42,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a17",
          "scenario": 14,
          "activation_step": 18,
          "start_time": 12.03,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a16",
          "scenario": 14,
          "activation_step": 17,
          "start_time": 12.44,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a19",
          "scenario": 14,
          "activation_step": 20,
          "start_time": 14.04,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s13_a18",
          "scenario": 14,
          "activation_step": 19,
          "start_time": 14.16,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a20",
          "scenario": 14,
          "activation_step": 21,
          "start_time": 17.03,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a24",
          "scenario": 14,
          "activation_step": 25,
          "start_time": 18.93,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s13_a23",
          "scenario": 14,
          "activation_step": 24,
          "start_time": 19.3,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s13_a21",
          "scenario": 14,
          "activation_step": 22,
          "start_time": 19.53,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a22",
          "scenario": 14,
          "activation_step": 23,
          "start_time": 19.54,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s13_a25",
          "scenario": 14,
          "activation_step": 26,
          "start_time": 20.87,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a29",
          "scenario": 14,
          "activation_step": 30,
          "start_time": 21.63,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s13_a28",
          "scenario": 14,
          "activation_step": 29,
          "start_time": 22.13,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s13_a27",
          "scenario": 14,
          "activation_step": 28,
          "start_time": 22.55,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s13_a26",
          "scenario": 14,
          "activation_step": 27,
          "start_time": 22.6,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a30",
          "scenario": 14,
          "activation_step": 31,
          "start_time": 23.73,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a35",
          "scenario": 14,
          "activation_step": 36,
          "start_time": 25.76,
          "duration": 1.2,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a31",
          "scenario": 14,
          "activation_step": 32,
          "start_time": 25.9,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a34",
          "scenario": 14,
          "activation_step": 35,
          "start_time": 25.92,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s13_a33",
          "scenario": 14,
          "activation_step": 34,
          "start_time": 25.95,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a32",
          "scenario": 14,
          "activation_step": 33,
          "start_time": 26.04,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s13_a36",
          "scenario": 14,
          "activation_step": 37,
          "start_time": 27.84,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a38",
          "scenario": 14,
          "activation_step": 39,
          "start_time": 30.27,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a37",
          "scenario": 14,
          "activation_step": 38,
          "start_time": 30.53,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a41",
          "scenario": 14,
          "activation_step": 42,
          "start_time": 31.8,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s13_a39",
          "scenario": 14,
          "activation_step": 40,
          "start_time": 32.07,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a40",
          "scenario": 14,
          "activation_step": 41,
          "start_time": 32.15,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s13_a46",
          "scenario": 14,
          "activation_step": 47,
          "start_time": 33.57,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s13_a45",
          "scenario": 14,
          "activation_step": 46,
          "start_time": 33.82,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s13_a44",
          "scenario": 14,
          "activation_step": 45,
          "start_time": 33.88,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a43",
          "scenario": 14,
          "activation_step": 44,
          "start_time": 34.06,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s13_a55",
          "scenario": 14,
          "activation_step": 56,
          "start_time": 34.24,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a42",
          "scenario": 14,
          "activation_step": 43,
          "start_time": 34.29,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a54",
          "scenario": 14,
          "activation_step": 55,
          "start_time": 34.61,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a53",
          "scenario": 14,
          "activation_step": 54,
          "start_time": 35.09,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a52",
          "scenario": 14,
          "activation_step": 53,
          "start_time": 35.12,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s13_a51",
          "scenario": 14,
          "activation_step": 52,
          "start_time": 35.26,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s13_a50",
          "scenario": 14,
          "activation_step": 51,
          "start_time": 35.54,
          "duration": 1.1,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s13_a49",
          "scenario": 14,
          "activation_step": 50,
          "start_time": 36.0,
          "duration": 0.98,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s13_a48",
          "scenario": 14,
          "activation_step": 49,
          "start_time": 36.11,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s13_a56",
          "scenario": 14,
          "activation_step": 57,
          "start_time": 36.43,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a47",
          "scenario": 14,
          "activation_step": 48,
          "start_time": 36.54,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a57",
          "scenario": 14,
          "activation_step": 58,
          "start_time": 37.95,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a64",
          "scenario": 14,
          "activation_step": 65,
          "start_time": 39.01,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s13_a62",
          "scenario": 14,
          "activation_step": 63,
          "start_time": 39.03,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a63",
          "scenario": 14,
          "activation_step": 64,
          "start_time": 39.03,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a61",
          "scenario": 14,
          "activation_step": 62,
          "start_time": 39.27,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s13_a60",
          "scenario": 14,
          "activation_step": 61,
          "start_time": 39.53,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s13_a59",
          "scenario": 14,
          "activation_step": 60,
          "start_time": 39.55,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a58",
          "scenario": 14,
          "activation_step": 59,
          "start_time": 39.85,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a68",
          "scenario": 14,
          "activation_step": 69,
          "start_time": 41.59,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a67",
          "scenario": 14,
          "activation_step": 68,
          "start_time": 41.77,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s13_a65",
          "scenario": 14,
          "activation_step": 66,
          "start_time": 41.93,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a66",
          "scenario": 14,
          "activation_step": 67,
          "start_time": 41.93,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a69",
          "scenario": 14,
          "activation_step": 70,
          "start_time": 43.9,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a70",
          "scenario": 14,
          "activation_step": 71,
          "start_time": 43.95,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s13_a73",
          "scenario": 14,
          "activation_step": 74,
          "start_time": 45.76,
          "duration": 0.98,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s13_a72",
          "scenario": 14,
          "activation_step": 73,
          "start_time": 46.22,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s13_a71",
          "scenario": 14,
          "activation_step": 72,
          "start_time": 46.46,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a74",
          "scenario": 14,
          "activation_step": 75,
          "start_time": 47.95,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a75",
          "scenario": 14,
          "activation_step": 76,
          "start_time": 48.14,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a78",
          "scenario": 14,
          "activation_step": 79,
          "start_time": 49.57,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a76",
          "scenario": 14,
          "activation_step": 77,
          "start_time": 49.75,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a77",
          "scenario": 14,
          "activation_step": 78,
          "start_time": 49.79,
          "duration": 0.94,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s13_a79",
          "scenario": 14,
          "activation_step": 80,
          "start_time": 51.4,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a80",
          "scenario": 14,
          "activation_step": 81,
          "start_time": 51.59,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s13_a81",
          "scenario": 14,
          "activation_step": 82,
          "start_time": 53.38,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a83",
          "scenario": 14,
          "activation_step": 84,
          "start_time": 55.73,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s13_a82",
          "scenario": 14,
          "activation_step": 83,
          "start_time": 55.98,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a88",
          "scenario": 14,
          "activation_step": 89,
          "start_time": 56.6,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s13_a89",
          "scenario": 14,
          "activation_step": 90,
          "start_time": 56.78,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s13_a86",
          "scenario": 14,
          "activation_step": 87,
          "start_time": 56.82,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s13_a87",
          "scenario": 14,
          "activation_step": 88,
          "start_time": 56.84,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s13_a85",
          "scenario": 14,
          "activation_step": 86,
          "start_time": 57.26,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s13_a84",
          "scenario": 14,
          "activation_step": 85,
          "start_time": 57.64,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a90",
          "scenario": 14,
          "activation_step": 91,
          "start_time": 58.89,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a91",
          "scenario": 14,
          "activation_step": 92,
          "start_time": 61.56,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a93",
          "scenario": 14,
          "activation_step": 94,
          "start_time": 63.65,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s13_a92",
          "scenario": 14,
          "activation_step": 93,
          "start_time": 64.0,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a94",
          "scenario": 14,
          "activation_step": 95,
          "start_time": 66.23,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a97",
          "scenario": 14,
          "activation_step": 98,
          "start_time": 69.09,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s13_a96",
          "scenario": 14,
          "activation_step": 97,
          "start_time": 69.1,
          "duration": 1.2,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s13_a95",
          "scenario": 14,
          "activation_step": 96,
          "start_time": 69.13,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s13_a99",
          "scenario": 14,
          "activation_step": 100,
          "start_time": 70.81,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s13_a98",
          "scenario": 14,
          "activation_step": 99,
          "start_time": 71.09,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        }
      ]
    },
    {
      "scenario_id": 15,
      "conflict_count": 67,
      "total_duration": 62.62,
      "activations": [
        {
          "id": "s14_a1",
          "scenario": 15,
          "activation_step": 2,
          "start_time": 0,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a2",
          "scenario": 15,
          "activation_step": 3,
          "start_time": 0,
          "duration": 0.94,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a3",
          "scenario": 15,
          "activation_step": 4,
          "start_time": 0,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s14_a4",
          "scenario": 15,
          "activation_step": 5,
          "start_time": 0,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s14_a5",
          "scenario": 15,
          "activation_step": 6,
          "start_time": 0,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a0",
          "scenario": 15,
          "activation_step": 1,
          "start_time": 0.11,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s14_a10",
          "scenario": 15,
          "activation_step": 11,
          "start_time": 0.65,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s14_a9",
          "scenario": 15,
          "activation_step": 10,
          "start_time": 1.14,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s14_a8",
          "scenario": 15,
          "activation_step": 9,
          "start_time": 1.61,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s14_a18",
          "scenario": 15,
          "activation_step": 19,
          "start_time": 1.66,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s14_a19",
          "scenario": 15,
          "activation_step": 20,
          "start_time": 1.72,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s14_a7",
          "scenario": 15,
          "activation_step": 8,
          "start_time": 1.93,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s14_a17",
          "scenario": 15,
          "activation_step": 18,
          "start_time": 1.93,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s14_a6",
          "scenario": 15,
          "activation_step": 7,
          "start_time": 2.16,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a16",
          "scenario": 15,
          "activation_step": 17,
          "start_time": 2.22,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s14_a15",
          "scenario": 15,
          "activation_step": 16,
          "start_time": 2.47,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s14_a14",
          "scenario": 15,
          "activation_step": 15,
          "start_time": 2.81,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s14_a11",
          "scenario": 15,
          "activation_step": 12,
          "start_time": 2.83,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a12",
          "scenario": 15,
          "activation_step": 13,
          "start_time": 2.98,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a13",
          "scenario": 15,
          "activation_step": 14,
          "start_time": 3.13,
          "duration": 0.98,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a20",
          "scenario": 15,
          "activation_step": 21,
          "start_time": 3.67,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a22",
          "scenario": 15,
          "activation_step": 23,
          "start_time": 3.78,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s14_a21",
          "scenario": 15,
          "activation_step": 22,
          "start_time": 3.82,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a24",
          "scenario": 15,
          "activation_step": 25,
          "start_time": 5.63,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s14_a23",
          "scenario": 15,
          "activation_step": 24,
          "start_time": 5.84,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a25",
          "scenario": 15,
          "activation_step": 26,
          "start_time": 8.42,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a27",
          "scenario": 15,
          "activation_step": 28,
          "start_time": 9.64,
          "duration": 0.98,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a26",
          "scenario": 15,
          "activation_step": 27,
          "start_time": 9.93,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a28",
          "scenario": 15,
          "activation_step": 29,
          "start_time": 12.26,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a29",
          "scenario": 15,
          "activation_step": 30,
          "start_time": 12.34,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a30",
          "scenario": 15,
          "activation_step": 31,
          "start_time": 12.34,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s14_a34",
          "scenario": 15,
          "activation_step": 35,
          "start_time": 13.1,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a33",
          "scenario": 15,
          "activation_step": 34,
          "start_time": 13.28,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s14_a32",
          "scenario": 15,
          "activation_step": 33,
          "start_time": 13.53,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a39",
          "scenario": 15,
          "activation_step": 40,
          "start_time": 13.85,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s14_a41",
          "scenario": 15,
          "activation_step": 42,
          "start_time": 13.86,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s14_a31",
          "scenario": 15,
          "activation_step": 32,
          "start_time": 13.88,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a40",
          "scenario": 15,
          "activation_step": 41,
          "start_time": 13.9,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s14_a38",
          "scenario": 15,
          "activation_step": 39,
          "start_time": 14.23,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s14_a37",
          "scenario": 15,
          "activation_step": 38,
          "start_time": 14.57,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a35",
          "scenario": 15,
          "activation_step": 36,
          "start_time": 14.72,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a36",
          "scenario": 15,
          "activation_step": 37,
          "start_time": 14.75,
          "duration": 0.84,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s14_a45",
          "scenario": 15,
          "activation_step": 46,
          "start_time": 15.29,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s14_a46",
          "scenario": 15,
          "activation_step": 47,
          "start_time": 15.41,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s14_a47",
          "scenario": 15,
          "activation_step": 48,
          "start_time": 15.6,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s14_a43",
          "scenario": 15,
          "activation_step": 44,
          "start_time": 15.67,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s14_a44",
          "scenario": 15,
          "activation_step": 45,
          "start_time": 15.79,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s14_a42",
          "scenario": 15,
          "activation_step": 43,
          "start_time": 16.14,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a48",
          "scenario": 15,
          "activation_step": 49,
          "start_time": 17.35,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a49",
          "scenario": 15,
          "activation_step": 50,
          "start_time": 19.35,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a52",
          "scenario": 15,
          "activation_step": 53,
          "start_time": 21.6,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s14_a51",
          "scenario": 15,
          "activation_step": 52,
          "start_time": 21.64,
          "duration": 0.92,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s14_a53",
          "scenario": 15,
          "activation_step": 54,
          "start_time": 21.65,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s14_a54",
          "scenario": 15,
          "activation_step": 55,
          "start_time": 21.69,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s14_a50",
          "scenario": 15,
          "activation_step": 51,
          "start_time": 21.84,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a55",
          "scenario": 15,
          "activation_step": 56,
          "start_time": 21.87,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a56",
          "scenario": 15,
          "activation_step": 57,
          "start_time": 24.0,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a57",
          "scenario": 15,
          "activation_step": 58,
          "start_time": 26.91,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a64",
          "scenario": 15,
          "activation_step": 65,
          "start_time": 27.13,
          "duration": 0.98,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s14_a63",
          "scenario": 15,
          "activation_step": 64,
          "start_time": 27.17,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s14_a62",
          "scenario": 15,
          "activation_step": 63,
          "start_time": 27.61,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s14_a61",
          "scenario": 15,
          "activation_step": 62,
          "start_time": 27.71,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a60",
          "scenario": 15,
          "activation_step": 61,
          "start_time": 27.72,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s14_a59",
          "scenario": 15,
          "activation_step": 60,
          "start_time": 27.99,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a58",
          "scenario": 15,
          "activation_step": 59,
          "start_time": 28.42,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a70",
          "scenario": 15,
          "activation_step": 71,
          "start_time": 28.7,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s14_a68",
          "scenario": 15,
          "activation_step": 69,
          "start_time": 29.05,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a69",
          "scenario": 15,
          "activation_step": 70,
          "start_time": 29.1,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s14_a67",
          "scenario": 15,
          "activation_step": 68,
          "start_time": 29.46,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a66",
          "scenario": 15,
          "activation_step": 67,
          "start_time": 29.82,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a65",
          "scenario": 15,
          "activation_step": 66,
          "start_time": 29.87,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a71",
          "scenario": 15,
          "activation_step": 72,
          "start_time": 31.03,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a72",
          "scenario": 15,
          "activation_step": 73,
          "start_time": 33.67,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a74",
          "scenario": 15,
          "activation_step": 75,
          "start_time": 35.39,
          "duration": 0.9,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s14_a73",
          "scenario": 15,
          "activation_step": 74,
          "start_time": 35.84,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a75",
          "scenario": 15,
          "activation_step": 76,
          "start_time": 37.91,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a76",
          "scenario": 15,
          "activation_step": 77,
          "start_time": 39.84,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a78",
          "scenario": 15,
          "activation_step": 79,
          "start_time": 41.46,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Call Volume (>114k)"
        },
        {
          "id": "s14_a77",
          "scenario": 15,
          "activation_step": 78,
          "start_time": 41.71,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a79",
          "scenario": 15,
          "activation_step": 80,
          "start_time": 44.29,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a80",
          "scenario": 15,
          "activation_step": 81,
          "start_time": 45.81,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a82",
          "scenario": 15,
          "activation_step": 83,
          "start_time": 48.11,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s14_a81",
          "scenario": 15,
          "activation_step": 82,
          "start_time": 48.52,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a83",
          "scenario": 15,
          "activation_step": 84,
          "start_time": 49.98,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a85",
          "scenario": 15,
          "activation_step": 86,
          "start_time": 51.39,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s14_a84",
          "scenario": 15,
          "activation_step": 85,
          "start_time": 51.73,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a91",
          "scenario": 15,
          "activation_step": 92,
          "start_time": 52.63,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s14_a88",
          "scenario": 15,
          "activation_step": 89,
          "start_time": 52.96,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a90",
          "scenario": 15,
          "activation_step": 91,
          "start_time": 53.06,
          "duration": 0.92,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s14_a89",
          "scenario": 15,
          "activation_step": 90,
          "start_time": 53.13,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s14_a86",
          "scenario": 15,
          "activation_step": 87,
          "start_time": 53.2,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a87",
          "scenario": 15,
          "activation_step": 88,
          "start_time": 53.32,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s14_a92",
          "scenario": 15,
          "activation_step": 93,
          "start_time": 54.86,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a93",
          "scenario": 15,
          "activation_step": 94,
          "start_time": 56.92,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a98",
          "scenario": 15,
          "activation_step": 99,
          "start_time": 58.68,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: High Data Available CTR"
        },
        {
          "id": "s14_a97",
          "scenario": 15,
          "activation_step": 98,
          "start_time": 58.93,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Inter-Frequency Interference"
        },
        {
          "id": "s14_a95",
          "scenario": 15,
          "activation_step": 96,
          "start_time": 59.04,
          "duration": 0.98,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: Max RRC Connections Exceeded"
        },
        {
          "id": "s14_a96",
          "scenario": 15,
          "activation_step": 97,
          "start_time": 59.04,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Improper Sequencing: DL Latency > 7.31ms"
        },
        {
          "id": "s14_a94",
          "scenario": 15,
          "activation_step": 95,
          "start_time": 59.36,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        },
        {
          "id": "s14_a99",
          "scenario": 15,
          "activation_step": 100,
          "start_time": 60.62,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Optimal Execution"
        }
      ]
    }
  ],
  "ncf": [
    {
      "scenario_id": 1,
      "conflict_count": 6,
      "total_duration": 137.55,
      "activations": [
        {
          "id": "s0_a0",
          "scenario": 1,
          "activation_step": 1,
          "start_time": 0.31,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a1",
          "scenario": 1,
          "activation_step": 2,
          "start_time": 1.57,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a2",
          "scenario": 1,
          "activation_step": 3,
          "start_time": 3.18,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a3",
          "scenario": 1,
          "activation_step": 4,
          "start_time": 4.42,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a4",
          "scenario": 1,
          "activation_step": 5,
          "start_time": 5.92,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a5",
          "scenario": 1,
          "activation_step": 6,
          "start_time": 7.33,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a6",
          "scenario": 1,
          "activation_step": 7,
          "start_time": 8.5,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a7",
          "scenario": 1,
          "activation_step": 8,
          "start_time": 9.9,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a8",
          "scenario": 1,
          "activation_step": 9,
          "start_time": 11.26,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a9",
          "scenario": 1,
          "activation_step": 10,
          "start_time": 12.64,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a10",
          "scenario": 1,
          "activation_step": 11,
          "start_time": 14.21,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a11",
          "scenario": 1,
          "activation_step": 12,
          "start_time": 15.46,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a12",
          "scenario": 1,
          "activation_step": 13,
          "start_time": 16.94,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a13",
          "scenario": 1,
          "activation_step": 14,
          "start_time": 18.38,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a14",
          "scenario": 1,
          "activation_step": 15,
          "start_time": 19.76,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a15",
          "scenario": 1,
          "activation_step": 16,
          "start_time": 21.12,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a16",
          "scenario": 1,
          "activation_step": 17,
          "start_time": 22.56,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a17",
          "scenario": 1,
          "activation_step": 18,
          "start_time": 23.68,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a18",
          "scenario": 1,
          "activation_step": 19,
          "start_time": 25.04,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a19",
          "scenario": 1,
          "activation_step": 20,
          "start_time": 26.38,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a20",
          "scenario": 1,
          "activation_step": 21,
          "start_time": 27.82,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a21",
          "scenario": 1,
          "activation_step": 22,
          "start_time": 28.93,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s0_a22",
          "scenario": 1,
          "activation_step": 23,
          "start_time": 30.36,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a23",
          "scenario": 1,
          "activation_step": 24,
          "start_time": 31.9,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a24",
          "scenario": 1,
          "activation_step": 25,
          "start_time": 33.26,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a25",
          "scenario": 1,
          "activation_step": 26,
          "start_time": 34.88,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a26",
          "scenario": 1,
          "activation_step": 27,
          "start_time": 36.23,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a27",
          "scenario": 1,
          "activation_step": 28,
          "start_time": 37.63,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a28",
          "scenario": 1,
          "activation_step": 29,
          "start_time": 38.98,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a29",
          "scenario": 1,
          "activation_step": 30,
          "start_time": 40.28,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a30",
          "scenario": 1,
          "activation_step": 31,
          "start_time": 41.14,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s0_a31",
          "scenario": 1,
          "activation_step": 32,
          "start_time": 42.54,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a32",
          "scenario": 1,
          "activation_step": 33,
          "start_time": 43.81,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a33",
          "scenario": 1,
          "activation_step": 34,
          "start_time": 45.44,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a34",
          "scenario": 1,
          "activation_step": 35,
          "start_time": 46.85,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a35",
          "scenario": 1,
          "activation_step": 36,
          "start_time": 48.4,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a36",
          "scenario": 1,
          "activation_step": 37,
          "start_time": 49.82,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a37",
          "scenario": 1,
          "activation_step": 38,
          "start_time": 51.03,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a38",
          "scenario": 1,
          "activation_step": 39,
          "start_time": 52.38,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a39",
          "scenario": 1,
          "activation_step": 40,
          "start_time": 53.93,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a40",
          "scenario": 1,
          "activation_step": 41,
          "start_time": 55.23,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a41",
          "scenario": 1,
          "activation_step": 42,
          "start_time": 56.49,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a42",
          "scenario": 1,
          "activation_step": 43,
          "start_time": 57.89,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a43",
          "scenario": 1,
          "activation_step": 44,
          "start_time": 59.43,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a44",
          "scenario": 1,
          "activation_step": 45,
          "start_time": 60.93,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a45",
          "scenario": 1,
          "activation_step": 46,
          "start_time": 62.3,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a46",
          "scenario": 1,
          "activation_step": 47,
          "start_time": 63.72,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a47",
          "scenario": 1,
          "activation_step": 48,
          "start_time": 64.86,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s0_a48",
          "scenario": 1,
          "activation_step": 49,
          "start_time": 66.37,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a49",
          "scenario": 1,
          "activation_step": 50,
          "start_time": 67.71,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a50",
          "scenario": 1,
          "activation_step": 51,
          "start_time": 69.01,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a51",
          "scenario": 1,
          "activation_step": 52,
          "start_time": 70.38,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a52",
          "scenario": 1,
          "activation_step": 53,
          "start_time": 71.64,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a53",
          "scenario": 1,
          "activation_step": 54,
          "start_time": 73.04,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a54",
          "scenario": 1,
          "activation_step": 55,
          "start_time": 74.31,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a55",
          "scenario": 1,
          "activation_step": 56,
          "start_time": 75.66,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a56",
          "scenario": 1,
          "activation_step": 57,
          "start_time": 76.86,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a57",
          "scenario": 1,
          "activation_step": 58,
          "start_time": 78.44,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a58",
          "scenario": 1,
          "activation_step": 59,
          "start_time": 79.57,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a59",
          "scenario": 1,
          "activation_step": 60,
          "start_time": 81.12,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a60",
          "scenario": 1,
          "activation_step": 61,
          "start_time": 82.63,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a61",
          "scenario": 1,
          "activation_step": 62,
          "start_time": 84.1,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a62",
          "scenario": 1,
          "activation_step": 63,
          "start_time": 85.72,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a63",
          "scenario": 1,
          "activation_step": 64,
          "start_time": 86.95,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a64",
          "scenario": 1,
          "activation_step": 65,
          "start_time": 88.6,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a65",
          "scenario": 1,
          "activation_step": 66,
          "start_time": 90.2,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a66",
          "scenario": 1,
          "activation_step": 67,
          "start_time": 91.73,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a67",
          "scenario": 1,
          "activation_step": 68,
          "start_time": 93.28,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a68",
          "scenario": 1,
          "activation_step": 69,
          "start_time": 94.64,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a69",
          "scenario": 1,
          "activation_step": 70,
          "start_time": 95.75,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s0_a70",
          "scenario": 1,
          "activation_step": 71,
          "start_time": 97.2,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a71",
          "scenario": 1,
          "activation_step": 72,
          "start_time": 98.56,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a72",
          "scenario": 1,
          "activation_step": 73,
          "start_time": 99.53,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s0_a73",
          "scenario": 1,
          "activation_step": 74,
          "start_time": 100.92,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a74",
          "scenario": 1,
          "activation_step": 75,
          "start_time": 102.29,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a75",
          "scenario": 1,
          "activation_step": 76,
          "start_time": 103.26,
          "duration": 0.82,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s0_a76",
          "scenario": 1,
          "activation_step": 77,
          "start_time": 104.33,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a77",
          "scenario": 1,
          "activation_step": 78,
          "start_time": 105.94,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a78",
          "scenario": 1,
          "activation_step": 79,
          "start_time": 107.03,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a79",
          "scenario": 1,
          "activation_step": 80,
          "start_time": 108.25,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a80",
          "scenario": 1,
          "activation_step": 81,
          "start_time": 109.59,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a81",
          "scenario": 1,
          "activation_step": 82,
          "start_time": 110.69,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a82",
          "scenario": 1,
          "activation_step": 83,
          "start_time": 112.18,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a83",
          "scenario": 1,
          "activation_step": 84,
          "start_time": 113.37,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a84",
          "scenario": 1,
          "activation_step": 85,
          "start_time": 114.74,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a85",
          "scenario": 1,
          "activation_step": 86,
          "start_time": 116.14,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a86",
          "scenario": 1,
          "activation_step": 87,
          "start_time": 117.71,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a87",
          "scenario": 1,
          "activation_step": 88,
          "start_time": 119.22,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a88",
          "scenario": 1,
          "activation_step": 89,
          "start_time": 120.78,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a89",
          "scenario": 1,
          "activation_step": 90,
          "start_time": 122.32,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a90",
          "scenario": 1,
          "activation_step": 91,
          "start_time": 123.72,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a91",
          "scenario": 1,
          "activation_step": 92,
          "start_time": 125.32,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a92",
          "scenario": 1,
          "activation_step": 93,
          "start_time": 126.93,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a93",
          "scenario": 1,
          "activation_step": 94,
          "start_time": 128.03,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a94",
          "scenario": 1,
          "activation_step": 95,
          "start_time": 129.15,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a95",
          "scenario": 1,
          "activation_step": 96,
          "start_time": 130.48,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a96",
          "scenario": 1,
          "activation_step": 97,
          "start_time": 131.59,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a97",
          "scenario": 1,
          "activation_step": 98,
          "start_time": 132.9,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a98",
          "scenario": 1,
          "activation_step": 99,
          "start_time": 134.2,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s0_a99",
          "scenario": 1,
          "activation_step": 100,
          "start_time": 135.55,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        }
      ]
    },
    {
      "scenario_id": 2,
      "conflict_count": 7,
      "total_duration": 134.3,
      "activations": [
        {
          "id": "s1_a0",
          "scenario": 2,
          "activation_step": 1,
          "start_time": 0.36,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a1",
          "scenario": 2,
          "activation_step": 2,
          "start_time": 1.81,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a2",
          "scenario": 2,
          "activation_step": 3,
          "start_time": 3.07,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a3",
          "scenario": 2,
          "activation_step": 4,
          "start_time": 4.43,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a4",
          "scenario": 2,
          "activation_step": 5,
          "start_time": 5.91,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a5",
          "scenario": 2,
          "activation_step": 6,
          "start_time": 7.21,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a6",
          "scenario": 2,
          "activation_step": 7,
          "start_time": 8.13,
          "duration": 1.16,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s1_a7",
          "scenario": 2,
          "activation_step": 8,
          "start_time": 9.65,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a8",
          "scenario": 2,
          "activation_step": 9,
          "start_time": 10.94,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a9",
          "scenario": 2,
          "activation_step": 10,
          "start_time": 12.22,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a10",
          "scenario": 2,
          "activation_step": 11,
          "start_time": 13.66,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a11",
          "scenario": 2,
          "activation_step": 12,
          "start_time": 14.72,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a12",
          "scenario": 2,
          "activation_step": 13,
          "start_time": 16.2,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a13",
          "scenario": 2,
          "activation_step": 14,
          "start_time": 17.3,
          "duration": 1.02,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s1_a14",
          "scenario": 2,
          "activation_step": 15,
          "start_time": 18.65,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a15",
          "scenario": 2,
          "activation_step": 16,
          "start_time": 20.08,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a16",
          "scenario": 2,
          "activation_step": 17,
          "start_time": 21.38,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a17",
          "scenario": 2,
          "activation_step": 18,
          "start_time": 22.72,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a18",
          "scenario": 2,
          "activation_step": 19,
          "start_time": 24.11,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a19",
          "scenario": 2,
          "activation_step": 20,
          "start_time": 25.24,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a20",
          "scenario": 2,
          "activation_step": 21,
          "start_time": 26.53,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a21",
          "scenario": 2,
          "activation_step": 22,
          "start_time": 28.03,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a22",
          "scenario": 2,
          "activation_step": 23,
          "start_time": 29.38,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a23",
          "scenario": 2,
          "activation_step": 24,
          "start_time": 30.65,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a24",
          "scenario": 2,
          "activation_step": 25,
          "start_time": 32.09,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a25",
          "scenario": 2,
          "activation_step": 26,
          "start_time": 33.61,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a26",
          "scenario": 2,
          "activation_step": 27,
          "start_time": 34.92,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a27",
          "scenario": 2,
          "activation_step": 28,
          "start_time": 35.83,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s1_a28",
          "scenario": 2,
          "activation_step": 29,
          "start_time": 37.22,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a29",
          "scenario": 2,
          "activation_step": 30,
          "start_time": 38.56,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a30",
          "scenario": 2,
          "activation_step": 31,
          "start_time": 40.05,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a31",
          "scenario": 2,
          "activation_step": 32,
          "start_time": 41.34,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a32",
          "scenario": 2,
          "activation_step": 33,
          "start_time": 42.64,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a33",
          "scenario": 2,
          "activation_step": 34,
          "start_time": 43.96,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a34",
          "scenario": 2,
          "activation_step": 35,
          "start_time": 45.35,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a35",
          "scenario": 2,
          "activation_step": 36,
          "start_time": 46.47,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a36",
          "scenario": 2,
          "activation_step": 37,
          "start_time": 47.77,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a37",
          "scenario": 2,
          "activation_step": 38,
          "start_time": 49.36,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a38",
          "scenario": 2,
          "activation_step": 39,
          "start_time": 50.89,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a39",
          "scenario": 2,
          "activation_step": 40,
          "start_time": 52.41,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a40",
          "scenario": 2,
          "activation_step": 41,
          "start_time": 53.68,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a41",
          "scenario": 2,
          "activation_step": 42,
          "start_time": 55.0,
          "duration": 0.8,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a42",
          "scenario": 2,
          "activation_step": 43,
          "start_time": 56.15,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a43",
          "scenario": 2,
          "activation_step": 44,
          "start_time": 57.49,
          "duration": 0.8,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a44",
          "scenario": 2,
          "activation_step": 45,
          "start_time": 58.68,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a45",
          "scenario": 2,
          "activation_step": 46,
          "start_time": 60.09,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a46",
          "scenario": 2,
          "activation_step": 47,
          "start_time": 61.44,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a47",
          "scenario": 2,
          "activation_step": 48,
          "start_time": 62.57,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a48",
          "scenario": 2,
          "activation_step": 49,
          "start_time": 64.08,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a49",
          "scenario": 2,
          "activation_step": 50,
          "start_time": 65.4,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a50",
          "scenario": 2,
          "activation_step": 51,
          "start_time": 66.52,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s1_a51",
          "scenario": 2,
          "activation_step": 52,
          "start_time": 67.68,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a52",
          "scenario": 2,
          "activation_step": 53,
          "start_time": 68.72,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a53",
          "scenario": 2,
          "activation_step": 54,
          "start_time": 69.94,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a54",
          "scenario": 2,
          "activation_step": 55,
          "start_time": 71.56,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a55",
          "scenario": 2,
          "activation_step": 56,
          "start_time": 73.02,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a56",
          "scenario": 2,
          "activation_step": 57,
          "start_time": 74.62,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a57",
          "scenario": 2,
          "activation_step": 58,
          "start_time": 75.98,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a58",
          "scenario": 2,
          "activation_step": 59,
          "start_time": 77.36,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a59",
          "scenario": 2,
          "activation_step": 60,
          "start_time": 78.9,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a60",
          "scenario": 2,
          "activation_step": 61,
          "start_time": 80.01,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a61",
          "scenario": 2,
          "activation_step": 62,
          "start_time": 81.29,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a62",
          "scenario": 2,
          "activation_step": 63,
          "start_time": 82.88,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a63",
          "scenario": 2,
          "activation_step": 64,
          "start_time": 84.26,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a64",
          "scenario": 2,
          "activation_step": 65,
          "start_time": 85.78,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a65",
          "scenario": 2,
          "activation_step": 66,
          "start_time": 87.25,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a66",
          "scenario": 2,
          "activation_step": 67,
          "start_time": 88.44,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a67",
          "scenario": 2,
          "activation_step": 68,
          "start_time": 89.74,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a68",
          "scenario": 2,
          "activation_step": 69,
          "start_time": 90.64,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s1_a69",
          "scenario": 2,
          "activation_step": 70,
          "start_time": 91.91,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a70",
          "scenario": 2,
          "activation_step": 71,
          "start_time": 93.34,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a71",
          "scenario": 2,
          "activation_step": 72,
          "start_time": 94.89,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a72",
          "scenario": 2,
          "activation_step": 73,
          "start_time": 96.18,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a73",
          "scenario": 2,
          "activation_step": 74,
          "start_time": 97.16,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s1_a74",
          "scenario": 2,
          "activation_step": 75,
          "start_time": 98.7,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a75",
          "scenario": 2,
          "activation_step": 76,
          "start_time": 99.97,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a76",
          "scenario": 2,
          "activation_step": 77,
          "start_time": 101.28,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a77",
          "scenario": 2,
          "activation_step": 78,
          "start_time": 102.62,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a78",
          "scenario": 2,
          "activation_step": 79,
          "start_time": 103.98,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a79",
          "scenario": 2,
          "activation_step": 80,
          "start_time": 105.48,
          "duration": 0.8,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a80",
          "scenario": 2,
          "activation_step": 81,
          "start_time": 106.53,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a81",
          "scenario": 2,
          "activation_step": 82,
          "start_time": 107.84,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a82",
          "scenario": 2,
          "activation_step": 83,
          "start_time": 109.37,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a83",
          "scenario": 2,
          "activation_step": 84,
          "start_time": 110.52,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s1_a84",
          "scenario": 2,
          "activation_step": 85,
          "start_time": 111.81,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a85",
          "scenario": 2,
          "activation_step": 86,
          "start_time": 113.18,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a86",
          "scenario": 2,
          "activation_step": 87,
          "start_time": 114.37,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a87",
          "scenario": 2,
          "activation_step": 88,
          "start_time": 115.76,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a88",
          "scenario": 2,
          "activation_step": 89,
          "start_time": 117.07,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a89",
          "scenario": 2,
          "activation_step": 90,
          "start_time": 118.45,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a90",
          "scenario": 2,
          "activation_step": 91,
          "start_time": 119.75,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a91",
          "scenario": 2,
          "activation_step": 92,
          "start_time": 121.24,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a92",
          "scenario": 2,
          "activation_step": 93,
          "start_time": 122.31,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a93",
          "scenario": 2,
          "activation_step": 94,
          "start_time": 123.71,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a94",
          "scenario": 2,
          "activation_step": 95,
          "start_time": 125.12,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a95",
          "scenario": 2,
          "activation_step": 96,
          "start_time": 126.66,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a96",
          "scenario": 2,
          "activation_step": 97,
          "start_time": 128.29,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a97",
          "scenario": 2,
          "activation_step": 98,
          "start_time": 129.38,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a98",
          "scenario": 2,
          "activation_step": 99,
          "start_time": 130.71,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s1_a99",
          "scenario": 2,
          "activation_step": 100,
          "start_time": 132.3,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        }
      ]
    },
    {
      "scenario_id": 3,
      "conflict_count": 7,
      "total_duration": 131.94,
      "activations": [
        {
          "id": "s2_a0",
          "scenario": 3,
          "activation_step": 1,
          "start_time": 0.33,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a1",
          "scenario": 3,
          "activation_step": 2,
          "start_time": 1.19,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s2_a2",
          "scenario": 3,
          "activation_step": 3,
          "start_time": 2.81,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a3",
          "scenario": 3,
          "activation_step": 4,
          "start_time": 3.62,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s2_a4",
          "scenario": 3,
          "activation_step": 5,
          "start_time": 4.87,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a5",
          "scenario": 3,
          "activation_step": 6,
          "start_time": 6.36,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a6",
          "scenario": 3,
          "activation_step": 7,
          "start_time": 7.25,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s2_a7",
          "scenario": 3,
          "activation_step": 8,
          "start_time": 8.7,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a8",
          "scenario": 3,
          "activation_step": 9,
          "start_time": 10.19,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a9",
          "scenario": 3,
          "activation_step": 10,
          "start_time": 11.43,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a10",
          "scenario": 3,
          "activation_step": 11,
          "start_time": 12.63,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a11",
          "scenario": 3,
          "activation_step": 12,
          "start_time": 13.74,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a12",
          "scenario": 3,
          "activation_step": 13,
          "start_time": 15.36,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a13",
          "scenario": 3,
          "activation_step": 14,
          "start_time": 16.96,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a14",
          "scenario": 3,
          "activation_step": 15,
          "start_time": 18.23,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a15",
          "scenario": 3,
          "activation_step": 16,
          "start_time": 19.51,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a16",
          "scenario": 3,
          "activation_step": 17,
          "start_time": 20.79,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a17",
          "scenario": 3,
          "activation_step": 18,
          "start_time": 22.16,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a18",
          "scenario": 3,
          "activation_step": 19,
          "start_time": 23.22,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a19",
          "scenario": 3,
          "activation_step": 20,
          "start_time": 24.8,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a20",
          "scenario": 3,
          "activation_step": 21,
          "start_time": 26.15,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a21",
          "scenario": 3,
          "activation_step": 22,
          "start_time": 27.32,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a22",
          "scenario": 3,
          "activation_step": 23,
          "start_time": 28.92,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a23",
          "scenario": 3,
          "activation_step": 24,
          "start_time": 30.07,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a24",
          "scenario": 3,
          "activation_step": 25,
          "start_time": 31.44,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a25",
          "scenario": 3,
          "activation_step": 26,
          "start_time": 32.56,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a26",
          "scenario": 3,
          "activation_step": 27,
          "start_time": 33.85,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a27",
          "scenario": 3,
          "activation_step": 28,
          "start_time": 35.02,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a28",
          "scenario": 3,
          "activation_step": 29,
          "start_time": 36.25,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a29",
          "scenario": 3,
          "activation_step": 30,
          "start_time": 37.75,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a30",
          "scenario": 3,
          "activation_step": 31,
          "start_time": 39.23,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a31",
          "scenario": 3,
          "activation_step": 32,
          "start_time": 40.44,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a32",
          "scenario": 3,
          "activation_step": 33,
          "start_time": 41.75,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a33",
          "scenario": 3,
          "activation_step": 34,
          "start_time": 43.08,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a34",
          "scenario": 3,
          "activation_step": 35,
          "start_time": 44.59,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a35",
          "scenario": 3,
          "activation_step": 36,
          "start_time": 45.81,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a36",
          "scenario": 3,
          "activation_step": 37,
          "start_time": 47.22,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a37",
          "scenario": 3,
          "activation_step": 38,
          "start_time": 48.7,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a38",
          "scenario": 3,
          "activation_step": 39,
          "start_time": 50.04,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a39",
          "scenario": 3,
          "activation_step": 40,
          "start_time": 51.36,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a40",
          "scenario": 3,
          "activation_step": 41,
          "start_time": 52.72,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a41",
          "scenario": 3,
          "activation_step": 42,
          "start_time": 54.07,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a42",
          "scenario": 3,
          "activation_step": 43,
          "start_time": 55.52,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a43",
          "scenario": 3,
          "activation_step": 44,
          "start_time": 56.67,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a44",
          "scenario": 3,
          "activation_step": 45,
          "start_time": 58.01,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a45",
          "scenario": 3,
          "activation_step": 46,
          "start_time": 58.95,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s2_a46",
          "scenario": 3,
          "activation_step": 47,
          "start_time": 60.44,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a47",
          "scenario": 3,
          "activation_step": 48,
          "start_time": 61.91,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a48",
          "scenario": 3,
          "activation_step": 49,
          "start_time": 63.28,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a49",
          "scenario": 3,
          "activation_step": 50,
          "start_time": 64.63,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a50",
          "scenario": 3,
          "activation_step": 51,
          "start_time": 66.18,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a51",
          "scenario": 3,
          "activation_step": 52,
          "start_time": 67.43,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a52",
          "scenario": 3,
          "activation_step": 53,
          "start_time": 68.95,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a53",
          "scenario": 3,
          "activation_step": 54,
          "start_time": 70.43,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a54",
          "scenario": 3,
          "activation_step": 55,
          "start_time": 71.78,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a55",
          "scenario": 3,
          "activation_step": 56,
          "start_time": 72.85,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a56",
          "scenario": 3,
          "activation_step": 57,
          "start_time": 74.18,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a57",
          "scenario": 3,
          "activation_step": 58,
          "start_time": 75.51,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a58",
          "scenario": 3,
          "activation_step": 59,
          "start_time": 76.37,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s2_a59",
          "scenario": 3,
          "activation_step": 60,
          "start_time": 77.76,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a60",
          "scenario": 3,
          "activation_step": 61,
          "start_time": 79.11,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a61",
          "scenario": 3,
          "activation_step": 62,
          "start_time": 80.7,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a62",
          "scenario": 3,
          "activation_step": 63,
          "start_time": 82.04,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a63",
          "scenario": 3,
          "activation_step": 64,
          "start_time": 83.43,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a64",
          "scenario": 3,
          "activation_step": 65,
          "start_time": 84.71,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a65",
          "scenario": 3,
          "activation_step": 66,
          "start_time": 86.03,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a66",
          "scenario": 3,
          "activation_step": 67,
          "start_time": 87.35,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a67",
          "scenario": 3,
          "activation_step": 68,
          "start_time": 88.85,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a68",
          "scenario": 3,
          "activation_step": 69,
          "start_time": 90.08,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a69",
          "scenario": 3,
          "activation_step": 70,
          "start_time": 91.35,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a70",
          "scenario": 3,
          "activation_step": 71,
          "start_time": 92.79,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a71",
          "scenario": 3,
          "activation_step": 72,
          "start_time": 93.82,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a72",
          "scenario": 3,
          "activation_step": 73,
          "start_time": 95.13,
          "duration": 0.8,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a73",
          "scenario": 3,
          "activation_step": 74,
          "start_time": 96.21,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a74",
          "scenario": 3,
          "activation_step": 75,
          "start_time": 97.28,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a75",
          "scenario": 3,
          "activation_step": 76,
          "start_time": 98.67,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a76",
          "scenario": 3,
          "activation_step": 77,
          "start_time": 100.12,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a77",
          "scenario": 3,
          "activation_step": 78,
          "start_time": 101.25,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a78",
          "scenario": 3,
          "activation_step": 79,
          "start_time": 102.6,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a79",
          "scenario": 3,
          "activation_step": 80,
          "start_time": 104.02,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a80",
          "scenario": 3,
          "activation_step": 81,
          "start_time": 105.4,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a81",
          "scenario": 3,
          "activation_step": 82,
          "start_time": 106.26,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s2_a82",
          "scenario": 3,
          "activation_step": 83,
          "start_time": 107.67,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a83",
          "scenario": 3,
          "activation_step": 84,
          "start_time": 108.95,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a84",
          "scenario": 3,
          "activation_step": 85,
          "start_time": 110.27,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a85",
          "scenario": 3,
          "activation_step": 86,
          "start_time": 111.56,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a86",
          "scenario": 3,
          "activation_step": 87,
          "start_time": 112.99,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a87",
          "scenario": 3,
          "activation_step": 88,
          "start_time": 114.46,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a88",
          "scenario": 3,
          "activation_step": 89,
          "start_time": 115.62,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a89",
          "scenario": 3,
          "activation_step": 90,
          "start_time": 116.89,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a90",
          "scenario": 3,
          "activation_step": 91,
          "start_time": 118.1,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a91",
          "scenario": 3,
          "activation_step": 92,
          "start_time": 119.5,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a92",
          "scenario": 3,
          "activation_step": 93,
          "start_time": 120.77,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a93",
          "scenario": 3,
          "activation_step": 94,
          "start_time": 122.25,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a94",
          "scenario": 3,
          "activation_step": 95,
          "start_time": 123.57,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a95",
          "scenario": 3,
          "activation_step": 96,
          "start_time": 125.0,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a96",
          "scenario": 3,
          "activation_step": 97,
          "start_time": 126.17,
          "duration": 1.01,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s2_a97",
          "scenario": 3,
          "activation_step": 98,
          "start_time": 127.45,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a98",
          "scenario": 3,
          "activation_step": 99,
          "start_time": 128.75,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s2_a99",
          "scenario": 3,
          "activation_step": 100,
          "start_time": 129.94,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        }
      ]
    },
    {
      "scenario_id": 4,
      "conflict_count": 4,
      "total_duration": 132.79,
      "activations": [
        {
          "id": "s3_a0",
          "scenario": 4,
          "activation_step": 1,
          "start_time": 0.33,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a1",
          "scenario": 4,
          "activation_step": 2,
          "start_time": 1.74,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a2",
          "scenario": 4,
          "activation_step": 3,
          "start_time": 2.81,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a3",
          "scenario": 4,
          "activation_step": 4,
          "start_time": 3.92,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a4",
          "scenario": 4,
          "activation_step": 5,
          "start_time": 5.47,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a5",
          "scenario": 4,
          "activation_step": 6,
          "start_time": 6.58,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a6",
          "scenario": 4,
          "activation_step": 7,
          "start_time": 8.21,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a7",
          "scenario": 4,
          "activation_step": 8,
          "start_time": 9.31,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s3_a8",
          "scenario": 4,
          "activation_step": 9,
          "start_time": 10.62,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a9",
          "scenario": 4,
          "activation_step": 10,
          "start_time": 11.91,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a10",
          "scenario": 4,
          "activation_step": 11,
          "start_time": 13.41,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a11",
          "scenario": 4,
          "activation_step": 12,
          "start_time": 14.69,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a12",
          "scenario": 4,
          "activation_step": 13,
          "start_time": 16.02,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a13",
          "scenario": 4,
          "activation_step": 14,
          "start_time": 17.59,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a14",
          "scenario": 4,
          "activation_step": 15,
          "start_time": 18.87,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a15",
          "scenario": 4,
          "activation_step": 16,
          "start_time": 20.09,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a16",
          "scenario": 4,
          "activation_step": 17,
          "start_time": 21.3,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a17",
          "scenario": 4,
          "activation_step": 18,
          "start_time": 22.93,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a18",
          "scenario": 4,
          "activation_step": 19,
          "start_time": 24.15,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a19",
          "scenario": 4,
          "activation_step": 20,
          "start_time": 25.43,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a20",
          "scenario": 4,
          "activation_step": 21,
          "start_time": 26.92,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a21",
          "scenario": 4,
          "activation_step": 22,
          "start_time": 28.25,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a22",
          "scenario": 4,
          "activation_step": 23,
          "start_time": 29.58,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a23",
          "scenario": 4,
          "activation_step": 24,
          "start_time": 30.92,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a24",
          "scenario": 4,
          "activation_step": 25,
          "start_time": 32.13,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a25",
          "scenario": 4,
          "activation_step": 26,
          "start_time": 33.26,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a26",
          "scenario": 4,
          "activation_step": 27,
          "start_time": 34.7,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a27",
          "scenario": 4,
          "activation_step": 28,
          "start_time": 35.87,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a28",
          "scenario": 4,
          "activation_step": 29,
          "start_time": 37.01,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a29",
          "scenario": 4,
          "activation_step": 30,
          "start_time": 38.34,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a30",
          "scenario": 4,
          "activation_step": 31,
          "start_time": 39.92,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a31",
          "scenario": 4,
          "activation_step": 32,
          "start_time": 41.2,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a32",
          "scenario": 4,
          "activation_step": 33,
          "start_time": 42.67,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a33",
          "scenario": 4,
          "activation_step": 34,
          "start_time": 44.17,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a34",
          "scenario": 4,
          "activation_step": 35,
          "start_time": 45.62,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a35",
          "scenario": 4,
          "activation_step": 36,
          "start_time": 47.03,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a36",
          "scenario": 4,
          "activation_step": 37,
          "start_time": 48.47,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a37",
          "scenario": 4,
          "activation_step": 38,
          "start_time": 49.8,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a38",
          "scenario": 4,
          "activation_step": 39,
          "start_time": 51.35,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a39",
          "scenario": 4,
          "activation_step": 40,
          "start_time": 52.45,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a40",
          "scenario": 4,
          "activation_step": 41,
          "start_time": 53.85,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a41",
          "scenario": 4,
          "activation_step": 42,
          "start_time": 55.13,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a42",
          "scenario": 4,
          "activation_step": 43,
          "start_time": 56.72,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a43",
          "scenario": 4,
          "activation_step": 44,
          "start_time": 58.1,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a44",
          "scenario": 4,
          "activation_step": 45,
          "start_time": 59.41,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a45",
          "scenario": 4,
          "activation_step": 46,
          "start_time": 60.3,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s3_a46",
          "scenario": 4,
          "activation_step": 47,
          "start_time": 61.61,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a47",
          "scenario": 4,
          "activation_step": 48,
          "start_time": 62.8,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a48",
          "scenario": 4,
          "activation_step": 49,
          "start_time": 63.98,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a49",
          "scenario": 4,
          "activation_step": 50,
          "start_time": 65.34,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a50",
          "scenario": 4,
          "activation_step": 51,
          "start_time": 66.55,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a51",
          "scenario": 4,
          "activation_step": 52,
          "start_time": 67.83,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a52",
          "scenario": 4,
          "activation_step": 53,
          "start_time": 69.29,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a53",
          "scenario": 4,
          "activation_step": 54,
          "start_time": 70.55,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a54",
          "scenario": 4,
          "activation_step": 55,
          "start_time": 72.0,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a55",
          "scenario": 4,
          "activation_step": 56,
          "start_time": 72.87,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s3_a56",
          "scenario": 4,
          "activation_step": 57,
          "start_time": 74.26,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a57",
          "scenario": 4,
          "activation_step": 58,
          "start_time": 75.65,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a58",
          "scenario": 4,
          "activation_step": 59,
          "start_time": 76.95,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a59",
          "scenario": 4,
          "activation_step": 60,
          "start_time": 78.25,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a60",
          "scenario": 4,
          "activation_step": 61,
          "start_time": 79.55,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a61",
          "scenario": 4,
          "activation_step": 62,
          "start_time": 80.79,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a62",
          "scenario": 4,
          "activation_step": 63,
          "start_time": 81.89,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a63",
          "scenario": 4,
          "activation_step": 64,
          "start_time": 83.2,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a64",
          "scenario": 4,
          "activation_step": 65,
          "start_time": 84.56,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a65",
          "scenario": 4,
          "activation_step": 66,
          "start_time": 85.83,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a66",
          "scenario": 4,
          "activation_step": 67,
          "start_time": 87.1,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a67",
          "scenario": 4,
          "activation_step": 68,
          "start_time": 88.3,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a68",
          "scenario": 4,
          "activation_step": 69,
          "start_time": 89.09,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s3_a69",
          "scenario": 4,
          "activation_step": 70,
          "start_time": 90.46,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a70",
          "scenario": 4,
          "activation_step": 71,
          "start_time": 91.84,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a71",
          "scenario": 4,
          "activation_step": 72,
          "start_time": 93.2,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a72",
          "scenario": 4,
          "activation_step": 73,
          "start_time": 94.72,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a73",
          "scenario": 4,
          "activation_step": 74,
          "start_time": 96.31,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a74",
          "scenario": 4,
          "activation_step": 75,
          "start_time": 97.49,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a75",
          "scenario": 4,
          "activation_step": 76,
          "start_time": 98.65,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a76",
          "scenario": 4,
          "activation_step": 77,
          "start_time": 100.02,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a77",
          "scenario": 4,
          "activation_step": 78,
          "start_time": 101.39,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a78",
          "scenario": 4,
          "activation_step": 79,
          "start_time": 102.8,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a79",
          "scenario": 4,
          "activation_step": 80,
          "start_time": 104.38,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a80",
          "scenario": 4,
          "activation_step": 81,
          "start_time": 105.76,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a81",
          "scenario": 4,
          "activation_step": 82,
          "start_time": 106.85,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a82",
          "scenario": 4,
          "activation_step": 83,
          "start_time": 107.99,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a83",
          "scenario": 4,
          "activation_step": 84,
          "start_time": 109.34,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a84",
          "scenario": 4,
          "activation_step": 85,
          "start_time": 110.84,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a85",
          "scenario": 4,
          "activation_step": 86,
          "start_time": 111.96,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a86",
          "scenario": 4,
          "activation_step": 87,
          "start_time": 113.53,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a87",
          "scenario": 4,
          "activation_step": 88,
          "start_time": 115.02,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a88",
          "scenario": 4,
          "activation_step": 89,
          "start_time": 116.18,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a89",
          "scenario": 4,
          "activation_step": 90,
          "start_time": 117.48,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a90",
          "scenario": 4,
          "activation_step": 91,
          "start_time": 118.81,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a91",
          "scenario": 4,
          "activation_step": 92,
          "start_time": 120.04,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a92",
          "scenario": 4,
          "activation_step": 93,
          "start_time": 121.61,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a93",
          "scenario": 4,
          "activation_step": 94,
          "start_time": 123.03,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a94",
          "scenario": 4,
          "activation_step": 95,
          "start_time": 124.56,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a95",
          "scenario": 4,
          "activation_step": 96,
          "start_time": 126.16,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a96",
          "scenario": 4,
          "activation_step": 97,
          "start_time": 127.26,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a97",
          "scenario": 4,
          "activation_step": 98,
          "start_time": 128.38,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a98",
          "scenario": 4,
          "activation_step": 99,
          "start_time": 129.72,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s3_a99",
          "scenario": 4,
          "activation_step": 100,
          "start_time": 130.79,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        }
      ]
    },
    {
      "scenario_id": 5,
      "conflict_count": 5,
      "total_duration": 133.66,
      "activations": [
        {
          "id": "s4_a0",
          "scenario": 5,
          "activation_step": 1,
          "start_time": 0.29,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a1",
          "scenario": 5,
          "activation_step": 2,
          "start_time": 1.64,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a2",
          "scenario": 5,
          "activation_step": 3,
          "start_time": 3.11,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a3",
          "scenario": 5,
          "activation_step": 4,
          "start_time": 4.61,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a4",
          "scenario": 5,
          "activation_step": 5,
          "start_time": 5.99,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a5",
          "scenario": 5,
          "activation_step": 6,
          "start_time": 7.21,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a6",
          "scenario": 5,
          "activation_step": 7,
          "start_time": 8.59,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a7",
          "scenario": 5,
          "activation_step": 8,
          "start_time": 10.03,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a8",
          "scenario": 5,
          "activation_step": 9,
          "start_time": 11.36,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a9",
          "scenario": 5,
          "activation_step": 10,
          "start_time": 12.89,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a10",
          "scenario": 5,
          "activation_step": 11,
          "start_time": 14.47,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a11",
          "scenario": 5,
          "activation_step": 12,
          "start_time": 15.92,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a12",
          "scenario": 5,
          "activation_step": 13,
          "start_time": 17.09,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a13",
          "scenario": 5,
          "activation_step": 14,
          "start_time": 18.65,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a14",
          "scenario": 5,
          "activation_step": 15,
          "start_time": 19.99,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a15",
          "scenario": 5,
          "activation_step": 16,
          "start_time": 21.3,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a16",
          "scenario": 5,
          "activation_step": 17,
          "start_time": 22.91,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a17",
          "scenario": 5,
          "activation_step": 18,
          "start_time": 24.26,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a18",
          "scenario": 5,
          "activation_step": 19,
          "start_time": 25.64,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a19",
          "scenario": 5,
          "activation_step": 20,
          "start_time": 26.73,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a20",
          "scenario": 5,
          "activation_step": 21,
          "start_time": 28.11,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a21",
          "scenario": 5,
          "activation_step": 22,
          "start_time": 29.68,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a22",
          "scenario": 5,
          "activation_step": 23,
          "start_time": 30.59,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s4_a23",
          "scenario": 5,
          "activation_step": 24,
          "start_time": 31.92,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a24",
          "scenario": 5,
          "activation_step": 25,
          "start_time": 33.43,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a25",
          "scenario": 5,
          "activation_step": 26,
          "start_time": 34.9,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a26",
          "scenario": 5,
          "activation_step": 27,
          "start_time": 36.11,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a27",
          "scenario": 5,
          "activation_step": 28,
          "start_time": 37.26,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a28",
          "scenario": 5,
          "activation_step": 29,
          "start_time": 38.54,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a29",
          "scenario": 5,
          "activation_step": 30,
          "start_time": 39.91,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a30",
          "scenario": 5,
          "activation_step": 31,
          "start_time": 41.32,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a31",
          "scenario": 5,
          "activation_step": 32,
          "start_time": 42.73,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a32",
          "scenario": 5,
          "activation_step": 33,
          "start_time": 44.06,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a33",
          "scenario": 5,
          "activation_step": 34,
          "start_time": 45.2,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a34",
          "scenario": 5,
          "activation_step": 35,
          "start_time": 46.81,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a35",
          "scenario": 5,
          "activation_step": 36,
          "start_time": 48.17,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a36",
          "scenario": 5,
          "activation_step": 37,
          "start_time": 49.31,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a37",
          "scenario": 5,
          "activation_step": 38,
          "start_time": 50.64,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a38",
          "scenario": 5,
          "activation_step": 39,
          "start_time": 51.88,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a39",
          "scenario": 5,
          "activation_step": 40,
          "start_time": 53.35,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a40",
          "scenario": 5,
          "activation_step": 41,
          "start_time": 54.4,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a41",
          "scenario": 5,
          "activation_step": 42,
          "start_time": 55.72,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a42",
          "scenario": 5,
          "activation_step": 43,
          "start_time": 56.88,
          "duration": 1.17,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s4_a43",
          "scenario": 5,
          "activation_step": 44,
          "start_time": 58.26,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a44",
          "scenario": 5,
          "activation_step": 45,
          "start_time": 59.3,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a45",
          "scenario": 5,
          "activation_step": 46,
          "start_time": 60.58,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a46",
          "scenario": 5,
          "activation_step": 47,
          "start_time": 61.95,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a47",
          "scenario": 5,
          "activation_step": 48,
          "start_time": 63.27,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a48",
          "scenario": 5,
          "activation_step": 49,
          "start_time": 64.0,
          "duration": 1.12,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s4_a49",
          "scenario": 5,
          "activation_step": 50,
          "start_time": 65.58,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a50",
          "scenario": 5,
          "activation_step": 51,
          "start_time": 66.47,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s4_a51",
          "scenario": 5,
          "activation_step": 52,
          "start_time": 67.7,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a52",
          "scenario": 5,
          "activation_step": 53,
          "start_time": 68.76,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s4_a53",
          "scenario": 5,
          "activation_step": 54,
          "start_time": 69.85,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a54",
          "scenario": 5,
          "activation_step": 55,
          "start_time": 71.36,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a55",
          "scenario": 5,
          "activation_step": 56,
          "start_time": 72.85,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a56",
          "scenario": 5,
          "activation_step": 57,
          "start_time": 74.22,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a57",
          "scenario": 5,
          "activation_step": 58,
          "start_time": 75.43,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a58",
          "scenario": 5,
          "activation_step": 59,
          "start_time": 76.95,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a59",
          "scenario": 5,
          "activation_step": 60,
          "start_time": 78.24,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a60",
          "scenario": 5,
          "activation_step": 61,
          "start_time": 79.41,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a61",
          "scenario": 5,
          "activation_step": 62,
          "start_time": 80.57,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a62",
          "scenario": 5,
          "activation_step": 63,
          "start_time": 82.03,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a63",
          "scenario": 5,
          "activation_step": 64,
          "start_time": 83.33,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a64",
          "scenario": 5,
          "activation_step": 65,
          "start_time": 84.69,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a65",
          "scenario": 5,
          "activation_step": 66,
          "start_time": 86.07,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a66",
          "scenario": 5,
          "activation_step": 67,
          "start_time": 87.42,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a67",
          "scenario": 5,
          "activation_step": 68,
          "start_time": 88.81,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a68",
          "scenario": 5,
          "activation_step": 69,
          "start_time": 89.88,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a69",
          "scenario": 5,
          "activation_step": 70,
          "start_time": 91.05,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a70",
          "scenario": 5,
          "activation_step": 71,
          "start_time": 92.17,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a71",
          "scenario": 5,
          "activation_step": 72,
          "start_time": 93.56,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a72",
          "scenario": 5,
          "activation_step": 73,
          "start_time": 94.79,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a73",
          "scenario": 5,
          "activation_step": 74,
          "start_time": 96.01,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a74",
          "scenario": 5,
          "activation_step": 75,
          "start_time": 97.42,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a75",
          "scenario": 5,
          "activation_step": 76,
          "start_time": 98.99,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a76",
          "scenario": 5,
          "activation_step": 77,
          "start_time": 100.39,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a77",
          "scenario": 5,
          "activation_step": 78,
          "start_time": 101.83,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a78",
          "scenario": 5,
          "activation_step": 79,
          "start_time": 103.15,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a79",
          "scenario": 5,
          "activation_step": 80,
          "start_time": 104.39,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a80",
          "scenario": 5,
          "activation_step": 81,
          "start_time": 105.77,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a81",
          "scenario": 5,
          "activation_step": 82,
          "start_time": 107.18,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a82",
          "scenario": 5,
          "activation_step": 83,
          "start_time": 108.7,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a83",
          "scenario": 5,
          "activation_step": 84,
          "start_time": 109.88,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a84",
          "scenario": 5,
          "activation_step": 85,
          "start_time": 111.23,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a85",
          "scenario": 5,
          "activation_step": 86,
          "start_time": 112.7,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a86",
          "scenario": 5,
          "activation_step": 87,
          "start_time": 114.01,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a87",
          "scenario": 5,
          "activation_step": 88,
          "start_time": 115.26,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a88",
          "scenario": 5,
          "activation_step": 89,
          "start_time": 116.55,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a89",
          "scenario": 5,
          "activation_step": 90,
          "start_time": 118.03,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a90",
          "scenario": 5,
          "activation_step": 91,
          "start_time": 119.6,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a91",
          "scenario": 5,
          "activation_step": 92,
          "start_time": 120.66,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a92",
          "scenario": 5,
          "activation_step": 93,
          "start_time": 121.99,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a93",
          "scenario": 5,
          "activation_step": 94,
          "start_time": 123.07,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a94",
          "scenario": 5,
          "activation_step": 95,
          "start_time": 124.37,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a95",
          "scenario": 5,
          "activation_step": 96,
          "start_time": 125.99,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a96",
          "scenario": 5,
          "activation_step": 97,
          "start_time": 127.58,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a97",
          "scenario": 5,
          "activation_step": 98,
          "start_time": 129.06,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a98",
          "scenario": 5,
          "activation_step": 99,
          "start_time": 130.46,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s4_a99",
          "scenario": 5,
          "activation_step": 100,
          "start_time": 131.66,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        }
      ]
    },
    {
      "scenario_id": 6,
      "conflict_count": 3,
      "total_duration": 133.26,
      "activations": [
        {
          "id": "s5_a0",
          "scenario": 6,
          "activation_step": 1,
          "start_time": 0.2,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a1",
          "scenario": 6,
          "activation_step": 2,
          "start_time": 1.28,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a2",
          "scenario": 6,
          "activation_step": 3,
          "start_time": 2.73,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a3",
          "scenario": 6,
          "activation_step": 4,
          "start_time": 3.79,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a4",
          "scenario": 6,
          "activation_step": 5,
          "start_time": 5.01,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a5",
          "scenario": 6,
          "activation_step": 6,
          "start_time": 6.48,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a6",
          "scenario": 6,
          "activation_step": 7,
          "start_time": 7.55,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a7",
          "scenario": 6,
          "activation_step": 8,
          "start_time": 9.03,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a8",
          "scenario": 6,
          "activation_step": 9,
          "start_time": 10.35,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a9",
          "scenario": 6,
          "activation_step": 10,
          "start_time": 11.4,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a10",
          "scenario": 6,
          "activation_step": 11,
          "start_time": 13.01,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a11",
          "scenario": 6,
          "activation_step": 12,
          "start_time": 14.33,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a12",
          "scenario": 6,
          "activation_step": 13,
          "start_time": 15.74,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a13",
          "scenario": 6,
          "activation_step": 14,
          "start_time": 17.14,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a14",
          "scenario": 6,
          "activation_step": 15,
          "start_time": 18.26,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a15",
          "scenario": 6,
          "activation_step": 16,
          "start_time": 19.73,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a16",
          "scenario": 6,
          "activation_step": 17,
          "start_time": 21.02,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a17",
          "scenario": 6,
          "activation_step": 18,
          "start_time": 22.38,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a18",
          "scenario": 6,
          "activation_step": 19,
          "start_time": 23.56,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a19",
          "scenario": 6,
          "activation_step": 20,
          "start_time": 24.88,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a20",
          "scenario": 6,
          "activation_step": 21,
          "start_time": 26.47,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a21",
          "scenario": 6,
          "activation_step": 22,
          "start_time": 27.98,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a22",
          "scenario": 6,
          "activation_step": 23,
          "start_time": 29.33,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a23",
          "scenario": 6,
          "activation_step": 24,
          "start_time": 30.63,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a24",
          "scenario": 6,
          "activation_step": 25,
          "start_time": 32.2,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a25",
          "scenario": 6,
          "activation_step": 26,
          "start_time": 33.65,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a26",
          "scenario": 6,
          "activation_step": 27,
          "start_time": 34.94,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a27",
          "scenario": 6,
          "activation_step": 28,
          "start_time": 36.1,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a28",
          "scenario": 6,
          "activation_step": 29,
          "start_time": 37.68,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a29",
          "scenario": 6,
          "activation_step": 30,
          "start_time": 39.03,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a30",
          "scenario": 6,
          "activation_step": 31,
          "start_time": 40.21,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a31",
          "scenario": 6,
          "activation_step": 32,
          "start_time": 41.69,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a32",
          "scenario": 6,
          "activation_step": 33,
          "start_time": 42.93,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a33",
          "scenario": 6,
          "activation_step": 34,
          "start_time": 44.04,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a34",
          "scenario": 6,
          "activation_step": 35,
          "start_time": 44.98,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s5_a35",
          "scenario": 6,
          "activation_step": 36,
          "start_time": 46.47,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a36",
          "scenario": 6,
          "activation_step": 37,
          "start_time": 47.69,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a37",
          "scenario": 6,
          "activation_step": 38,
          "start_time": 48.99,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a38",
          "scenario": 6,
          "activation_step": 39,
          "start_time": 50.11,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a39",
          "scenario": 6,
          "activation_step": 40,
          "start_time": 51.33,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a40",
          "scenario": 6,
          "activation_step": 41,
          "start_time": 52.55,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a41",
          "scenario": 6,
          "activation_step": 42,
          "start_time": 54.13,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a42",
          "scenario": 6,
          "activation_step": 43,
          "start_time": 55.7,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a43",
          "scenario": 6,
          "activation_step": 44,
          "start_time": 57.11,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a44",
          "scenario": 6,
          "activation_step": 45,
          "start_time": 58.18,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a45",
          "scenario": 6,
          "activation_step": 46,
          "start_time": 59.52,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a46",
          "scenario": 6,
          "activation_step": 47,
          "start_time": 60.94,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a47",
          "scenario": 6,
          "activation_step": 48,
          "start_time": 61.75,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s5_a48",
          "scenario": 6,
          "activation_step": 49,
          "start_time": 63.04,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a49",
          "scenario": 6,
          "activation_step": 50,
          "start_time": 64.3,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a50",
          "scenario": 6,
          "activation_step": 51,
          "start_time": 65.4,
          "duration": 0.8,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a51",
          "scenario": 6,
          "activation_step": 52,
          "start_time": 66.7,
          "duration": 0.8,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a52",
          "scenario": 6,
          "activation_step": 53,
          "start_time": 67.9,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a53",
          "scenario": 6,
          "activation_step": 54,
          "start_time": 69.24,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a54",
          "scenario": 6,
          "activation_step": 55,
          "start_time": 70.68,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a55",
          "scenario": 6,
          "activation_step": 56,
          "start_time": 72.07,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a56",
          "scenario": 6,
          "activation_step": 57,
          "start_time": 73.1,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a57",
          "scenario": 6,
          "activation_step": 58,
          "start_time": 74.66,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a58",
          "scenario": 6,
          "activation_step": 59,
          "start_time": 76.08,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a59",
          "scenario": 6,
          "activation_step": 60,
          "start_time": 77.56,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a60",
          "scenario": 6,
          "activation_step": 61,
          "start_time": 78.72,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a61",
          "scenario": 6,
          "activation_step": 62,
          "start_time": 79.88,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a62",
          "scenario": 6,
          "activation_step": 63,
          "start_time": 81.1,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a63",
          "scenario": 6,
          "activation_step": 64,
          "start_time": 82.19,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a64",
          "scenario": 6,
          "activation_step": 65,
          "start_time": 83.63,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a65",
          "scenario": 6,
          "activation_step": 66,
          "start_time": 84.8,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a66",
          "scenario": 6,
          "activation_step": 67,
          "start_time": 85.95,
          "duration": 0.8,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a67",
          "scenario": 6,
          "activation_step": 68,
          "start_time": 87.22,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a68",
          "scenario": 6,
          "activation_step": 69,
          "start_time": 88.65,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a69",
          "scenario": 6,
          "activation_step": 70,
          "start_time": 89.86,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a70",
          "scenario": 6,
          "activation_step": 71,
          "start_time": 91.35,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a71",
          "scenario": 6,
          "activation_step": 72,
          "start_time": 92.83,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a72",
          "scenario": 6,
          "activation_step": 73,
          "start_time": 94.12,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a73",
          "scenario": 6,
          "activation_step": 74,
          "start_time": 95.08,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s5_a74",
          "scenario": 6,
          "activation_step": 75,
          "start_time": 96.42,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a75",
          "scenario": 6,
          "activation_step": 76,
          "start_time": 97.94,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a76",
          "scenario": 6,
          "activation_step": 77,
          "start_time": 99.13,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a77",
          "scenario": 6,
          "activation_step": 78,
          "start_time": 100.31,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a78",
          "scenario": 6,
          "activation_step": 79,
          "start_time": 101.97,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a79",
          "scenario": 6,
          "activation_step": 80,
          "start_time": 103.6,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a80",
          "scenario": 6,
          "activation_step": 81,
          "start_time": 104.94,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a81",
          "scenario": 6,
          "activation_step": 82,
          "start_time": 106.48,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a82",
          "scenario": 6,
          "activation_step": 83,
          "start_time": 107.7,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a83",
          "scenario": 6,
          "activation_step": 84,
          "start_time": 109.28,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a84",
          "scenario": 6,
          "activation_step": 85,
          "start_time": 110.58,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a85",
          "scenario": 6,
          "activation_step": 86,
          "start_time": 111.98,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a86",
          "scenario": 6,
          "activation_step": 87,
          "start_time": 113.39,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a87",
          "scenario": 6,
          "activation_step": 88,
          "start_time": 114.72,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a88",
          "scenario": 6,
          "activation_step": 89,
          "start_time": 116.03,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a89",
          "scenario": 6,
          "activation_step": 90,
          "start_time": 117.35,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a90",
          "scenario": 6,
          "activation_step": 91,
          "start_time": 118.7,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a91",
          "scenario": 6,
          "activation_step": 92,
          "start_time": 120.01,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a92",
          "scenario": 6,
          "activation_step": 93,
          "start_time": 121.56,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a93",
          "scenario": 6,
          "activation_step": 94,
          "start_time": 123.18,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a94",
          "scenario": 6,
          "activation_step": 95,
          "start_time": 124.46,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a95",
          "scenario": 6,
          "activation_step": 96,
          "start_time": 125.97,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a96",
          "scenario": 6,
          "activation_step": 97,
          "start_time": 127.44,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a97",
          "scenario": 6,
          "activation_step": 98,
          "start_time": 128.86,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a98",
          "scenario": 6,
          "activation_step": 99,
          "start_time": 130.06,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s5_a99",
          "scenario": 6,
          "activation_step": 100,
          "start_time": 131.26,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        }
      ]
    },
    {
      "scenario_id": 7,
      "conflict_count": 6,
      "total_duration": 133.54,
      "activations": [
        {
          "id": "s6_a0",
          "scenario": 7,
          "activation_step": 1,
          "start_time": 0.41,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a1",
          "scenario": 7,
          "activation_step": 2,
          "start_time": 1.86,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a2",
          "scenario": 7,
          "activation_step": 3,
          "start_time": 3.23,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a3",
          "scenario": 7,
          "activation_step": 4,
          "start_time": 4.67,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a4",
          "scenario": 7,
          "activation_step": 5,
          "start_time": 6.09,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a5",
          "scenario": 7,
          "activation_step": 6,
          "start_time": 7.39,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a6",
          "scenario": 7,
          "activation_step": 7,
          "start_time": 8.53,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a7",
          "scenario": 7,
          "activation_step": 8,
          "start_time": 9.76,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a8",
          "scenario": 7,
          "activation_step": 9,
          "start_time": 11.22,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a9",
          "scenario": 7,
          "activation_step": 10,
          "start_time": 12.6,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a10",
          "scenario": 7,
          "activation_step": 11,
          "start_time": 13.87,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a11",
          "scenario": 7,
          "activation_step": 12,
          "start_time": 15.4,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a12",
          "scenario": 7,
          "activation_step": 13,
          "start_time": 16.91,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a13",
          "scenario": 7,
          "activation_step": 14,
          "start_time": 17.97,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a14",
          "scenario": 7,
          "activation_step": 15,
          "start_time": 19.51,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a15",
          "scenario": 7,
          "activation_step": 16,
          "start_time": 20.78,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a16",
          "scenario": 7,
          "activation_step": 17,
          "start_time": 22.04,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a17",
          "scenario": 7,
          "activation_step": 18,
          "start_time": 23.26,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a18",
          "scenario": 7,
          "activation_step": 19,
          "start_time": 24.81,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a19",
          "scenario": 7,
          "activation_step": 20,
          "start_time": 25.67,
          "duration": 0.92,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s6_a20",
          "scenario": 7,
          "activation_step": 21,
          "start_time": 26.91,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a21",
          "scenario": 7,
          "activation_step": 22,
          "start_time": 28.15,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a22",
          "scenario": 7,
          "activation_step": 23,
          "start_time": 29.53,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a23",
          "scenario": 7,
          "activation_step": 24,
          "start_time": 30.69,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a24",
          "scenario": 7,
          "activation_step": 25,
          "start_time": 32.09,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a25",
          "scenario": 7,
          "activation_step": 26,
          "start_time": 33.59,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a26",
          "scenario": 7,
          "activation_step": 27,
          "start_time": 34.97,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a27",
          "scenario": 7,
          "activation_step": 28,
          "start_time": 36.3,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a28",
          "scenario": 7,
          "activation_step": 29,
          "start_time": 37.8,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a29",
          "scenario": 7,
          "activation_step": 30,
          "start_time": 39.13,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a30",
          "scenario": 7,
          "activation_step": 31,
          "start_time": 40.6,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a31",
          "scenario": 7,
          "activation_step": 32,
          "start_time": 42.09,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a32",
          "scenario": 7,
          "activation_step": 33,
          "start_time": 43.44,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a33",
          "scenario": 7,
          "activation_step": 34,
          "start_time": 44.55,
          "duration": 0.86,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s6_a34",
          "scenario": 7,
          "activation_step": 35,
          "start_time": 45.76,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a35",
          "scenario": 7,
          "activation_step": 36,
          "start_time": 46.56,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s6_a36",
          "scenario": 7,
          "activation_step": 37,
          "start_time": 47.85,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a37",
          "scenario": 7,
          "activation_step": 38,
          "start_time": 49.22,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a38",
          "scenario": 7,
          "activation_step": 39,
          "start_time": 50.54,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a39",
          "scenario": 7,
          "activation_step": 40,
          "start_time": 52.14,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a40",
          "scenario": 7,
          "activation_step": 41,
          "start_time": 53.5,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a41",
          "scenario": 7,
          "activation_step": 42,
          "start_time": 54.71,
          "duration": 0.8,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a42",
          "scenario": 7,
          "activation_step": 43,
          "start_time": 55.77,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a43",
          "scenario": 7,
          "activation_step": 44,
          "start_time": 57.13,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a44",
          "scenario": 7,
          "activation_step": 45,
          "start_time": 57.95,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s6_a45",
          "scenario": 7,
          "activation_step": 46,
          "start_time": 59.33,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a46",
          "scenario": 7,
          "activation_step": 47,
          "start_time": 60.47,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a47",
          "scenario": 7,
          "activation_step": 48,
          "start_time": 61.64,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a48",
          "scenario": 7,
          "activation_step": 49,
          "start_time": 63.08,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a49",
          "scenario": 7,
          "activation_step": 50,
          "start_time": 64.52,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a50",
          "scenario": 7,
          "activation_step": 51,
          "start_time": 65.92,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a51",
          "scenario": 7,
          "activation_step": 52,
          "start_time": 67.1,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a52",
          "scenario": 7,
          "activation_step": 53,
          "start_time": 68.27,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a53",
          "scenario": 7,
          "activation_step": 54,
          "start_time": 69.52,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a54",
          "scenario": 7,
          "activation_step": 55,
          "start_time": 70.73,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a55",
          "scenario": 7,
          "activation_step": 56,
          "start_time": 72.0,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a56",
          "scenario": 7,
          "activation_step": 57,
          "start_time": 73.65,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a57",
          "scenario": 7,
          "activation_step": 58,
          "start_time": 75.05,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a58",
          "scenario": 7,
          "activation_step": 59,
          "start_time": 76.28,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a59",
          "scenario": 7,
          "activation_step": 60,
          "start_time": 77.58,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a60",
          "scenario": 7,
          "activation_step": 61,
          "start_time": 78.65,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a61",
          "scenario": 7,
          "activation_step": 62,
          "start_time": 79.99,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a62",
          "scenario": 7,
          "activation_step": 63,
          "start_time": 81.22,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a63",
          "scenario": 7,
          "activation_step": 64,
          "start_time": 82.38,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a64",
          "scenario": 7,
          "activation_step": 65,
          "start_time": 83.67,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a65",
          "scenario": 7,
          "activation_step": 66,
          "start_time": 84.86,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a66",
          "scenario": 7,
          "activation_step": 67,
          "start_time": 86.23,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a67",
          "scenario": 7,
          "activation_step": 68,
          "start_time": 87.66,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a68",
          "scenario": 7,
          "activation_step": 69,
          "start_time": 89.06,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a69",
          "scenario": 7,
          "activation_step": 70,
          "start_time": 90.45,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a70",
          "scenario": 7,
          "activation_step": 71,
          "start_time": 91.49,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a71",
          "scenario": 7,
          "activation_step": 72,
          "start_time": 92.78,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a72",
          "scenario": 7,
          "activation_step": 73,
          "start_time": 94.12,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a73",
          "scenario": 7,
          "activation_step": 74,
          "start_time": 95.48,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a74",
          "scenario": 7,
          "activation_step": 75,
          "start_time": 96.76,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a75",
          "scenario": 7,
          "activation_step": 76,
          "start_time": 98.23,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a76",
          "scenario": 7,
          "activation_step": 77,
          "start_time": 99.37,
          "duration": 1.11,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s6_a77",
          "scenario": 7,
          "activation_step": 78,
          "start_time": 100.8,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a78",
          "scenario": 7,
          "activation_step": 79,
          "start_time": 102.23,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a79",
          "scenario": 7,
          "activation_step": 80,
          "start_time": 103.6,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a80",
          "scenario": 7,
          "activation_step": 81,
          "start_time": 105.11,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a81",
          "scenario": 7,
          "activation_step": 82,
          "start_time": 106.36,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a82",
          "scenario": 7,
          "activation_step": 83,
          "start_time": 107.95,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a83",
          "scenario": 7,
          "activation_step": 84,
          "start_time": 109.23,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a84",
          "scenario": 7,
          "activation_step": 85,
          "start_time": 110.17,
          "duration": 1.06,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s6_a85",
          "scenario": 7,
          "activation_step": 86,
          "start_time": 111.5,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a86",
          "scenario": 7,
          "activation_step": 87,
          "start_time": 112.99,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a87",
          "scenario": 7,
          "activation_step": 88,
          "start_time": 114.6,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a88",
          "scenario": 7,
          "activation_step": 89,
          "start_time": 115.97,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a89",
          "scenario": 7,
          "activation_step": 90,
          "start_time": 117.46,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a90",
          "scenario": 7,
          "activation_step": 91,
          "start_time": 118.91,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a91",
          "scenario": 7,
          "activation_step": 92,
          "start_time": 120.35,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a92",
          "scenario": 7,
          "activation_step": 93,
          "start_time": 121.86,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a93",
          "scenario": 7,
          "activation_step": 94,
          "start_time": 123.24,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a94",
          "scenario": 7,
          "activation_step": 95,
          "start_time": 124.66,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a95",
          "scenario": 7,
          "activation_step": 96,
          "start_time": 126.13,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a96",
          "scenario": 7,
          "activation_step": 97,
          "start_time": 127.43,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a97",
          "scenario": 7,
          "activation_step": 98,
          "start_time": 128.94,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a98",
          "scenario": 7,
          "activation_step": 99,
          "start_time": 130.17,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s6_a99",
          "scenario": 7,
          "activation_step": 100,
          "start_time": 131.54,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        }
      ]
    },
    {
      "scenario_id": 8,
      "conflict_count": 6,
      "total_duration": 131.88,
      "activations": [
        {
          "id": "s7_a0",
          "scenario": 8,
          "activation_step": 1,
          "start_time": 0.34,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a1",
          "scenario": 8,
          "activation_step": 2,
          "start_time": 1.58,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a2",
          "scenario": 8,
          "activation_step": 3,
          "start_time": 3.15,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a3",
          "scenario": 8,
          "activation_step": 4,
          "start_time": 4.47,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a4",
          "scenario": 8,
          "activation_step": 5,
          "start_time": 5.62,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a5",
          "scenario": 8,
          "activation_step": 6,
          "start_time": 6.99,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a6",
          "scenario": 8,
          "activation_step": 7,
          "start_time": 8.05,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a7",
          "scenario": 8,
          "activation_step": 8,
          "start_time": 9.23,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a8",
          "scenario": 8,
          "activation_step": 9,
          "start_time": 10.5,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a9",
          "scenario": 8,
          "activation_step": 10,
          "start_time": 11.71,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a10",
          "scenario": 8,
          "activation_step": 11,
          "start_time": 13.12,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a11",
          "scenario": 8,
          "activation_step": 12,
          "start_time": 14.55,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a12",
          "scenario": 8,
          "activation_step": 13,
          "start_time": 15.98,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a13",
          "scenario": 8,
          "activation_step": 14,
          "start_time": 17.27,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a14",
          "scenario": 8,
          "activation_step": 15,
          "start_time": 18.34,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s7_a15",
          "scenario": 8,
          "activation_step": 16,
          "start_time": 19.75,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a16",
          "scenario": 8,
          "activation_step": 17,
          "start_time": 21.25,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a17",
          "scenario": 8,
          "activation_step": 18,
          "start_time": 22.37,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a18",
          "scenario": 8,
          "activation_step": 19,
          "start_time": 23.6,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a19",
          "scenario": 8,
          "activation_step": 20,
          "start_time": 25.07,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a20",
          "scenario": 8,
          "activation_step": 21,
          "start_time": 26.67,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a21",
          "scenario": 8,
          "activation_step": 22,
          "start_time": 28.01,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a22",
          "scenario": 8,
          "activation_step": 23,
          "start_time": 29.07,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a23",
          "scenario": 8,
          "activation_step": 24,
          "start_time": 30.58,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a24",
          "scenario": 8,
          "activation_step": 25,
          "start_time": 31.85,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a25",
          "scenario": 8,
          "activation_step": 26,
          "start_time": 32.99,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a26",
          "scenario": 8,
          "activation_step": 27,
          "start_time": 34.6,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a27",
          "scenario": 8,
          "activation_step": 28,
          "start_time": 35.97,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a28",
          "scenario": 8,
          "activation_step": 29,
          "start_time": 37.17,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a29",
          "scenario": 8,
          "activation_step": 30,
          "start_time": 38.28,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a30",
          "scenario": 8,
          "activation_step": 31,
          "start_time": 39.66,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a31",
          "scenario": 8,
          "activation_step": 32,
          "start_time": 40.95,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a32",
          "scenario": 8,
          "activation_step": 33,
          "start_time": 42.51,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a33",
          "scenario": 8,
          "activation_step": 34,
          "start_time": 43.71,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a34",
          "scenario": 8,
          "activation_step": 35,
          "start_time": 44.99,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a35",
          "scenario": 8,
          "activation_step": 36,
          "start_time": 46.2,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a36",
          "scenario": 8,
          "activation_step": 37,
          "start_time": 47.44,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a37",
          "scenario": 8,
          "activation_step": 38,
          "start_time": 48.7,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a38",
          "scenario": 8,
          "activation_step": 39,
          "start_time": 50.31,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a39",
          "scenario": 8,
          "activation_step": 40,
          "start_time": 51.6,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a40",
          "scenario": 8,
          "activation_step": 41,
          "start_time": 52.39,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s7_a41",
          "scenario": 8,
          "activation_step": 42,
          "start_time": 53.47,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a42",
          "scenario": 8,
          "activation_step": 43,
          "start_time": 55.06,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a43",
          "scenario": 8,
          "activation_step": 44,
          "start_time": 56.43,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a44",
          "scenario": 8,
          "activation_step": 45,
          "start_time": 57.7,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a45",
          "scenario": 8,
          "activation_step": 46,
          "start_time": 59.16,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a46",
          "scenario": 8,
          "activation_step": 47,
          "start_time": 60.65,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a47",
          "scenario": 8,
          "activation_step": 48,
          "start_time": 62.1,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a48",
          "scenario": 8,
          "activation_step": 49,
          "start_time": 63.46,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a49",
          "scenario": 8,
          "activation_step": 50,
          "start_time": 64.88,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a50",
          "scenario": 8,
          "activation_step": 51,
          "start_time": 66.01,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a51",
          "scenario": 8,
          "activation_step": 52,
          "start_time": 67.52,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a52",
          "scenario": 8,
          "activation_step": 53,
          "start_time": 68.81,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a53",
          "scenario": 8,
          "activation_step": 54,
          "start_time": 69.87,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s7_a54",
          "scenario": 8,
          "activation_step": 55,
          "start_time": 71.11,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a55",
          "scenario": 8,
          "activation_step": 56,
          "start_time": 72.52,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a56",
          "scenario": 8,
          "activation_step": 57,
          "start_time": 73.73,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a57",
          "scenario": 8,
          "activation_step": 58,
          "start_time": 75.11,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a58",
          "scenario": 8,
          "activation_step": 59,
          "start_time": 76.41,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a59",
          "scenario": 8,
          "activation_step": 60,
          "start_time": 77.49,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a60",
          "scenario": 8,
          "activation_step": 61,
          "start_time": 78.84,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a61",
          "scenario": 8,
          "activation_step": 62,
          "start_time": 80.25,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a62",
          "scenario": 8,
          "activation_step": 63,
          "start_time": 81.34,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a63",
          "scenario": 8,
          "activation_step": 64,
          "start_time": 82.57,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a64",
          "scenario": 8,
          "activation_step": 65,
          "start_time": 84.04,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a65",
          "scenario": 8,
          "activation_step": 66,
          "start_time": 85.56,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a66",
          "scenario": 8,
          "activation_step": 67,
          "start_time": 87.1,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a67",
          "scenario": 8,
          "activation_step": 68,
          "start_time": 88.45,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a68",
          "scenario": 8,
          "activation_step": 69,
          "start_time": 89.91,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a69",
          "scenario": 8,
          "activation_step": 70,
          "start_time": 91.2,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a70",
          "scenario": 8,
          "activation_step": 71,
          "start_time": 92.34,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s7_a71",
          "scenario": 8,
          "activation_step": 72,
          "start_time": 93.62,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a72",
          "scenario": 8,
          "activation_step": 73,
          "start_time": 95.12,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a73",
          "scenario": 8,
          "activation_step": 74,
          "start_time": 96.73,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a74",
          "scenario": 8,
          "activation_step": 75,
          "start_time": 98.26,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a75",
          "scenario": 8,
          "activation_step": 76,
          "start_time": 99.49,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a76",
          "scenario": 8,
          "activation_step": 77,
          "start_time": 100.65,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a77",
          "scenario": 8,
          "activation_step": 78,
          "start_time": 101.77,
          "duration": 0.8,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a78",
          "scenario": 8,
          "activation_step": 79,
          "start_time": 102.88,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a79",
          "scenario": 8,
          "activation_step": 80,
          "start_time": 104.19,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a80",
          "scenario": 8,
          "activation_step": 81,
          "start_time": 105.04,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s7_a81",
          "scenario": 8,
          "activation_step": 82,
          "start_time": 106.38,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a82",
          "scenario": 8,
          "activation_step": 83,
          "start_time": 107.57,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a83",
          "scenario": 8,
          "activation_step": 84,
          "start_time": 109.12,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a84",
          "scenario": 8,
          "activation_step": 85,
          "start_time": 110.62,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a85",
          "scenario": 8,
          "activation_step": 86,
          "start_time": 111.79,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a86",
          "scenario": 8,
          "activation_step": 87,
          "start_time": 113.2,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a87",
          "scenario": 8,
          "activation_step": 88,
          "start_time": 114.72,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a88",
          "scenario": 8,
          "activation_step": 89,
          "start_time": 116.2,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a89",
          "scenario": 8,
          "activation_step": 90,
          "start_time": 117.39,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a90",
          "scenario": 8,
          "activation_step": 91,
          "start_time": 118.75,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a91",
          "scenario": 8,
          "activation_step": 92,
          "start_time": 120.04,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a92",
          "scenario": 8,
          "activation_step": 93,
          "start_time": 120.98,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s7_a93",
          "scenario": 8,
          "activation_step": 94,
          "start_time": 122.18,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a94",
          "scenario": 8,
          "activation_step": 95,
          "start_time": 123.63,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a95",
          "scenario": 8,
          "activation_step": 96,
          "start_time": 125.02,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a96",
          "scenario": 8,
          "activation_step": 97,
          "start_time": 126.26,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a97",
          "scenario": 8,
          "activation_step": 98,
          "start_time": 127.54,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a98",
          "scenario": 8,
          "activation_step": 99,
          "start_time": 128.71,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s7_a99",
          "scenario": 8,
          "activation_step": 100,
          "start_time": 129.88,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        }
      ]
    },
    {
      "scenario_id": 9,
      "conflict_count": 5,
      "total_duration": 135.33,
      "activations": [
        {
          "id": "s8_a0",
          "scenario": 9,
          "activation_step": 1,
          "start_time": 0.33,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a1",
          "scenario": 9,
          "activation_step": 2,
          "start_time": 1.58,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a2",
          "scenario": 9,
          "activation_step": 3,
          "start_time": 2.99,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a3",
          "scenario": 9,
          "activation_step": 4,
          "start_time": 4.44,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a4",
          "scenario": 9,
          "activation_step": 5,
          "start_time": 5.76,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a5",
          "scenario": 9,
          "activation_step": 6,
          "start_time": 7.24,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a6",
          "scenario": 9,
          "activation_step": 7,
          "start_time": 8.53,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a7",
          "scenario": 9,
          "activation_step": 8,
          "start_time": 10.05,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a8",
          "scenario": 9,
          "activation_step": 9,
          "start_time": 11.62,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a9",
          "scenario": 9,
          "activation_step": 10,
          "start_time": 13.07,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a10",
          "scenario": 9,
          "activation_step": 11,
          "start_time": 14.53,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a11",
          "scenario": 9,
          "activation_step": 12,
          "start_time": 15.74,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a12",
          "scenario": 9,
          "activation_step": 13,
          "start_time": 16.96,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a13",
          "scenario": 9,
          "activation_step": 14,
          "start_time": 18.63,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a14",
          "scenario": 9,
          "activation_step": 15,
          "start_time": 19.92,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a15",
          "scenario": 9,
          "activation_step": 16,
          "start_time": 21.24,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a16",
          "scenario": 9,
          "activation_step": 17,
          "start_time": 22.77,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a17",
          "scenario": 9,
          "activation_step": 18,
          "start_time": 24.25,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a18",
          "scenario": 9,
          "activation_step": 19,
          "start_time": 25.64,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a19",
          "scenario": 9,
          "activation_step": 20,
          "start_time": 27.25,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a20",
          "scenario": 9,
          "activation_step": 21,
          "start_time": 28.61,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a21",
          "scenario": 9,
          "activation_step": 22,
          "start_time": 29.96,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a22",
          "scenario": 9,
          "activation_step": 23,
          "start_time": 31.21,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a23",
          "scenario": 9,
          "activation_step": 24,
          "start_time": 32.33,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a24",
          "scenario": 9,
          "activation_step": 25,
          "start_time": 33.79,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a25",
          "scenario": 9,
          "activation_step": 26,
          "start_time": 34.99,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a26",
          "scenario": 9,
          "activation_step": 27,
          "start_time": 36.21,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a27",
          "scenario": 9,
          "activation_step": 28,
          "start_time": 37.57,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a28",
          "scenario": 9,
          "activation_step": 29,
          "start_time": 39.02,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a29",
          "scenario": 9,
          "activation_step": 30,
          "start_time": 40.07,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a30",
          "scenario": 9,
          "activation_step": 31,
          "start_time": 41.4,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a31",
          "scenario": 9,
          "activation_step": 32,
          "start_time": 43.0,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a32",
          "scenario": 9,
          "activation_step": 33,
          "start_time": 44.39,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a33",
          "scenario": 9,
          "activation_step": 34,
          "start_time": 45.72,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a34",
          "scenario": 9,
          "activation_step": 35,
          "start_time": 47.36,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a35",
          "scenario": 9,
          "activation_step": 36,
          "start_time": 48.91,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a36",
          "scenario": 9,
          "activation_step": 37,
          "start_time": 49.95,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a37",
          "scenario": 9,
          "activation_step": 38,
          "start_time": 51.09,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a38",
          "scenario": 9,
          "activation_step": 39,
          "start_time": 52.55,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a39",
          "scenario": 9,
          "activation_step": 40,
          "start_time": 53.82,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a40",
          "scenario": 9,
          "activation_step": 41,
          "start_time": 54.91,
          "duration": 1.18,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s8_a41",
          "scenario": 9,
          "activation_step": 42,
          "start_time": 56.31,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a42",
          "scenario": 9,
          "activation_step": 43,
          "start_time": 57.86,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a43",
          "scenario": 9,
          "activation_step": 44,
          "start_time": 59.07,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a44",
          "scenario": 9,
          "activation_step": 45,
          "start_time": 60.51,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a45",
          "scenario": 9,
          "activation_step": 46,
          "start_time": 61.85,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a46",
          "scenario": 9,
          "activation_step": 47,
          "start_time": 63.06,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a47",
          "scenario": 9,
          "activation_step": 48,
          "start_time": 64.05,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s8_a48",
          "scenario": 9,
          "activation_step": 49,
          "start_time": 65.58,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a49",
          "scenario": 9,
          "activation_step": 50,
          "start_time": 67.09,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a50",
          "scenario": 9,
          "activation_step": 51,
          "start_time": 68.2,
          "duration": 1.0,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s8_a51",
          "scenario": 9,
          "activation_step": 52,
          "start_time": 69.47,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a52",
          "scenario": 9,
          "activation_step": 53,
          "start_time": 70.93,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a53",
          "scenario": 9,
          "activation_step": 54,
          "start_time": 72.16,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a54",
          "scenario": 9,
          "activation_step": 55,
          "start_time": 73.25,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a55",
          "scenario": 9,
          "activation_step": 56,
          "start_time": 74.41,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a56",
          "scenario": 9,
          "activation_step": 57,
          "start_time": 75.68,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a57",
          "scenario": 9,
          "activation_step": 58,
          "start_time": 76.89,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a58",
          "scenario": 9,
          "activation_step": 59,
          "start_time": 78.5,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a59",
          "scenario": 9,
          "activation_step": 60,
          "start_time": 79.79,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a60",
          "scenario": 9,
          "activation_step": 61,
          "start_time": 80.97,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a61",
          "scenario": 9,
          "activation_step": 62,
          "start_time": 82.52,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a62",
          "scenario": 9,
          "activation_step": 63,
          "start_time": 84.05,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a63",
          "scenario": 9,
          "activation_step": 64,
          "start_time": 85.31,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a64",
          "scenario": 9,
          "activation_step": 65,
          "start_time": 86.71,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a65",
          "scenario": 9,
          "activation_step": 66,
          "start_time": 87.92,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a66",
          "scenario": 9,
          "activation_step": 67,
          "start_time": 89.53,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a67",
          "scenario": 9,
          "activation_step": 68,
          "start_time": 90.9,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a68",
          "scenario": 9,
          "activation_step": 69,
          "start_time": 92.28,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a69",
          "scenario": 9,
          "activation_step": 70,
          "start_time": 93.72,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a70",
          "scenario": 9,
          "activation_step": 71,
          "start_time": 95.15,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a71",
          "scenario": 9,
          "activation_step": 72,
          "start_time": 96.49,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a72",
          "scenario": 9,
          "activation_step": 73,
          "start_time": 97.88,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a73",
          "scenario": 9,
          "activation_step": 74,
          "start_time": 99.22,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a74",
          "scenario": 9,
          "activation_step": 75,
          "start_time": 100.35,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a75",
          "scenario": 9,
          "activation_step": 76,
          "start_time": 101.87,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a76",
          "scenario": 9,
          "activation_step": 77,
          "start_time": 102.99,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a77",
          "scenario": 9,
          "activation_step": 78,
          "start_time": 104.35,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a78",
          "scenario": 9,
          "activation_step": 79,
          "start_time": 105.6,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a79",
          "scenario": 9,
          "activation_step": 80,
          "start_time": 106.89,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a80",
          "scenario": 9,
          "activation_step": 81,
          "start_time": 107.98,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a81",
          "scenario": 9,
          "activation_step": 82,
          "start_time": 109.41,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a82",
          "scenario": 9,
          "activation_step": 83,
          "start_time": 110.76,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a83",
          "scenario": 9,
          "activation_step": 84,
          "start_time": 111.9,
          "duration": 1.07,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s8_a84",
          "scenario": 9,
          "activation_step": 85,
          "start_time": 113.27,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a85",
          "scenario": 9,
          "activation_step": 86,
          "start_time": 114.57,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a86",
          "scenario": 9,
          "activation_step": 87,
          "start_time": 115.88,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a87",
          "scenario": 9,
          "activation_step": 88,
          "start_time": 117.16,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a88",
          "scenario": 9,
          "activation_step": 89,
          "start_time": 118.49,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a89",
          "scenario": 9,
          "activation_step": 90,
          "start_time": 119.89,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a90",
          "scenario": 9,
          "activation_step": 91,
          "start_time": 121.17,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a91",
          "scenario": 9,
          "activation_step": 92,
          "start_time": 122.44,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a92",
          "scenario": 9,
          "activation_step": 93,
          "start_time": 124.08,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a93",
          "scenario": 9,
          "activation_step": 94,
          "start_time": 125.33,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a94",
          "scenario": 9,
          "activation_step": 95,
          "start_time": 126.53,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a95",
          "scenario": 9,
          "activation_step": 96,
          "start_time": 127.73,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a96",
          "scenario": 9,
          "activation_step": 97,
          "start_time": 129.11,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a97",
          "scenario": 9,
          "activation_step": 98,
          "start_time": 130.16,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s8_a98",
          "scenario": 9,
          "activation_step": 99,
          "start_time": 131.78,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s8_a99",
          "scenario": 9,
          "activation_step": 100,
          "start_time": 133.33,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        }
      ]
    },
    {
      "scenario_id": 10,
      "conflict_count": 6,
      "total_duration": 132.33,
      "activations": [
        {
          "id": "s9_a0",
          "scenario": 10,
          "activation_step": 1,
          "start_time": 0.23,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a1",
          "scenario": 10,
          "activation_step": 2,
          "start_time": 1.77,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a2",
          "scenario": 10,
          "activation_step": 3,
          "start_time": 3.13,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a3",
          "scenario": 10,
          "activation_step": 4,
          "start_time": 4.49,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a4",
          "scenario": 10,
          "activation_step": 5,
          "start_time": 5.71,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a5",
          "scenario": 10,
          "activation_step": 6,
          "start_time": 6.99,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a6",
          "scenario": 10,
          "activation_step": 7,
          "start_time": 8.37,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a7",
          "scenario": 10,
          "activation_step": 8,
          "start_time": 9.59,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a8",
          "scenario": 10,
          "activation_step": 9,
          "start_time": 11.12,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a9",
          "scenario": 10,
          "activation_step": 10,
          "start_time": 12.39,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a10",
          "scenario": 10,
          "activation_step": 11,
          "start_time": 13.57,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a11",
          "scenario": 10,
          "activation_step": 12,
          "start_time": 14.91,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a12",
          "scenario": 10,
          "activation_step": 13,
          "start_time": 16.09,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a13",
          "scenario": 10,
          "activation_step": 14,
          "start_time": 17.46,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a14",
          "scenario": 10,
          "activation_step": 15,
          "start_time": 18.59,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a15",
          "scenario": 10,
          "activation_step": 16,
          "start_time": 20.08,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a16",
          "scenario": 10,
          "activation_step": 17,
          "start_time": 21.15,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a17",
          "scenario": 10,
          "activation_step": 18,
          "start_time": 22.48,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a18",
          "scenario": 10,
          "activation_step": 19,
          "start_time": 24.0,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a19",
          "scenario": 10,
          "activation_step": 20,
          "start_time": 25.18,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a20",
          "scenario": 10,
          "activation_step": 21,
          "start_time": 26.58,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a21",
          "scenario": 10,
          "activation_step": 22,
          "start_time": 28.0,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a22",
          "scenario": 10,
          "activation_step": 23,
          "start_time": 29.44,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a23",
          "scenario": 10,
          "activation_step": 24,
          "start_time": 30.88,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a24",
          "scenario": 10,
          "activation_step": 25,
          "start_time": 32.15,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a25",
          "scenario": 10,
          "activation_step": 26,
          "start_time": 33.43,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a26",
          "scenario": 10,
          "activation_step": 27,
          "start_time": 35.08,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a27",
          "scenario": 10,
          "activation_step": 28,
          "start_time": 36.58,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a28",
          "scenario": 10,
          "activation_step": 29,
          "start_time": 38.01,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a29",
          "scenario": 10,
          "activation_step": 30,
          "start_time": 39.41,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a30",
          "scenario": 10,
          "activation_step": 31,
          "start_time": 40.69,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a31",
          "scenario": 10,
          "activation_step": 32,
          "start_time": 41.96,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a32",
          "scenario": 10,
          "activation_step": 33,
          "start_time": 43.33,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a33",
          "scenario": 10,
          "activation_step": 34,
          "start_time": 44.76,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a34",
          "scenario": 10,
          "activation_step": 35,
          "start_time": 46.26,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a35",
          "scenario": 10,
          "activation_step": 36,
          "start_time": 47.7,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a36",
          "scenario": 10,
          "activation_step": 37,
          "start_time": 49.33,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a37",
          "scenario": 10,
          "activation_step": 38,
          "start_time": 50.67,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a38",
          "scenario": 10,
          "activation_step": 39,
          "start_time": 52.05,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a39",
          "scenario": 10,
          "activation_step": 40,
          "start_time": 53.3,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a40",
          "scenario": 10,
          "activation_step": 41,
          "start_time": 54.51,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a41",
          "scenario": 10,
          "activation_step": 42,
          "start_time": 56.06,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a42",
          "scenario": 10,
          "activation_step": 43,
          "start_time": 57.29,
          "duration": 0.8,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a43",
          "scenario": 10,
          "activation_step": 44,
          "start_time": 58.3,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a44",
          "scenario": 10,
          "activation_step": 45,
          "start_time": 59.48,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a45",
          "scenario": 10,
          "activation_step": 46,
          "start_time": 61.05,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a46",
          "scenario": 10,
          "activation_step": 47,
          "start_time": 62.59,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a47",
          "scenario": 10,
          "activation_step": 48,
          "start_time": 63.87,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a48",
          "scenario": 10,
          "activation_step": 49,
          "start_time": 65.01,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a49",
          "scenario": 10,
          "activation_step": 50,
          "start_time": 66.11,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a50",
          "scenario": 10,
          "activation_step": 51,
          "start_time": 67.57,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a51",
          "scenario": 10,
          "activation_step": 52,
          "start_time": 69.09,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a52",
          "scenario": 10,
          "activation_step": 53,
          "start_time": 70.29,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a53",
          "scenario": 10,
          "activation_step": 54,
          "start_time": 71.61,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a54",
          "scenario": 10,
          "activation_step": 55,
          "start_time": 73.13,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a55",
          "scenario": 10,
          "activation_step": 56,
          "start_time": 74.04,
          "duration": 0.81,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s9_a56",
          "scenario": 10,
          "activation_step": 57,
          "start_time": 75.06,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a57",
          "scenario": 10,
          "activation_step": 58,
          "start_time": 76.57,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a58",
          "scenario": 10,
          "activation_step": 59,
          "start_time": 78.03,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a59",
          "scenario": 10,
          "activation_step": 60,
          "start_time": 79.41,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a60",
          "scenario": 10,
          "activation_step": 61,
          "start_time": 80.54,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a61",
          "scenario": 10,
          "activation_step": 62,
          "start_time": 82.07,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a62",
          "scenario": 10,
          "activation_step": 63,
          "start_time": 83.61,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a63",
          "scenario": 10,
          "activation_step": 64,
          "start_time": 84.83,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a64",
          "scenario": 10,
          "activation_step": 65,
          "start_time": 86.01,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a65",
          "scenario": 10,
          "activation_step": 66,
          "start_time": 87.32,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a66",
          "scenario": 10,
          "activation_step": 67,
          "start_time": 88.63,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a67",
          "scenario": 10,
          "activation_step": 68,
          "start_time": 89.92,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a68",
          "scenario": 10,
          "activation_step": 69,
          "start_time": 91.24,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a69",
          "scenario": 10,
          "activation_step": 70,
          "start_time": 92.41,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a70",
          "scenario": 10,
          "activation_step": 71,
          "start_time": 93.7,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a71",
          "scenario": 10,
          "activation_step": 72,
          "start_time": 94.69,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s9_a72",
          "scenario": 10,
          "activation_step": 73,
          "start_time": 96.19,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a73",
          "scenario": 10,
          "activation_step": 74,
          "start_time": 97.67,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a74",
          "scenario": 10,
          "activation_step": 75,
          "start_time": 98.76,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a75",
          "scenario": 10,
          "activation_step": 76,
          "start_time": 100.36,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a76",
          "scenario": 10,
          "activation_step": 77,
          "start_time": 101.28,
          "duration": 0.85,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s9_a77",
          "scenario": 10,
          "activation_step": 78,
          "start_time": 102.57,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a78",
          "scenario": 10,
          "activation_step": 79,
          "start_time": 104.19,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a79",
          "scenario": 10,
          "activation_step": 80,
          "start_time": 105.5,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a80",
          "scenario": 10,
          "activation_step": 81,
          "start_time": 106.77,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a81",
          "scenario": 10,
          "activation_step": 82,
          "start_time": 108.08,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a82",
          "scenario": 10,
          "activation_step": 83,
          "start_time": 109.5,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a83",
          "scenario": 10,
          "activation_step": 84,
          "start_time": 110.36,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s9_a84",
          "scenario": 10,
          "activation_step": 85,
          "start_time": 111.85,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a85",
          "scenario": 10,
          "activation_step": 86,
          "start_time": 113.31,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a86",
          "scenario": 10,
          "activation_step": 87,
          "start_time": 114.22,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s9_a87",
          "scenario": 10,
          "activation_step": 88,
          "start_time": 115.42,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a88",
          "scenario": 10,
          "activation_step": 89,
          "start_time": 117.04,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a89",
          "scenario": 10,
          "activation_step": 90,
          "start_time": 118.12,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a90",
          "scenario": 10,
          "activation_step": 91,
          "start_time": 119.51,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a91",
          "scenario": 10,
          "activation_step": 92,
          "start_time": 120.7,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a92",
          "scenario": 10,
          "activation_step": 93,
          "start_time": 121.97,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a93",
          "scenario": 10,
          "activation_step": 94,
          "start_time": 123.43,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a94",
          "scenario": 10,
          "activation_step": 95,
          "start_time": 124.64,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a95",
          "scenario": 10,
          "activation_step": 96,
          "start_time": 125.56,
          "duration": 0.89,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s9_a96",
          "scenario": 10,
          "activation_step": 97,
          "start_time": 126.72,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a97",
          "scenario": 10,
          "activation_step": 98,
          "start_time": 127.92,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a98",
          "scenario": 10,
          "activation_step": 99,
          "start_time": 128.94,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s9_a99",
          "scenario": 10,
          "activation_step": 100,
          "start_time": 130.33,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        }
      ]
    },
    {
      "scenario_id": 11,
      "conflict_count": 4,
      "total_duration": 133.65,
      "activations": [
        {
          "id": "s10_a0",
          "scenario": 11,
          "activation_step": 1,
          "start_time": 0.39,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a1",
          "scenario": 11,
          "activation_step": 2,
          "start_time": 1.76,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a2",
          "scenario": 11,
          "activation_step": 3,
          "start_time": 2.6,
          "duration": 0.95,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s10_a3",
          "scenario": 11,
          "activation_step": 4,
          "start_time": 3.81,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a4",
          "scenario": 11,
          "activation_step": 5,
          "start_time": 5.07,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a5",
          "scenario": 11,
          "activation_step": 6,
          "start_time": 6.32,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a6",
          "scenario": 11,
          "activation_step": 7,
          "start_time": 7.51,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a7",
          "scenario": 11,
          "activation_step": 8,
          "start_time": 8.91,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a8",
          "scenario": 11,
          "activation_step": 9,
          "start_time": 9.98,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a9",
          "scenario": 11,
          "activation_step": 10,
          "start_time": 11.25,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a10",
          "scenario": 11,
          "activation_step": 11,
          "start_time": 12.56,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a11",
          "scenario": 11,
          "activation_step": 12,
          "start_time": 13.8,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a12",
          "scenario": 11,
          "activation_step": 13,
          "start_time": 14.57,
          "duration": 1.05,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s10_a13",
          "scenario": 11,
          "activation_step": 14,
          "start_time": 16.1,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a14",
          "scenario": 11,
          "activation_step": 15,
          "start_time": 17.28,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a15",
          "scenario": 11,
          "activation_step": 16,
          "start_time": 18.72,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a16",
          "scenario": 11,
          "activation_step": 17,
          "start_time": 20.07,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a17",
          "scenario": 11,
          "activation_step": 18,
          "start_time": 21.32,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a18",
          "scenario": 11,
          "activation_step": 19,
          "start_time": 22.4,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a19",
          "scenario": 11,
          "activation_step": 20,
          "start_time": 23.63,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a20",
          "scenario": 11,
          "activation_step": 21,
          "start_time": 25.08,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a21",
          "scenario": 11,
          "activation_step": 22,
          "start_time": 26.5,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a22",
          "scenario": 11,
          "activation_step": 23,
          "start_time": 28.07,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a23",
          "scenario": 11,
          "activation_step": 24,
          "start_time": 29.58,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a24",
          "scenario": 11,
          "activation_step": 25,
          "start_time": 31.08,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a25",
          "scenario": 11,
          "activation_step": 26,
          "start_time": 32.26,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a26",
          "scenario": 11,
          "activation_step": 27,
          "start_time": 33.43,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a27",
          "scenario": 11,
          "activation_step": 28,
          "start_time": 34.74,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a28",
          "scenario": 11,
          "activation_step": 29,
          "start_time": 35.93,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a29",
          "scenario": 11,
          "activation_step": 30,
          "start_time": 37.26,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a30",
          "scenario": 11,
          "activation_step": 31,
          "start_time": 38.54,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a31",
          "scenario": 11,
          "activation_step": 32,
          "start_time": 39.84,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a32",
          "scenario": 11,
          "activation_step": 33,
          "start_time": 41.07,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a33",
          "scenario": 11,
          "activation_step": 34,
          "start_time": 42.68,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a34",
          "scenario": 11,
          "activation_step": 35,
          "start_time": 43.78,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a35",
          "scenario": 11,
          "activation_step": 36,
          "start_time": 45.32,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a36",
          "scenario": 11,
          "activation_step": 37,
          "start_time": 46.65,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a37",
          "scenario": 11,
          "activation_step": 38,
          "start_time": 47.9,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a38",
          "scenario": 11,
          "activation_step": 39,
          "start_time": 49.31,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a39",
          "scenario": 11,
          "activation_step": 40,
          "start_time": 50.62,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a40",
          "scenario": 11,
          "activation_step": 41,
          "start_time": 51.94,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a41",
          "scenario": 11,
          "activation_step": 42,
          "start_time": 53.41,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a42",
          "scenario": 11,
          "activation_step": 43,
          "start_time": 54.47,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s10_a43",
          "scenario": 11,
          "activation_step": 44,
          "start_time": 55.65,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a44",
          "scenario": 11,
          "activation_step": 45,
          "start_time": 57.15,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a45",
          "scenario": 11,
          "activation_step": 46,
          "start_time": 58.53,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a46",
          "scenario": 11,
          "activation_step": 47,
          "start_time": 60.01,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a47",
          "scenario": 11,
          "activation_step": 48,
          "start_time": 61.53,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a48",
          "scenario": 11,
          "activation_step": 49,
          "start_time": 63.08,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a49",
          "scenario": 11,
          "activation_step": 50,
          "start_time": 64.6,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a50",
          "scenario": 11,
          "activation_step": 51,
          "start_time": 65.7,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a51",
          "scenario": 11,
          "activation_step": 52,
          "start_time": 66.94,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a52",
          "scenario": 11,
          "activation_step": 53,
          "start_time": 68.24,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a53",
          "scenario": 11,
          "activation_step": 54,
          "start_time": 69.68,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a54",
          "scenario": 11,
          "activation_step": 55,
          "start_time": 70.97,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a55",
          "scenario": 11,
          "activation_step": 56,
          "start_time": 72.23,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a56",
          "scenario": 11,
          "activation_step": 57,
          "start_time": 73.79,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a57",
          "scenario": 11,
          "activation_step": 58,
          "start_time": 75.05,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a58",
          "scenario": 11,
          "activation_step": 59,
          "start_time": 76.51,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a59",
          "scenario": 11,
          "activation_step": 60,
          "start_time": 77.63,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a60",
          "scenario": 11,
          "activation_step": 61,
          "start_time": 79.11,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a61",
          "scenario": 11,
          "activation_step": 62,
          "start_time": 80.49,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a62",
          "scenario": 11,
          "activation_step": 63,
          "start_time": 81.67,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a63",
          "scenario": 11,
          "activation_step": 64,
          "start_time": 83.18,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a64",
          "scenario": 11,
          "activation_step": 65,
          "start_time": 84.43,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a65",
          "scenario": 11,
          "activation_step": 66,
          "start_time": 86.01,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a66",
          "scenario": 11,
          "activation_step": 67,
          "start_time": 87.52,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a67",
          "scenario": 11,
          "activation_step": 68,
          "start_time": 89.17,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a68",
          "scenario": 11,
          "activation_step": 69,
          "start_time": 90.56,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a69",
          "scenario": 11,
          "activation_step": 70,
          "start_time": 91.63,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a70",
          "scenario": 11,
          "activation_step": 71,
          "start_time": 92.74,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a71",
          "scenario": 11,
          "activation_step": 72,
          "start_time": 94.2,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a72",
          "scenario": 11,
          "activation_step": 73,
          "start_time": 95.53,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a73",
          "scenario": 11,
          "activation_step": 74,
          "start_time": 96.83,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a74",
          "scenario": 11,
          "activation_step": 75,
          "start_time": 98.11,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a75",
          "scenario": 11,
          "activation_step": 76,
          "start_time": 99.7,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a76",
          "scenario": 11,
          "activation_step": 77,
          "start_time": 101.04,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a77",
          "scenario": 11,
          "activation_step": 78,
          "start_time": 102.38,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a78",
          "scenario": 11,
          "activation_step": 79,
          "start_time": 103.71,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a79",
          "scenario": 11,
          "activation_step": 80,
          "start_time": 104.8,
          "duration": 1.19,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s10_a80",
          "scenario": 11,
          "activation_step": 81,
          "start_time": 106.22,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a81",
          "scenario": 11,
          "activation_step": 82,
          "start_time": 107.72,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a82",
          "scenario": 11,
          "activation_step": 83,
          "start_time": 108.91,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a83",
          "scenario": 11,
          "activation_step": 84,
          "start_time": 110.29,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a84",
          "scenario": 11,
          "activation_step": 85,
          "start_time": 111.69,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a85",
          "scenario": 11,
          "activation_step": 86,
          "start_time": 112.94,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a86",
          "scenario": 11,
          "activation_step": 87,
          "start_time": 114.5,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a87",
          "scenario": 11,
          "activation_step": 88,
          "start_time": 115.73,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a88",
          "scenario": 11,
          "activation_step": 89,
          "start_time": 117.16,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a89",
          "scenario": 11,
          "activation_step": 90,
          "start_time": 118.54,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a90",
          "scenario": 11,
          "activation_step": 91,
          "start_time": 119.81,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a91",
          "scenario": 11,
          "activation_step": 92,
          "start_time": 121.19,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a92",
          "scenario": 11,
          "activation_step": 93,
          "start_time": 122.39,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a93",
          "scenario": 11,
          "activation_step": 94,
          "start_time": 123.81,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a94",
          "scenario": 11,
          "activation_step": 95,
          "start_time": 125.07,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a95",
          "scenario": 11,
          "activation_step": 96,
          "start_time": 126.31,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a96",
          "scenario": 11,
          "activation_step": 97,
          "start_time": 127.64,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a97",
          "scenario": 11,
          "activation_step": 98,
          "start_time": 128.85,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a98",
          "scenario": 11,
          "activation_step": 99,
          "start_time": 130.06,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s10_a99",
          "scenario": 11,
          "activation_step": 100,
          "start_time": 131.65,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        }
      ]
    },
    {
      "scenario_id": 12,
      "conflict_count": 3,
      "total_duration": 133.04,
      "activations": [
        {
          "id": "s11_a0",
          "scenario": 12,
          "activation_step": 1,
          "start_time": 0.27,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a1",
          "scenario": 12,
          "activation_step": 2,
          "start_time": 1.55,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a2",
          "scenario": 12,
          "activation_step": 3,
          "start_time": 2.89,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a3",
          "scenario": 12,
          "activation_step": 4,
          "start_time": 4.29,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a4",
          "scenario": 12,
          "activation_step": 5,
          "start_time": 5.8,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a5",
          "scenario": 12,
          "activation_step": 6,
          "start_time": 6.84,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a6",
          "scenario": 12,
          "activation_step": 7,
          "start_time": 8.22,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a7",
          "scenario": 12,
          "activation_step": 8,
          "start_time": 9.68,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a8",
          "scenario": 12,
          "activation_step": 9,
          "start_time": 11.07,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a9",
          "scenario": 12,
          "activation_step": 10,
          "start_time": 12.55,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a10",
          "scenario": 12,
          "activation_step": 11,
          "start_time": 13.86,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a11",
          "scenario": 12,
          "activation_step": 12,
          "start_time": 15.22,
          "duration": 0.8,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a12",
          "scenario": 12,
          "activation_step": 13,
          "start_time": 16.46,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a13",
          "scenario": 12,
          "activation_step": 14,
          "start_time": 17.87,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a14",
          "scenario": 12,
          "activation_step": 15,
          "start_time": 18.99,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a15",
          "scenario": 12,
          "activation_step": 16,
          "start_time": 20.12,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a16",
          "scenario": 12,
          "activation_step": 17,
          "start_time": 21.48,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a17",
          "scenario": 12,
          "activation_step": 18,
          "start_time": 22.85,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a18",
          "scenario": 12,
          "activation_step": 19,
          "start_time": 24.08,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a19",
          "scenario": 12,
          "activation_step": 20,
          "start_time": 25.69,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a20",
          "scenario": 12,
          "activation_step": 21,
          "start_time": 27.37,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a21",
          "scenario": 12,
          "activation_step": 22,
          "start_time": 28.78,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a22",
          "scenario": 12,
          "activation_step": 23,
          "start_time": 30.02,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a23",
          "scenario": 12,
          "activation_step": 24,
          "start_time": 31.19,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a24",
          "scenario": 12,
          "activation_step": 25,
          "start_time": 32.69,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a25",
          "scenario": 12,
          "activation_step": 26,
          "start_time": 33.93,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a26",
          "scenario": 12,
          "activation_step": 27,
          "start_time": 35.48,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a27",
          "scenario": 12,
          "activation_step": 28,
          "start_time": 36.63,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a28",
          "scenario": 12,
          "activation_step": 29,
          "start_time": 37.42,
          "duration": 0.96,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s11_a29",
          "scenario": 12,
          "activation_step": 30,
          "start_time": 38.68,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a30",
          "scenario": 12,
          "activation_step": 31,
          "start_time": 40.06,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a31",
          "scenario": 12,
          "activation_step": 32,
          "start_time": 41.14,
          "duration": 1.04,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s11_a32",
          "scenario": 12,
          "activation_step": 33,
          "start_time": 42.52,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a33",
          "scenario": 12,
          "activation_step": 34,
          "start_time": 43.86,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a34",
          "scenario": 12,
          "activation_step": 35,
          "start_time": 45.35,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a35",
          "scenario": 12,
          "activation_step": 36,
          "start_time": 46.69,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a36",
          "scenario": 12,
          "activation_step": 37,
          "start_time": 47.94,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a37",
          "scenario": 12,
          "activation_step": 38,
          "start_time": 49.4,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a38",
          "scenario": 12,
          "activation_step": 39,
          "start_time": 51.06,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a39",
          "scenario": 12,
          "activation_step": 40,
          "start_time": 52.39,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a40",
          "scenario": 12,
          "activation_step": 41,
          "start_time": 53.64,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a41",
          "scenario": 12,
          "activation_step": 42,
          "start_time": 54.72,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a42",
          "scenario": 12,
          "activation_step": 43,
          "start_time": 55.84,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a43",
          "scenario": 12,
          "activation_step": 44,
          "start_time": 57.09,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a44",
          "scenario": 12,
          "activation_step": 45,
          "start_time": 58.22,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a45",
          "scenario": 12,
          "activation_step": 46,
          "start_time": 59.32,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a46",
          "scenario": 12,
          "activation_step": 47,
          "start_time": 60.5,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a47",
          "scenario": 12,
          "activation_step": 48,
          "start_time": 61.96,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a48",
          "scenario": 12,
          "activation_step": 49,
          "start_time": 63.25,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a49",
          "scenario": 12,
          "activation_step": 50,
          "start_time": 64.51,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a50",
          "scenario": 12,
          "activation_step": 51,
          "start_time": 65.93,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a51",
          "scenario": 12,
          "activation_step": 52,
          "start_time": 67.26,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a52",
          "scenario": 12,
          "activation_step": 53,
          "start_time": 68.54,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a53",
          "scenario": 12,
          "activation_step": 54,
          "start_time": 70.03,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a54",
          "scenario": 12,
          "activation_step": 55,
          "start_time": 71.07,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a55",
          "scenario": 12,
          "activation_step": 56,
          "start_time": 72.44,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a56",
          "scenario": 12,
          "activation_step": 57,
          "start_time": 73.89,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a57",
          "scenario": 12,
          "activation_step": 58,
          "start_time": 75.33,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a58",
          "scenario": 12,
          "activation_step": 59,
          "start_time": 76.89,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a59",
          "scenario": 12,
          "activation_step": 60,
          "start_time": 78.23,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a60",
          "scenario": 12,
          "activation_step": 61,
          "start_time": 79.83,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a61",
          "scenario": 12,
          "activation_step": 62,
          "start_time": 81.31,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a62",
          "scenario": 12,
          "activation_step": 63,
          "start_time": 82.57,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a63",
          "scenario": 12,
          "activation_step": 64,
          "start_time": 84.01,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a64",
          "scenario": 12,
          "activation_step": 65,
          "start_time": 85.23,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a65",
          "scenario": 12,
          "activation_step": 66,
          "start_time": 86.4,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a66",
          "scenario": 12,
          "activation_step": 67,
          "start_time": 87.7,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a67",
          "scenario": 12,
          "activation_step": 68,
          "start_time": 89.11,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a68",
          "scenario": 12,
          "activation_step": 69,
          "start_time": 90.36,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a69",
          "scenario": 12,
          "activation_step": 70,
          "start_time": 91.53,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a70",
          "scenario": 12,
          "activation_step": 71,
          "start_time": 92.81,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a71",
          "scenario": 12,
          "activation_step": 72,
          "start_time": 94.24,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a72",
          "scenario": 12,
          "activation_step": 73,
          "start_time": 95.65,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a73",
          "scenario": 12,
          "activation_step": 74,
          "start_time": 97.2,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a74",
          "scenario": 12,
          "activation_step": 75,
          "start_time": 98.39,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a75",
          "scenario": 12,
          "activation_step": 76,
          "start_time": 99.83,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a76",
          "scenario": 12,
          "activation_step": 77,
          "start_time": 101.12,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a77",
          "scenario": 12,
          "activation_step": 78,
          "start_time": 102.62,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a78",
          "scenario": 12,
          "activation_step": 79,
          "start_time": 103.92,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a79",
          "scenario": 12,
          "activation_step": 80,
          "start_time": 104.96,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a80",
          "scenario": 12,
          "activation_step": 81,
          "start_time": 106.35,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a81",
          "scenario": 12,
          "activation_step": 82,
          "start_time": 107.35,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s11_a82",
          "scenario": 12,
          "activation_step": 83,
          "start_time": 108.5,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a83",
          "scenario": 12,
          "activation_step": 84,
          "start_time": 110.01,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a84",
          "scenario": 12,
          "activation_step": 85,
          "start_time": 111.41,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a85",
          "scenario": 12,
          "activation_step": 86,
          "start_time": 112.48,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a86",
          "scenario": 12,
          "activation_step": 87,
          "start_time": 113.67,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a87",
          "scenario": 12,
          "activation_step": 88,
          "start_time": 114.92,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a88",
          "scenario": 12,
          "activation_step": 89,
          "start_time": 116.19,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a89",
          "scenario": 12,
          "activation_step": 90,
          "start_time": 117.52,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a90",
          "scenario": 12,
          "activation_step": 91,
          "start_time": 118.78,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a91",
          "scenario": 12,
          "activation_step": 92,
          "start_time": 119.92,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a92",
          "scenario": 12,
          "activation_step": 93,
          "start_time": 121.33,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a93",
          "scenario": 12,
          "activation_step": 94,
          "start_time": 122.6,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a94",
          "scenario": 12,
          "activation_step": 95,
          "start_time": 124.0,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a95",
          "scenario": 12,
          "activation_step": 96,
          "start_time": 125.42,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a96",
          "scenario": 12,
          "activation_step": 97,
          "start_time": 126.98,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a97",
          "scenario": 12,
          "activation_step": 98,
          "start_time": 128.36,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a98",
          "scenario": 12,
          "activation_step": 99,
          "start_time": 129.88,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s11_a99",
          "scenario": 12,
          "activation_step": 100,
          "start_time": 131.04,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        }
      ]
    },
    {
      "scenario_id": 13,
      "conflict_count": 4,
      "total_duration": 137.33,
      "activations": [
        {
          "id": "s12_a0",
          "scenario": 13,
          "activation_step": 1,
          "start_time": 0.34,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a1",
          "scenario": 13,
          "activation_step": 2,
          "start_time": 1.64,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a2",
          "scenario": 13,
          "activation_step": 3,
          "start_time": 2.95,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a3",
          "scenario": 13,
          "activation_step": 4,
          "start_time": 4.51,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a4",
          "scenario": 13,
          "activation_step": 5,
          "start_time": 6.07,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a5",
          "scenario": 13,
          "activation_step": 6,
          "start_time": 7.69,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a6",
          "scenario": 13,
          "activation_step": 7,
          "start_time": 9.03,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a7",
          "scenario": 13,
          "activation_step": 8,
          "start_time": 10.38,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a8",
          "scenario": 13,
          "activation_step": 9,
          "start_time": 11.69,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a9",
          "scenario": 13,
          "activation_step": 10,
          "start_time": 13.03,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a10",
          "scenario": 13,
          "activation_step": 11,
          "start_time": 14.49,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a11",
          "scenario": 13,
          "activation_step": 12,
          "start_time": 15.83,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a12",
          "scenario": 13,
          "activation_step": 13,
          "start_time": 17.34,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a13",
          "scenario": 13,
          "activation_step": 14,
          "start_time": 18.79,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a14",
          "scenario": 13,
          "activation_step": 15,
          "start_time": 20.42,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a15",
          "scenario": 13,
          "activation_step": 16,
          "start_time": 21.73,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a16",
          "scenario": 13,
          "activation_step": 17,
          "start_time": 23.38,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a17",
          "scenario": 13,
          "activation_step": 18,
          "start_time": 24.79,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a18",
          "scenario": 13,
          "activation_step": 19,
          "start_time": 25.98,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a19",
          "scenario": 13,
          "activation_step": 20,
          "start_time": 27.1,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a20",
          "scenario": 13,
          "activation_step": 21,
          "start_time": 28.62,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a21",
          "scenario": 13,
          "activation_step": 22,
          "start_time": 30.12,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a22",
          "scenario": 13,
          "activation_step": 23,
          "start_time": 31.45,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a23",
          "scenario": 13,
          "activation_step": 24,
          "start_time": 32.62,
          "duration": 1.03,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s12_a24",
          "scenario": 13,
          "activation_step": 25,
          "start_time": 33.99,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a25",
          "scenario": 13,
          "activation_step": 26,
          "start_time": 35.53,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a26",
          "scenario": 13,
          "activation_step": 27,
          "start_time": 36.9,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a27",
          "scenario": 13,
          "activation_step": 28,
          "start_time": 38.54,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a28",
          "scenario": 13,
          "activation_step": 29,
          "start_time": 40.05,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a29",
          "scenario": 13,
          "activation_step": 30,
          "start_time": 41.28,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a30",
          "scenario": 13,
          "activation_step": 31,
          "start_time": 42.88,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a31",
          "scenario": 13,
          "activation_step": 32,
          "start_time": 44.2,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a32",
          "scenario": 13,
          "activation_step": 33,
          "start_time": 45.74,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a33",
          "scenario": 13,
          "activation_step": 34,
          "start_time": 47.11,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a34",
          "scenario": 13,
          "activation_step": 35,
          "start_time": 48.4,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a35",
          "scenario": 13,
          "activation_step": 36,
          "start_time": 49.83,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a36",
          "scenario": 13,
          "activation_step": 37,
          "start_time": 50.96,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a37",
          "scenario": 13,
          "activation_step": 38,
          "start_time": 52.22,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a38",
          "scenario": 13,
          "activation_step": 39,
          "start_time": 53.5,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a39",
          "scenario": 13,
          "activation_step": 40,
          "start_time": 55.0,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a40",
          "scenario": 13,
          "activation_step": 41,
          "start_time": 56.31,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a41",
          "scenario": 13,
          "activation_step": 42,
          "start_time": 57.75,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a42",
          "scenario": 13,
          "activation_step": 43,
          "start_time": 59.19,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a43",
          "scenario": 13,
          "activation_step": 44,
          "start_time": 60.49,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a44",
          "scenario": 13,
          "activation_step": 45,
          "start_time": 61.66,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a45",
          "scenario": 13,
          "activation_step": 46,
          "start_time": 62.99,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a46",
          "scenario": 13,
          "activation_step": 47,
          "start_time": 64.63,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a47",
          "scenario": 13,
          "activation_step": 48,
          "start_time": 66.0,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a48",
          "scenario": 13,
          "activation_step": 49,
          "start_time": 67.19,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a49",
          "scenario": 13,
          "activation_step": 50,
          "start_time": 68.68,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a50",
          "scenario": 13,
          "activation_step": 51,
          "start_time": 70.2,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a51",
          "scenario": 13,
          "activation_step": 52,
          "start_time": 71.63,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a52",
          "scenario": 13,
          "activation_step": 53,
          "start_time": 73.09,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a53",
          "scenario": 13,
          "activation_step": 54,
          "start_time": 74.56,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a54",
          "scenario": 13,
          "activation_step": 55,
          "start_time": 75.85,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a55",
          "scenario": 13,
          "activation_step": 56,
          "start_time": 76.85,
          "duration": 1.14,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s12_a56",
          "scenario": 13,
          "activation_step": 57,
          "start_time": 78.36,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a57",
          "scenario": 13,
          "activation_step": 58,
          "start_time": 79.68,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a58",
          "scenario": 13,
          "activation_step": 59,
          "start_time": 80.97,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a59",
          "scenario": 13,
          "activation_step": 60,
          "start_time": 82.18,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a60",
          "scenario": 13,
          "activation_step": 61,
          "start_time": 83.51,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a61",
          "scenario": 13,
          "activation_step": 62,
          "start_time": 84.9,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a62",
          "scenario": 13,
          "activation_step": 63,
          "start_time": 86.25,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a63",
          "scenario": 13,
          "activation_step": 64,
          "start_time": 87.49,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a64",
          "scenario": 13,
          "activation_step": 65,
          "start_time": 88.9,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a65",
          "scenario": 13,
          "activation_step": 66,
          "start_time": 90.35,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a66",
          "scenario": 13,
          "activation_step": 67,
          "start_time": 91.82,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a67",
          "scenario": 13,
          "activation_step": 68,
          "start_time": 92.92,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a68",
          "scenario": 13,
          "activation_step": 69,
          "start_time": 94.4,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a69",
          "scenario": 13,
          "activation_step": 70,
          "start_time": 95.78,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a70",
          "scenario": 13,
          "activation_step": 71,
          "start_time": 97.09,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a71",
          "scenario": 13,
          "activation_step": 72,
          "start_time": 98.48,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a72",
          "scenario": 13,
          "activation_step": 73,
          "start_time": 99.79,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a73",
          "scenario": 13,
          "activation_step": 74,
          "start_time": 101.08,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a74",
          "scenario": 13,
          "activation_step": 75,
          "start_time": 102.32,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a75",
          "scenario": 13,
          "activation_step": 76,
          "start_time": 103.89,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a76",
          "scenario": 13,
          "activation_step": 77,
          "start_time": 105.14,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a77",
          "scenario": 13,
          "activation_step": 78,
          "start_time": 106.27,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a78",
          "scenario": 13,
          "activation_step": 79,
          "start_time": 107.57,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a79",
          "scenario": 13,
          "activation_step": 80,
          "start_time": 108.96,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a80",
          "scenario": 13,
          "activation_step": 81,
          "start_time": 109.95,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s12_a81",
          "scenario": 13,
          "activation_step": 82,
          "start_time": 111.21,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a82",
          "scenario": 13,
          "activation_step": 83,
          "start_time": 112.69,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a83",
          "scenario": 13,
          "activation_step": 84,
          "start_time": 114.11,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a84",
          "scenario": 13,
          "activation_step": 85,
          "start_time": 115.73,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a85",
          "scenario": 13,
          "activation_step": 86,
          "start_time": 117.3,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a86",
          "scenario": 13,
          "activation_step": 87,
          "start_time": 118.4,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a87",
          "scenario": 13,
          "activation_step": 88,
          "start_time": 119.76,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a88",
          "scenario": 13,
          "activation_step": 89,
          "start_time": 121.05,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a89",
          "scenario": 13,
          "activation_step": 90,
          "start_time": 122.43,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a90",
          "scenario": 13,
          "activation_step": 91,
          "start_time": 123.74,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a91",
          "scenario": 13,
          "activation_step": 92,
          "start_time": 124.92,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a92",
          "scenario": 13,
          "activation_step": 93,
          "start_time": 125.93,
          "duration": 0.8,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s12_a93",
          "scenario": 13,
          "activation_step": 94,
          "start_time": 127.0,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a94",
          "scenario": 13,
          "activation_step": 95,
          "start_time": 128.41,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a95",
          "scenario": 13,
          "activation_step": 96,
          "start_time": 129.92,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a96",
          "scenario": 13,
          "activation_step": 97,
          "start_time": 131.51,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a97",
          "scenario": 13,
          "activation_step": 98,
          "start_time": 132.63,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a98",
          "scenario": 13,
          "activation_step": 99,
          "start_time": 134.14,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s12_a99",
          "scenario": 13,
          "activation_step": 100,
          "start_time": 135.33,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        }
      ]
    },
    {
      "scenario_id": 14,
      "conflict_count": 7,
      "total_duration": 132.39,
      "activations": [
        {
          "id": "s13_a0",
          "scenario": 14,
          "activation_step": 1,
          "start_time": 0.22,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a1",
          "scenario": 14,
          "activation_step": 2,
          "start_time": 1.29,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a2",
          "scenario": 14,
          "activation_step": 3,
          "start_time": 2.78,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a3",
          "scenario": 14,
          "activation_step": 4,
          "start_time": 4.21,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a4",
          "scenario": 14,
          "activation_step": 5,
          "start_time": 5.57,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a5",
          "scenario": 14,
          "activation_step": 6,
          "start_time": 6.98,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a6",
          "scenario": 14,
          "activation_step": 7,
          "start_time": 8.47,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a7",
          "scenario": 14,
          "activation_step": 8,
          "start_time": 9.93,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a8",
          "scenario": 14,
          "activation_step": 9,
          "start_time": 11.18,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a9",
          "scenario": 14,
          "activation_step": 10,
          "start_time": 12.49,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a10",
          "scenario": 14,
          "activation_step": 11,
          "start_time": 13.86,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a11",
          "scenario": 14,
          "activation_step": 12,
          "start_time": 15.15,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a12",
          "scenario": 14,
          "activation_step": 13,
          "start_time": 16.66,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a13",
          "scenario": 14,
          "activation_step": 14,
          "start_time": 17.63,
          "duration": 0.97,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s13_a14",
          "scenario": 14,
          "activation_step": 15,
          "start_time": 18.97,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a15",
          "scenario": 14,
          "activation_step": 16,
          "start_time": 20.55,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a16",
          "scenario": 14,
          "activation_step": 17,
          "start_time": 21.94,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a17",
          "scenario": 14,
          "activation_step": 18,
          "start_time": 23.21,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a18",
          "scenario": 14,
          "activation_step": 19,
          "start_time": 24.45,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a19",
          "scenario": 14,
          "activation_step": 20,
          "start_time": 25.73,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a20",
          "scenario": 14,
          "activation_step": 21,
          "start_time": 27.07,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a21",
          "scenario": 14,
          "activation_step": 22,
          "start_time": 28.54,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a22",
          "scenario": 14,
          "activation_step": 23,
          "start_time": 29.68,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a23",
          "scenario": 14,
          "activation_step": 24,
          "start_time": 31.19,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a24",
          "scenario": 14,
          "activation_step": 25,
          "start_time": 32.29,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a25",
          "scenario": 14,
          "activation_step": 26,
          "start_time": 33.51,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a26",
          "scenario": 14,
          "activation_step": 27,
          "start_time": 35.01,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a27",
          "scenario": 14,
          "activation_step": 28,
          "start_time": 36.34,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a28",
          "scenario": 14,
          "activation_step": 29,
          "start_time": 37.63,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a29",
          "scenario": 14,
          "activation_step": 30,
          "start_time": 38.74,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a30",
          "scenario": 14,
          "activation_step": 31,
          "start_time": 39.98,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a31",
          "scenario": 14,
          "activation_step": 32,
          "start_time": 40.82,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s13_a32",
          "scenario": 14,
          "activation_step": 33,
          "start_time": 41.99,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a33",
          "scenario": 14,
          "activation_step": 34,
          "start_time": 43.37,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a34",
          "scenario": 14,
          "activation_step": 35,
          "start_time": 44.7,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a35",
          "scenario": 14,
          "activation_step": 36,
          "start_time": 46.03,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a36",
          "scenario": 14,
          "activation_step": 37,
          "start_time": 47.12,
          "duration": 1.09,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s13_a37",
          "scenario": 14,
          "activation_step": 38,
          "start_time": 48.56,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a38",
          "scenario": 14,
          "activation_step": 39,
          "start_time": 49.82,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a39",
          "scenario": 14,
          "activation_step": 40,
          "start_time": 51.26,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a40",
          "scenario": 14,
          "activation_step": 41,
          "start_time": 52.24,
          "duration": 0.87,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s13_a41",
          "scenario": 14,
          "activation_step": 42,
          "start_time": 53.34,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a42",
          "scenario": 14,
          "activation_step": 43,
          "start_time": 54.42,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a43",
          "scenario": 14,
          "activation_step": 44,
          "start_time": 55.82,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a44",
          "scenario": 14,
          "activation_step": 45,
          "start_time": 57.0,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a45",
          "scenario": 14,
          "activation_step": 46,
          "start_time": 58.49,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a46",
          "scenario": 14,
          "activation_step": 47,
          "start_time": 59.79,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a47",
          "scenario": 14,
          "activation_step": 48,
          "start_time": 60.92,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a48",
          "scenario": 14,
          "activation_step": 49,
          "start_time": 62.2,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a49",
          "scenario": 14,
          "activation_step": 50,
          "start_time": 63.65,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a50",
          "scenario": 14,
          "activation_step": 51,
          "start_time": 64.7,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a51",
          "scenario": 14,
          "activation_step": 52,
          "start_time": 66.26,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a52",
          "scenario": 14,
          "activation_step": 53,
          "start_time": 67.85,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a53",
          "scenario": 14,
          "activation_step": 54,
          "start_time": 69.06,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a54",
          "scenario": 14,
          "activation_step": 55,
          "start_time": 70.24,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a55",
          "scenario": 14,
          "activation_step": 56,
          "start_time": 71.79,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a56",
          "scenario": 14,
          "activation_step": 57,
          "start_time": 73.1,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a57",
          "scenario": 14,
          "activation_step": 58,
          "start_time": 74.39,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a58",
          "scenario": 14,
          "activation_step": 59,
          "start_time": 75.77,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a59",
          "scenario": 14,
          "activation_step": 60,
          "start_time": 77.12,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a60",
          "scenario": 14,
          "activation_step": 61,
          "start_time": 78.49,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a61",
          "scenario": 14,
          "activation_step": 62,
          "start_time": 79.82,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a62",
          "scenario": 14,
          "activation_step": 63,
          "start_time": 81.15,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a63",
          "scenario": 14,
          "activation_step": 64,
          "start_time": 82.49,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a64",
          "scenario": 14,
          "activation_step": 65,
          "start_time": 83.88,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a65",
          "scenario": 14,
          "activation_step": 66,
          "start_time": 84.6,
          "duration": 0.91,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s13_a66",
          "scenario": 14,
          "activation_step": 67,
          "start_time": 85.81,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a67",
          "scenario": 14,
          "activation_step": 68,
          "start_time": 87.44,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a68",
          "scenario": 14,
          "activation_step": 69,
          "start_time": 88.73,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a69",
          "scenario": 14,
          "activation_step": 70,
          "start_time": 90.02,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a70",
          "scenario": 14,
          "activation_step": 71,
          "start_time": 91.36,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a71",
          "scenario": 14,
          "activation_step": 72,
          "start_time": 92.76,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a72",
          "scenario": 14,
          "activation_step": 73,
          "start_time": 94.14,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a73",
          "scenario": 14,
          "activation_step": 74,
          "start_time": 95.62,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a74",
          "scenario": 14,
          "activation_step": 75,
          "start_time": 97.01,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a75",
          "scenario": 14,
          "activation_step": 76,
          "start_time": 98.09,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a76",
          "scenario": 14,
          "activation_step": 77,
          "start_time": 99.66,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a77",
          "scenario": 14,
          "activation_step": 78,
          "start_time": 100.98,
          "duration": 1.04,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a78",
          "scenario": 14,
          "activation_step": 79,
          "start_time": 102.42,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a79",
          "scenario": 14,
          "activation_step": 80,
          "start_time": 103.93,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a80",
          "scenario": 14,
          "activation_step": 81,
          "start_time": 105.27,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a81",
          "scenario": 14,
          "activation_step": 82,
          "start_time": 106.67,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a82",
          "scenario": 14,
          "activation_step": 83,
          "start_time": 108.02,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a83",
          "scenario": 14,
          "activation_step": 84,
          "start_time": 109.27,
          "duration": 1.1,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a84",
          "scenario": 14,
          "activation_step": 85,
          "start_time": 110.81,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a85",
          "scenario": 14,
          "activation_step": 86,
          "start_time": 112.09,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a86",
          "scenario": 14,
          "activation_step": 87,
          "start_time": 113.53,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a87",
          "scenario": 14,
          "activation_step": 88,
          "start_time": 114.82,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a88",
          "scenario": 14,
          "activation_step": 89,
          "start_time": 116.28,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a89",
          "scenario": 14,
          "activation_step": 90,
          "start_time": 117.94,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a90",
          "scenario": 14,
          "activation_step": 91,
          "start_time": 119.22,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a91",
          "scenario": 14,
          "activation_step": 92,
          "start_time": 120.16,
          "duration": 0.88,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s13_a92",
          "scenario": 14,
          "activation_step": 93,
          "start_time": 121.33,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a93",
          "scenario": 14,
          "activation_step": 94,
          "start_time": 122.59,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a94",
          "scenario": 14,
          "activation_step": 95,
          "start_time": 123.85,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a95",
          "scenario": 14,
          "activation_step": 96,
          "start_time": 125.24,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a96",
          "scenario": 14,
          "activation_step": 97,
          "start_time": 126.43,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a97",
          "scenario": 14,
          "activation_step": 98,
          "start_time": 127.61,
          "duration": 0.99,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s13_a98",
          "scenario": 14,
          "activation_step": 99,
          "start_time": 128.97,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s13_a99",
          "scenario": 14,
          "activation_step": 100,
          "start_time": 130.39,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        }
      ]
    },
    {
      "scenario_id": 15,
      "conflict_count": 5,
      "total_duration": 134.62,
      "activations": [
        {
          "id": "s14_a0",
          "scenario": 15,
          "activation_step": 1,
          "start_time": 0.3,
          "duration": 0.88,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a1",
          "scenario": 15,
          "activation_step": 2,
          "start_time": 1.4,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a2",
          "scenario": 15,
          "activation_step": 3,
          "start_time": 2.73,
          "duration": 0.89,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a3",
          "scenario": 15,
          "activation_step": 4,
          "start_time": 3.86,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a4",
          "scenario": 15,
          "activation_step": 5,
          "start_time": 5.28,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a5",
          "scenario": 15,
          "activation_step": 6,
          "start_time": 6.38,
          "duration": 1.08,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s14_a6",
          "scenario": 15,
          "activation_step": 7,
          "start_time": 7.85,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a7",
          "scenario": 15,
          "activation_step": 8,
          "start_time": 9.02,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a8",
          "scenario": 15,
          "activation_step": 9,
          "start_time": 10.21,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a9",
          "scenario": 15,
          "activation_step": 10,
          "start_time": 11.82,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a10",
          "scenario": 15,
          "activation_step": 11,
          "start_time": 13.05,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a11",
          "scenario": 15,
          "activation_step": 12,
          "start_time": 14.58,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a12",
          "scenario": 15,
          "activation_step": 13,
          "start_time": 15.97,
          "duration": 0.82,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a13",
          "scenario": 15,
          "activation_step": 14,
          "start_time": 17.04,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a14",
          "scenario": 15,
          "activation_step": 15,
          "start_time": 18.16,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a15",
          "scenario": 15,
          "activation_step": 16,
          "start_time": 19.68,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a16",
          "scenario": 15,
          "activation_step": 17,
          "start_time": 21.07,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a17",
          "scenario": 15,
          "activation_step": 18,
          "start_time": 22.48,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a18",
          "scenario": 15,
          "activation_step": 19,
          "start_time": 23.93,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a19",
          "scenario": 15,
          "activation_step": 20,
          "start_time": 25.12,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a20",
          "scenario": 15,
          "activation_step": 21,
          "start_time": 26.18,
          "duration": 1.13,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s14_a21",
          "scenario": 15,
          "activation_step": 22,
          "start_time": 27.57,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a22",
          "scenario": 15,
          "activation_step": 23,
          "start_time": 28.94,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a23",
          "scenario": 15,
          "activation_step": 24,
          "start_time": 30.4,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a24",
          "scenario": 15,
          "activation_step": 25,
          "start_time": 31.73,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a25",
          "scenario": 15,
          "activation_step": 26,
          "start_time": 33.28,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a26",
          "scenario": 15,
          "activation_step": 27,
          "start_time": 34.44,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a27",
          "scenario": 15,
          "activation_step": 28,
          "start_time": 35.72,
          "duration": 0.85,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a28",
          "scenario": 15,
          "activation_step": 29,
          "start_time": 36.95,
          "duration": 1.11,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a29",
          "scenario": 15,
          "activation_step": 30,
          "start_time": 38.33,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a30",
          "scenario": 15,
          "activation_step": 31,
          "start_time": 39.78,
          "duration": 1.18,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a31",
          "scenario": 15,
          "activation_step": 32,
          "start_time": 41.18,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a32",
          "scenario": 15,
          "activation_step": 33,
          "start_time": 42.68,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a33",
          "scenario": 15,
          "activation_step": 34,
          "start_time": 43.96,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a34",
          "scenario": 15,
          "activation_step": 35,
          "start_time": 45.46,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a35",
          "scenario": 15,
          "activation_step": 36,
          "start_time": 46.74,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a36",
          "scenario": 15,
          "activation_step": 37,
          "start_time": 48.15,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a37",
          "scenario": 15,
          "activation_step": 38,
          "start_time": 49.26,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a38",
          "scenario": 15,
          "activation_step": 39,
          "start_time": 50.51,
          "duration": 0.97,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a39",
          "scenario": 15,
          "activation_step": 40,
          "start_time": 51.81,
          "duration": 1.08,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a40",
          "scenario": 15,
          "activation_step": 41,
          "start_time": 53.24,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a41",
          "scenario": 15,
          "activation_step": 42,
          "start_time": 54.53,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a42",
          "scenario": 15,
          "activation_step": 43,
          "start_time": 56.11,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a43",
          "scenario": 15,
          "activation_step": 44,
          "start_time": 57.44,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a44",
          "scenario": 15,
          "activation_step": 45,
          "start_time": 58.53,
          "duration": 0.83,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s14_a45",
          "scenario": 15,
          "activation_step": 46,
          "start_time": 59.81,
          "duration": 1.02,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a46",
          "scenario": 15,
          "activation_step": 47,
          "start_time": 61.26,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a47",
          "scenario": 15,
          "activation_step": 48,
          "start_time": 62.71,
          "duration": 0.9,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a48",
          "scenario": 15,
          "activation_step": 49,
          "start_time": 63.96,
          "duration": 0.87,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a49",
          "scenario": 15,
          "activation_step": 50,
          "start_time": 65.29,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a50",
          "scenario": 15,
          "activation_step": 51,
          "start_time": 66.55,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a51",
          "scenario": 15,
          "activation_step": 52,
          "start_time": 67.83,
          "duration": 1.05,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a52",
          "scenario": 15,
          "activation_step": 53,
          "start_time": 69.38,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a53",
          "scenario": 15,
          "activation_step": 54,
          "start_time": 70.44,
          "duration": 0.93,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s14_a54",
          "scenario": 15,
          "activation_step": 55,
          "start_time": 71.73,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a55",
          "scenario": 15,
          "activation_step": 56,
          "start_time": 73.16,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a56",
          "scenario": 15,
          "activation_step": 57,
          "start_time": 74.2,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a57",
          "scenario": 15,
          "activation_step": 58,
          "start_time": 75.68,
          "duration": 1.06,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a58",
          "scenario": 15,
          "activation_step": 59,
          "start_time": 77.05,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a59",
          "scenario": 15,
          "activation_step": 60,
          "start_time": 78.47,
          "duration": 1.17,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a60",
          "scenario": 15,
          "activation_step": 61,
          "start_time": 79.85,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a61",
          "scenario": 15,
          "activation_step": 62,
          "start_time": 81.44,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a62",
          "scenario": 15,
          "activation_step": 63,
          "start_time": 82.71,
          "duration": 1.12,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a63",
          "scenario": 15,
          "activation_step": 64,
          "start_time": 84.3,
          "duration": 1.14,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a64",
          "scenario": 15,
          "activation_step": 65,
          "start_time": 85.84,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a65",
          "scenario": 15,
          "activation_step": 66,
          "start_time": 87.28,
          "duration": 1.07,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a66",
          "scenario": 15,
          "activation_step": 67,
          "start_time": 88.84,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a67",
          "scenario": 15,
          "activation_step": 68,
          "start_time": 90.48,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a68",
          "scenario": 15,
          "activation_step": 69,
          "start_time": 91.88,
          "duration": 1.16,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a69",
          "scenario": 15,
          "activation_step": 70,
          "start_time": 93.51,
          "duration": 0.98,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a70",
          "scenario": 15,
          "activation_step": 71,
          "start_time": 94.97,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a71",
          "scenario": 15,
          "activation_step": 72,
          "start_time": 96.47,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a72",
          "scenario": 15,
          "activation_step": 73,
          "start_time": 97.66,
          "duration": 0.93,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a73",
          "scenario": 15,
          "activation_step": 74,
          "start_time": 98.89,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a74",
          "scenario": 15,
          "activation_step": 75,
          "start_time": 100.15,
          "duration": 1.15,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a75",
          "scenario": 15,
          "activation_step": 76,
          "start_time": 101.74,
          "duration": 0.92,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a76",
          "scenario": 15,
          "activation_step": 77,
          "start_time": 102.96,
          "duration": 0.83,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a77",
          "scenario": 15,
          "activation_step": 78,
          "start_time": 104.0,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a78",
          "scenario": 15,
          "activation_step": 79,
          "start_time": 105.26,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a79",
          "scenario": 15,
          "activation_step": 80,
          "start_time": 106.45,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a80",
          "scenario": 15,
          "activation_step": 81,
          "start_time": 107.71,
          "duration": 0.95,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a81",
          "scenario": 15,
          "activation_step": 82,
          "start_time": 108.99,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a82",
          "scenario": 15,
          "activation_step": 83,
          "start_time": 110.31,
          "duration": 1.19,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a83",
          "scenario": 15,
          "activation_step": 84,
          "start_time": 111.75,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a84",
          "scenario": 15,
          "activation_step": 85,
          "start_time": 113.17,
          "duration": 0.94,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a85",
          "scenario": 15,
          "activation_step": 86,
          "start_time": 114.59,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a86",
          "scenario": 15,
          "activation_step": 87,
          "start_time": 115.84,
          "duration": 0.91,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a87",
          "scenario": 15,
          "activation_step": 88,
          "start_time": 117.02,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a88",
          "scenario": 15,
          "activation_step": 89,
          "start_time": 118.41,
          "duration": 1.13,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a89",
          "scenario": 15,
          "activation_step": 90,
          "start_time": 119.49,
          "duration": 1.15,
          "is_conflict": true,
          "type": "CONFLICT",
          "reason": "Minor Sequencing Delay"
        },
        {
          "id": "s14_a90",
          "scenario": 15,
          "activation_step": 91,
          "start_time": 120.89,
          "duration": 0.84,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a91",
          "scenario": 15,
          "activation_step": 92,
          "start_time": 122.02,
          "duration": 0.81,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a92",
          "scenario": 15,
          "activation_step": 93,
          "start_time": 123.06,
          "duration": 1.0,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a93",
          "scenario": 15,
          "activation_step": 94,
          "start_time": 124.53,
          "duration": 0.99,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a94",
          "scenario": 15,
          "activation_step": 95,
          "start_time": 125.73,
          "duration": 0.96,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a95",
          "scenario": 15,
          "activation_step": 96,
          "start_time": 127.11,
          "duration": 1.03,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a96",
          "scenario": 15,
          "activation_step": 97,
          "start_time": 128.48,
          "duration": 0.86,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a97",
          "scenario": 15,
          "activation_step": 98,
          "start_time": 129.8,
          "duration": 1.01,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a98",
          "scenario": 15,
          "activation_step": 99,
          "start_time": 131.11,
          "duration": 1.09,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        },
        {
          "id": "s14_a99",
          "scenario": 15,
          "activation_step": 100,
          "start_time": 132.62,
          "duration": 1.2,
          "is_conflict": false,
          "type": "OPTIMAL",
          "reason": "Sequenced by ASANA (INFEROBIA Verified)"
        }
      ]
    }
  ],
  "meta": {
    "description": "Simulation data representing ANF activations. Baseline shows chaotic/overlapping scheduling. NCF shows ASANA-governed sequential scheduling.",
    "source": "Thesis Chapter 6.4",
    "scenarios": 15,
    "activations_per_scenario": 100
  }
}